/* XRAY DEMO: the plugin dev's app (app/main.js + engine/*) bundled by esbuild with theme-build patches marked 'theme build' (scratchpad xray_demo_build.py, 2026-10-20). ES module. Do not hand-edit: re-run the build. */
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __publicField = (obj, key2, value) => __defNormalProp(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);

// xray-demo-stage/src/app/assets.js
var BASE = new URL("../assets/", import.meta.url);
var images = {};
function load(name) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.decoding = "async";
    img.onload = () => {
      images[name] = img;
      resolve(img);
    };
    img.onerror = () => reject(new Error(`could not load ${name}`));
    img.src = window.XRDEMO && window.XRDEMO.assets && window.XRDEMO.assets["ui/" + name] || new URL(`ui/${name}`, BASE).href;
  });
}
async function loadAssets() {
  const names = ["plate.jpg", "logo.png"];
  for (let i = 0; i < 8; ++i) names.push(`key_pressed_${i}.png`, `light_${i}.png`, `light_pressed_${i}.png`);
  const faces = [["Inter-Regular.ttf", 400], ["Inter-Medium.ttf", 500], ["Inter-SemiBold.ttf", 600]].map(async ([file, weight]) => {
    try {
      if (window.XRDEMO && window.XRDEMO.googleFonts) {
        await document.fonts.load(`${weight} 14px Inter`);
        return;
      }
      const f2 = new FontFace("Inter", `url(${new URL(`fonts/${file}`, BASE).href})`, { weight: String(weight) });
      document.fonts.add(await f2.load());
    } catch {
    }
  });
  await Promise.all([...names.map(load), ...faces]);
}
var plateImage = () => images["plate.jpg"];
var logoImage = () => images["logo.png"];
var keyPressedImage = (i) => images[`key_pressed_${i}.png`];
var keyLightImage = (i, onPressedKey) => images[onPressedKey ? `light_pressed_${i}.png` : `light_${i}.png`];

// xray-demo-stage/src/engine/registry.js
var MODULES = ["drive", "lofi", "chop", "vibe", "grain", "delay", "scan", "space"];
var TITLES = ["DRIVE", "LOFI", "CHOP", "VIBE", "GRAIN", "DELAY", "SCAN", "SPACE"];
var DEFAULT_ORDER = ["drive", "lofi", "chop", "vibe", "scan", "grain", "delay", "space"];
var mp = {
  drive: { on: 0, mix: 1, model: 2, gain: 3, tone: 4, bias: 5, character: 6, headroom: 7, boost: 8, match: 9, count: 10 },
  lofi: { on: 0, mix: 1, mode: 2, type: 3, crush: 4, flutter: 5, wow: 6, dropouts: 7, wear: 8, noise: 9, noiseLevel: 10, duck: 11, tilt: 12, bits: 13, rate: 14, count: 15 },
  chop: { on: 0, mix: 1, size: 2, slice: 3, repeat: 4, stutter: 5, shuffle: 6, reverse: 7, pitchUp: 8, pitchDown: 9, pitchAmt: 10, glide: 11, smooth: 12, stretch: 13, chaos: 14, target: 15, seed: 16, lock: 17, count: 18 },
  vibe: {
    on: 0,
    chOn: 1,
    chMix: 2,
    chMode: 3,
    chDepth: 4,
    chWidth: 5,
    chRate: 6,
    chColor: 7,
    chMotion: 8,
    chDelay: 9,
    chFeedback: 10,
    phOn: 11,
    phMix: 12,
    phMode: 13,
    phDepth: 14,
    phRate: 15,
    phFeedback: 16,
    phSync: 17,
    phDiv: 18,
    count: 19
  },
  grain: { on: 0, mix: 1, mode: 2, size: 3, density: 4, position: 5, pitch: 6, jitter: 7, reverse: 8, feedback: 9, filter: 10, spread: 11, count: 12 },
  delay: {
    on: 0,
    anOn: 1,
    anMix: 2,
    anSync: 3,
    anDiv: 4,
    anTime: 5,
    anFeedback: 6,
    anMod: 7,
    anRate: 8,
    anDrive: 9,
    anFilter: 10,
    anStereo: 11,
    piOn: 12,
    piMix: 13,
    piSync: 14,
    piDiv: 15,
    piTime: 16,
    piFeedback: 17,
    piIntA: 18,
    piIntB: 19,
    piGlide: 20,
    piSpread: 21,
    piFilter: 22,
    count: 23
  },
  scan: { on: 0, mix: 1, mode: 2, shape: 3, strength: 4, phase: 5, smooth: 6, shift: 7, invert: 8, frame: 9, count: 10 },
  space: { on: 0, mix: 1, type: 2, size: 3, width: 4, damp: 5, predelay: 6, tilt: 7, filter: 8, count: 9 }
};
var lfoIdx = { rate: 0, sync: 1, div: 2, shape: 3, warp: 4, asym: 5, slew: 6, polarity: 7, mod1: 8, mod2: 9, count: 10 };
var U = {
  none: "none",
  pct: "pct",
  bipolarPct: "bipolarPct",
  db: "db",
  hz: "hz",
  ms: "ms",
  sec: "sec",
  semis: "semis",
  filter: "filter",
  rate: "rate",
  bits: "bits",
  khz: "khz",
  integer: "integer"
};
function F(id, name, label, min, max, def, unit, centre2 = 0, group = 0) {
  return { id, name, label, kind: "float", min, max, def, centre: centre2, unit, group, cell: true, showIf: -1, showIfValue: 1, choices: null };
}
function C(id, name, label, choices, def, group = 0) {
  return { id, name, label, kind: "choice", min: 0, max: choices.length - 1, def, centre: 0, unit: U.none, group, cell: true, showIf: -1, showIfValue: 1, choices };
}
function B(id, name, label, def, group = 0, cell = true) {
  return { id, name, label, kind: "bool", min: 0, max: 1, def: def ? 1 : 0, centre: 0, unit: U.none, group, cell, showIf: -1, showIfValue: 1, choices: null };
}
function I(id, name, label, min, max, def, unit, group = 0) {
  return { id, name, label, kind: "int", min, max, def, centre: 0, unit, group, cell: true, showIf: -1, showIfValue: 1, choices: null };
}
var hidden = (p) => ({ ...p, cell: false });
var showIf = (p, param, value) => ({ ...p, showIf: param, showIfValue: value });
function page(name, group, enable, mix, x, y, xl, yl) {
  return { name, group, enableParam: enable, mixParam: mix, mixLabel: "mix", xParam: x, yParam: y, syncParam: -1, yParamSynced: -1, xLabel: xl, yLabel: yl };
}
var DELAY_DIV_NAMES = ["1/32", "1/16T", "1/16", "1/16D", "1/8T", "1/8", "1/8D", "1/4T", "1/4", "1/4D", "1/2", "1 bar"];
var DELAY_DIV_BEATS = [0.125, 1 / 6, 0.25, 0.375, 1 / 3, 0.5, 0.75, 2 / 3, 1, 1.5, 2, 4];
var LFO_SHAPES = ["sine", "triangle", "saw", "reverse saw", "square", "random", "stairs", "drift"];
var LFO_DIV_BEATS = [16, 8, 4, 2, 1, 0.5, 0.25, 4 / 3, 2 / 3, 1 / 3, 1.5, 0.75];
var RATE_DIVS = ["4 bars", "2 bars", "1 bar", "1/2", "1/4", "1/8", "1/16", "1/2T", "1/4T", "1/8T", "1/4D", "1/8D"];
function build() {
  const defs = [];
  {
    const P3 = mp.drive;
    defs.push({ id: "drive", mixParam: P3.mix, linearMix: true, params: [
      B("drive_on", "Drive On", "on", true, 0, false),
      hidden(F("drive_mix", "Drive Mix", "mix", 0, 1, 1, U.pct)),
      C("drive_model", "Drive Model", "model", ["tube", "tape", "opamp", "fold"], 0),
      F("drive_gain", "Drive Gain", "gain", 0, 36, 12, U.db),
      F("drive_tone", "Drive Tone", "tone", -1, 1, 0, U.bipolarPct),
      F("drive_bias", "Drive Bias", "bias", -1, 1, 0, U.bipolarPct),
      F("drive_character", "Drive Character", "character", 0, 1, 0.2, U.pct),
      F("drive_headroom", "Drive Headroom", "headroom", 0, 1, 1, U.pct),
      B("drive_boost", "Drive Boost", "boost", false),
      B("drive_match", "Drive Auto Gain", "auto gain", true)
    ], pages: [page("", 0, -1, P3.mix, P3.tone, P3.gain, "tone", "gain")] });
  }
  {
    const P3 = mp.lofi;
    const p = page("", 0, -1, P3.mix, P3.flutter, P3.crush, "flutter", "crush");
    p.mixLabel = "depth";
    defs.push({ id: "lofi", mixParam: P3.mix, linearMix: true, params: [
      B("lofi_on", "Lofi On", "on", false, 0, false),
      hidden(F("lofi_mix", "Lofi Depth", "depth", 0, 1, 1, U.pct)),
      C("lofi_mode", "Lofi Mode", "mode", ["sample", "tape", "digital"], 1),
      C("lofi_type", "Lofi Type", "type", ["clean", "worn", "warped", "broken", "ancient"], 1),
      F("lofi_crush", "Lofi Crush", "crush", 0, 1, 0.35, U.pct),
      F("lofi_flutter", "Lofi Flutter", "flutter", 0, 1, 0.35, U.pct),
      F("lofi_wow", "Lofi Wow", "wow", 0, 1, 0.3, U.pct),
      F("lofi_dropouts", "Lofi Dropouts", "dropouts", 0, 1, 0.1, U.pct),
      F("lofi_wear", "Lofi Wear", "wear", 0, 1, 0.3, U.pct),
      C("lofi_noise", "Lofi Noise", "noise", ["hiss", "crackle", "hum", "rain", "room"], 0),
      F("lofi_noise_level", "Lofi Noise Level", "noise lvl", 0, 1, 0.25, U.pct),
      B("lofi_duck", "Lofi Noise Duck", "duck", false),
      F("lofi_tilt", "Lofi EQ Tilt", "eq tilt", -1, 1, 0, U.bipolarPct),
      F("lofi_bits", "Lofi Bit Depth", "bit rate", 3, 24, 12, U.bits),
      F("lofi_rate", "Lofi Sample Rate", "smpl rate", 2e3, 48e3, 26e3, U.khz, 16e3)
    ], pages: [p] });
  }
  {
    const P3 = mp.chop;
    defs.push({ id: "chop", mixParam: P3.mix, linearMix: true, params: [
      B("chop_on", "Chop On", "on", false, 0, false),
      hidden(F("chop_mix", "Chop Mix", "mix", 0, 1, 1, U.pct)),
      C("chop_size", "Chop Size", "size", ["1/2 bar", "1 bar", "2 bars"], 1),
      C("chop_slice", "Chop Slice", "slice", ["1/8", "1/16", "1/32"], 1),
      F("chop_repeat", "Chop Repeat", "repeat", 0, 1, 0.3, U.pct),
      C("chop_stutter", "Chop Stutter", "stutter", ["off", "1/2", "1/4", "1/8"], 0),
      F("chop_shuffle", "Chop Shuffle", "shuffle", 0, 1, 0.3, U.pct),
      F("chop_reverse", "Chop Reverse", "reverse", 0, 1, 0.25, U.pct),
      B("chop_pitch_up", "Chop Pitch Up", "+12", false),
      B("chop_pitch_down", "Chop Pitch Down", "-12", true),
      F("chop_pitch_amt", "Chop Pitch Amount", "pitch amt", 0, 1, 0.2, U.pct),
      F("chop_glide", "Chop Glide", "glide", 0, 1, 0.15, U.pct),
      F("chop_smooth", "Chop Smooth", "smooth", 0, 1, 0.2, U.pct),
      F("chop_stretch", "Chop Stretch", "stretch", 0, 1, 0, U.pct),
      F("chop_chaos", "Chop Chaos", "chaos", 0, 1, 0, U.pct),
      C("chop_target", "Chop Target", "target", ["full", "low", "mid", "high"], 0),
      I("chop_seed", "Chop Seed", "seed", 1, 9999, 1337, U.integer),
      B("chop_lock", "Chop Lock", "lock", true)
    ], pages: [page("", 0, -1, P3.mix, -1, -1, "", "")] });
  }
  {
    const P3 = mp.vibe;
    const params = [
      B("vibe_on", "Vibe On", "on", false, 0, false),
      B("vibe_ch_on", "Chorus On", "on", true, 1, false),
      hidden(F("vibe_ch_mix", "Chorus Mix", "mix", 0, 1, 0.6, U.pct, 0, 1)),
      C("vibe_ch_mode", "Chorus Mode", "mode", ["clean chorus", "lush chorus", "flanger", "vintage"], 0, 1),
      F("vibe_ch_depth", "Chorus Depth", "depth", 0, 1, 0.55, U.pct, 0, 1),
      F("vibe_ch_width", "Chorus Width", "width", 0, 1, 0.8, U.pct, 0, 1),
      F("vibe_ch_rate", "Chorus Rate", "rate", 0.05, 10, 0.8, U.rate, 1, 1),
      F("vibe_ch_color", "Chorus Color", "color", -1, 1, 0, U.bipolarPct, 0, 1),
      F("vibe_ch_motion", "Chorus Motion", "motion", 0, 1, 0.2, U.pct, 0, 1),
      F("vibe_ch_delay", "Chorus Delay", "delay", 0.5, 25, 7, U.ms, 6, 1),
      F("vibe_ch_feedback", "Chorus Feedback", "feedback", 0, 0.95, 0, U.pct, 0, 1),
      B("vibe_ph_on", "Phaser On", "on", false, 2, false),
      hidden(F("vibe_ph_mix", "Phaser Mix", "mix", 0, 1, 0.6, U.pct, 0, 2)),
      C("vibe_ph_mode", "Phaser Mode", "mode", ["smooth", "deep", "vintage", "ring"], 0, 2),
      F("vibe_ph_depth", "Phaser Depth", "depth", 0, 1, 0.75, U.pct, 0, 2),
      F("vibe_ph_rate", "Phaser Rate", "rate", 0.05, 40, 0.5, U.rate, 1.5, 2),
      F("vibe_ph_feedback", "Phaser Feedback", "feedback", -0.95, 0.95, 0.35, U.bipolarPct, 0, 2),
      B("vibe_ph_sync", "Phaser Sync", "sync", false, 2),
      C("vibe_ph_div", "Phaser Division", "rate", RATE_DIVS, 2, 2)
    ];
    params[P3.phRate] = showIf(params[P3.phRate], P3.phSync, 0);
    params[P3.phDiv] = showIf(params[P3.phDiv], P3.phSync, 1);
    defs.push({ id: "vibe", mixParam: -1, linearMix: false, params, pages: [
      page("CHORUS", 1, P3.chOn, P3.chMix, P3.chWidth, P3.chDepth, "width", "depth"),
      page("PHASER", 2, P3.phOn, P3.phMix, P3.phRate, P3.phDepth, "rate", "depth")
    ] });
  }
  {
    const P3 = mp.grain;
    defs.push({ id: "grain", mixParam: P3.mix, linearMix: false, params: [
      B("grain_on", "Grain On", "on", false, 0, false),
      hidden(F("grain_mix", "Grain Mix", "mix", 0, 1, 0.4, U.pct)),
      C("grain_mode", "Grain Mode", "mode", ["classic", "crystal"], 0),
      F("grain_size", "Grain Size", "grain size", 10, 500, 90, U.ms, 80),
      F("grain_density", "Grain Density", "density", 0, 1, 0.5, U.pct),
      F("grain_position", "Grain Position", "position", 0, 1, 0.2, U.pct),
      C("grain_pitch", "Grain Pitch", "pitch", ["-2 oct", "-1 oct", "-5th", "0", "+5th", "+1 oct", "+2 oct"], 3),
      F("grain_jitter", "Grain Jitter", "jitter", 0, 1, 0.35, U.pct),
      F("grain_reverse", "Grain Reverse", "reverse", 0, 1, 0, U.pct),
      F("grain_feedback", "Grain Feedback", "feedback", 0, 0.9, 0.2, U.pct),
      F("grain_filter", "Grain Filter", "lp/hp", -1, 1, 0, U.filter),
      F("grain_spread", "Grain Spread", "spread", 0, 1, 0.6, U.pct)
    ], pages: [page("", 0, -1, P3.mix, P3.size, P3.density, "grain size", "density")] });
  }
  {
    const P3 = mp.delay;
    const params = [
      B("delay_on", "Delay On", "on", true, 0, false),
      B("delay_an_on", "Analog Delay On", "on", true, 1, false),
      hidden(F("delay_an_mix", "Analog Delay Mix", "mix", 0, 1, 0.3, U.pct, 0, 1)),
      B("delay_an_sync", "Analog Delay Sync", "sync", true, 1),
      C("delay_an_div", "Analog Delay Division", "time", DELAY_DIV_NAMES, 6, 1),
      F("delay_an_time", "Analog Delay Time", "time", 1, 2e3, 375, U.ms, 300, 1),
      F("delay_an_feedback", "Analog Delay Feedback", "feedback", 0, 1, 0.45, U.pct, 0, 1),
      F("delay_an_mod", "Analog Delay Mod Depth", "mod depth", 0, 1, 0.25, U.pct, 0, 1),
      F("delay_an_rate", "Analog Delay Mod Rate", "mod rate", 0.05, 8, 0.5, U.rate, 0.8, 1),
      F("delay_an_drive", "Analog Delay Drive", "drive", 0, 24, 3, U.db, 0, 1),
      F("delay_an_filter", "Analog Delay Filter", "lp/hp", -1, 1, -0.15, U.filter, 0, 1),
      C("delay_an_stereo", "Analog Delay Stereo", "stereo", ["mono", "wide", "ping-pong"], 1, 1),
      B("delay_pi_on", "Pitch Delay On", "on", false, 2, false),
      hidden(F("delay_pi_mix", "Pitch Delay Mix", "mix", 0, 1, 0.35, U.pct, 0, 2)),
      B("delay_pi_sync", "Pitch Delay Sync", "sync", true, 2),
      C("delay_pi_div", "Pitch Delay Division", "time", DELAY_DIV_NAMES, 8, 2),
      F("delay_pi_time", "Pitch Delay Time", "time", 1, 2e3, 400, U.ms, 300, 2),
      F("delay_pi_feedback", "Pitch Delay Feedback", "feedback", 0, 0.95, 0.5, U.pct, 0, 2),
      I("delay_pi_int_a", "Pitch Delay Interval L", "interval L", -12, 12, 12, U.semis, 2),
      I("delay_pi_int_b", "Pitch Delay Interval R", "interval R", -12, 12, 7, U.semis, 2),
      F("delay_pi_glide", "Pitch Delay Glide", "glide", 0, 1, 0.2, U.pct, 0, 2),
      F("delay_pi_spread", "Pitch Delay Spread", "spread", 0, 1, 0.5, U.pct, 0, 2),
      F("delay_pi_filter", "Pitch Delay Filter", "lp/hp", -1, 1, 0, U.filter, 0, 2)
    ];
    params[P3.anDiv] = showIf(params[P3.anDiv], P3.anSync, 1);
    params[P3.anTime] = showIf(params[P3.anTime], P3.anSync, 0);
    params[P3.piDiv] = showIf(params[P3.piDiv], P3.piSync, 1);
    params[P3.piTime] = showIf(params[P3.piTime], P3.piSync, 0);
    const analog = page("ANALOG", 1, P3.anOn, P3.anMix, P3.anFeedback, P3.anTime, "feedback", "time");
    analog.syncParam = P3.anSync;
    analog.yParamSynced = P3.anDiv;
    const pitch = page("PITCH", 2, P3.piOn, P3.piMix, P3.piFeedback, P3.piTime, "feedback", "time");
    pitch.syncParam = P3.piSync;
    pitch.yParamSynced = P3.piDiv;
    defs.push({ id: "delay", mixParam: -1, linearMix: false, params, pages: [analog, pitch] });
  }
  {
    const P3 = mp.scan;
    defs.push({ id: "scan", mixParam: P3.mix, linearMix: true, params: [
      B("scan_on", "Scan On", "on", false, 0, false),
      hidden(F("scan_mix", "Scan Mix", "mix", 0, 1, 1, U.pct)),
      C("scan_mode", "Scan Mode", "mode", ["filter", "smear", "gate"], 0),
      C("scan_shape", "Scan Shape", "shape", ["comb 2", "comb 4", "comb 8", "saw", "ramp", "sine", "pulse", "steps", "draw"], 1),
      F("scan_strength", "Scan Strength", "strength", 0, 1, 0.85, U.pct),
      F("scan_phase", "Scan Phase", "phase", 0, 1, 0, U.pct),
      F("scan_smooth", "Scan Smooth", "smooth", 0, 1, 0.25, U.pct),
      F("scan_shift", "Scan Shift", "shift", -1, 1, 0, U.bipolarPct),
      B("scan_invert", "Scan Invert", "invert", false),
      C("scan_frame", "Scan Frame", "frame", ["512", "1024", "2048", "4096"], 2)
    ], pages: [page("", 0, -1, P3.mix, -1, -1, "", "")] });
  }
  {
    const P3 = mp.space;
    defs.push({ id: "space", mixParam: P3.mix, linearMix: false, params: [
      B("space_on", "Space On", "on", true, 0, false),
      hidden(F("space_mix", "Space Mix", "mix", 0, 1, 0.22, U.pct)),
      C("space_type", "Space Type", "type", ["room", "hall", "plate", "spring", "chamber", "cathedral"], 1),
      F("space_size", "Space Size", "size", 0.2, 20, 2.8, U.sec, 2.5),
      F("space_width", "Space Width", "width", 0, 2, 1.1, U.pct),
      F("space_damp", "Space Damp", "damp", 0, 1, 0.45, U.pct),
      F("space_predelay", "Space Predelay", "predelay", 0, 250, 18, U.ms, 40),
      F("space_tilt", "Space EQ Tilt", "eq tilt", -1, 1, 0, U.bipolarPct),
      F("space_filter", "Space Filter", "lp/hp", -1, 1, 0.15, U.filter)
    ], pages: [page("", 0, -1, P3.mix, P3.width, P3.mix, "width", "mix")] });
  }
  return defs;
}
var MODULE_DEFS = build();
var moduleDef = (m) => MODULE_DEFS[typeof m === "number" ? m : MODULES.indexOf(m)];
function buildLfo() {
  return MODULES.map((k) => {
    const t = k.charAt(0).toUpperCase() + k.slice(1);
    const mk = (p, suffix, name) => ({ ...p, id: `${k}_lfo_${suffix}`, name: `${t} LFO ${name}` });
    return [
      mk(F("", "", "rate", 0.02, 20, 1, U.rate, 1), "rate", "Rate"),
      mk(B("", "", "sync", false), "sync", "Sync"),
      mk(C("", "", "rate", RATE_DIVS, 2), "div", "Division"),
      mk(C("", "", "shape", LFO_SHAPES, 0), "shape", "Shape"),
      mk(F("", "", "phase warp", 0, 1, 0, U.pct), "warp", "Phase Warp"),
      mk(F("", "", "asymmetry", -1, 1, 0, U.bipolarPct), "asym", "Asymmetry"),
      mk(F("", "", "slew", 0, 1, 0, U.pct), "slew", "Slew"),
      mk(C("", "", "polarity", ["bi", "uni"], 0), "polarity", "Polarity"),
      mk(F("", "", "mod 1", -1, 1, 0.5, U.bipolarPct), "mod1", "Mod 1"),
      mk(F("", "", "mod 2", -1, 1, 0, U.bipolarPct), "mod2", "Mod 2")
    ];
  });
}
var LFO_DEFS = buildLfo();
var GLOBAL_DEFS = [
  F("in_gain", "Input Gain", "input", -24, 24, 0, U.db),
  F("out_gain", "Output Gain", "gain out", -24, 12, 0, U.db),
  F("mix", "Global Mix", "mix", 0, 1, 1, U.pct),
  F("filter", "Global Filter", "filter", -1, 1, 0, U.filter),
  F("width", "Global Width", "width", 0, 2, 1, U.pct),
  I("pitch", "Global Pitch", "pitch", -12, 12, 0, U.semis),
  F("pitch_mix", "Pitch Mix", "mix", 0, 1, 1, U.pct),
  B("pitch_lock", "Pitch Lock", "lock", false),
  B("glue", "Master Glue", "master glue", false)
];
var ALL_PARAMS = /* @__PURE__ */ new Map();
for (const p of GLOBAL_DEFS) ALL_PARAMS.set(p.id, p);
MODULE_DEFS.forEach((m) => m.params.forEach((p) => ALL_PARAMS.set(p.id, p)));
LFO_DEFS.forEach((l) => l.forEach((p) => ALL_PARAMS.set(p.id, p)));
function skewOf(p) {
  return p.centre > 0 ? Math.log(0.5) / Math.log((p.centre - p.min) / (p.max - p.min)) : 1;
}
function toNorm(p, v) {
  if (p.kind === "bool") return v > 0.5 ? 1 : 0;
  let x = (v - p.min) / (p.max - p.min);
  x = Math.max(0, Math.min(1, x));
  if (p.kind === "float" && p.centre > 0) x = Math.pow(x, skewOf(p));
  return x;
}
function fromNorm(p, n) {
  n = Math.max(0, Math.min(1, n));
  if (p.kind === "bool") return n > 0.5 ? 1 : 0;
  if (p.kind === "float" && p.centre > 0 && n > 0) n = Math.exp(Math.log(n) / skewOf(p));
  const v = p.min + (p.max - p.min) * n;
  return p.kind === "float" ? v : Math.round(v);
}
var FILTER_DEAD_ZONE = 0.01;
var filterLpHz = (v) => 2e4 * Math.pow(150 / 2e4, Math.abs(v));
var filterHpHz = (v) => 15 * Math.pow(4e3 / 15, Math.abs(v));
var fixed = (v, d) => d === 0 ? String(Math.round(v)) : v.toFixed(d);
function formatValue(unit, v) {
  switch (unit) {
    case U.pct:
      return `${Math.round(v * 100)}%`;
    case U.bipolarPct: {
      const p = Math.round(v * 100);
      return `${p > 0 ? "+" : ""}${p}%`;
    }
    case U.db:
      return `${v > 0.05 ? "+" : ""}${fixed(v, Math.abs(v) < 10 ? 1 : 0)} dB`;
    case U.hz:
      return v < 1e3 ? `${Math.round(v)} Hz` : `${(v / 1e3).toFixed(1)} kHz`;
    case U.ms:
      return `${fixed(v, v < 10 ? 1 : 0)} ms`;
    case U.sec:
      return `${fixed(v, v < 10 ? 1 : 0)} s`;
    case U.semis:
      return `${v > 0.5 ? "+" : ""}${Math.round(v)} st`;
    case U.filter:
      if (Math.abs(v) <= FILTER_DEAD_ZONE) return "Off";
      return (v < 0 ? "LP " : "HP ") + formatValue(U.hz, v < 0 ? filterLpHz(v) : filterHpHz(v));
    case U.rate:
      return `${v.toFixed(v < 1 ? 2 : 1)} Hz`;
    case U.bits:
      return String(Math.round(v));
    case U.khz:
      return `${(v / 1e3).toFixed(1)} kHz`;
    case U.integer:
      return String(Math.round(v));
    default:
      return v.toFixed(2);
  }
}
function valueText(p, v) {
  if (p.kind === "bool") return v > 0.5 ? "On" : "Off";
  if (p.kind === "choice") return p.choices[Math.max(0, Math.min(p.choices.length - 1, Math.round(v)))];
  return formatValue(p.unit, v);
}

// xray-demo-stage/src/engine/dsp.js
var TWO_PI = 2 * Math.PI;
var HALF_PI = 0.5 * Math.PI;
var roundToInt = (v) => {
  const r = Math.round(v);
  return r - v === 0.5 && r & 1 ? r - 1 : r;
};
var Rng = class {
  constructor(seed = 305419896) {
    seed >>>= 0;
    this.state = seed === 0 ? 2654435769 : seed;
  }
  next() {
    let s = this.state;
    s = (s ^ s << 13) >>> 0;
    s = (s ^ s >>> 17) >>> 0;
    s = (s ^ s << 5) >>> 0;
    this.state = s;
    return s;
  }
  uni() {
    return (this.next() >>> 8) * (1 / 16777216);
  }
  // 0..1
  bi() {
    return this.uni() * 2 - 1;
  }
  // -1..1
};
var SampleRing = class {
  constructor(log2Size) {
    this.size = 1 << log2Size;
    this.mask = this.size - 1;
    this.data = new Float32Array(this.size);
    this.writePos = 0;
  }
  push(src, n) {
    if (typeof src === "number") {
      this.data[this.writePos & this.mask] = src;
      this.writePos++;
      return;
    }
    for (let i = 0; i < n; ++i) this.data[this.writePos + i & this.mask] = src[i];
    this.writePos += n;
  }
  readLatest(dst, n) {
    const w = this.writePos;
    for (let i = 0; i < n; ++i) dst[i] = this.data[w - n + i & this.mask];
  }
  capacity() {
    return this.size;
  }
  position() {
    return this.writePos;
  }
};
var EnvelopeTap = class {
  constructor(log2Size = 12) {
    this.ring = new SampleRing(log2Size);
    this.hop = 64;
    this.count = 0;
    this.peak = 0;
  }
  setHop(samples) {
    this.hop = Math.max(1, samples | 0);
    this.count = 0;
    this.peak = 0;
  }
  process(x) {
    const a = Math.abs(x);
    if (a > this.peak) this.peak = a;
    if (++this.count >= this.hop) {
      this.ring.push(this.peak);
      this.peak = 0;
      this.count = 0;
    }
  }
  getHop() {
    return this.hop;
  }
};
var CHOP_MAX_SLOTS = 64;
var GRAIN_MAX = 64;
var SCAN_BANDS = 96;
function makeAnalysis() {
  const slot = () => ({
    pre: new SampleRing(13),
    post: new SampleRing(13),
    postRms: 0,
    active: false,
    latency: 0,
    effective: new Float32Array(32),
    lfo: 0
  });
  return {
    sampleRate: 48e3,
    bpm: 120,
    beat: 0,
    latency: 0,
    slots: Array.from({ length: 8 }, slot),
    lofi: { wet: new SampleRing(12), bits: 24, rate: 48e3, wowMs: 0, dropout: 1, noise: 0 },
    chop: { numSlots: 16, current: 0, action: new Int32Array(CHOP_MAX_SLOTS), level: new Float32Array(CHOP_MAX_SLOTS), progress: 0 },
    vibe: { voiceMsL: new Float32Array(4), voiceMsR: new Float32Array(4), voices: 2, phaserHz: 1e3, phaserHzR: 1e3, phaserStages: 6, phaserFeedback: 0 },
    grain: {
      grains: Array.from({ length: GRAIN_MAX }, () => ({ position: 0, semis: 0, env: 0, pan: 0, size: 0, reverse: false, alive: false })),
      bufferSeconds: 2
    },
    delay: { writeL: new EnvelopeTap(12), writeR: new EnvelopeTap(12), msL: 0, msR: 0, feedback: 0, pointsPerSecond: 750 },
    scan: { in: new Float32Array(SCAN_BANDS), out: new Float32Array(SCAN_BANDS), mask: new Float32Array(SCAN_BANDS), frame: 2048 },
    space: { wet: new SampleRing(13) },
    global: { out: new SampleRing(13), outPeakL: 0, outPeakR: 0 }
  };
}

// xray-demo-stage/src/app/mirror.js
function ringsOf(a) {
  const out2 = [];
  const walk = (o, path) => {
    for (const k of Object.keys(o)) {
      const v = o[k];
      if (v instanceof SampleRing) out2.push([`${path}${k}`, v]);
      else if (v instanceof EnvelopeTap) out2.push([`${path}${k}`, v.ring]);
      else if (v && typeof v === "object" && !ArrayBuffer.isView(v)) walk(v, `${path}${k}.`);
    }
  };
  walk(a, "");
  return out2;
}
function applyScalars(target, src) {
  for (const k of Object.keys(src)) {
    const v = src[k], t = target[k];
    if (t instanceof EnvelopeTap) {
      t.hop = v.hop;
      continue;
    }
    if (ArrayBuffer.isView(v)) {
      if (t && ArrayBuffer.isView(t)) t.set(v);
      else target[k] = v;
    } else if (v && typeof v === "object") {
      if (t && typeof t === "object") applyScalars(t, v);
      else target[k] = v;
    } else target[k] = v;
  }
}
function applyRingDeltas(rings, deltas) {
  for (const { i, pos, data } of deltas) {
    const ring = rings[i][1];
    ring.writePos = pos - data.length;
    ring.push(data, data.length);
  }
}

// xray-demo-stage/src/app/proc.js
var MOTION_POINTS = 256;
var SCAN_TABLE_SIZE = 64;
var Param = class {
  constructor(proc2, def) {
    this.proc = proc2;
    this.def = def;
    this.id = def.id;
  }
  get() {
    return this.proc.values.get(this.id);
  }
  // real value
  set(v) {
    this.proc.setValue(this.id, v);
  }
  // real value
  getValue() {
    return toNorm(this.def, this.get());
  }
  // 0..1
  setValueNotifyingHost(n) {
    this.set(fromNorm(this.def, n));
  }
  convertTo0to1(v) {
    return toNorm(this.def, v);
  }
  convertFrom0to1(n) {
    return fromNorm(this.def, n);
  }
  getDefaultValue() {
    return toNorm(this.def, this.def.def);
  }
  getParameterID() {
    return this.id;
  }
  getName() {
    return this.def.name;
  }
  getCurrentValueAsText() {
    return valueText(this.def, this.get());
  }
  textFor(n) {
    return valueText(this.def, fromNorm(this.def, n));
  }
  beginChangeGesture() {
  }
  endChangeGesture() {
  }
};
var Proc = class {
  constructor() {
    this.port = null;
    this.values = /* @__PURE__ */ new Map();
    this.params = /* @__PURE__ */ new Map();
    for (const [id, def] of ALL_PARAMS) {
      this.values.set(id, def.def);
      this.params.set(id, new Param(this, def));
    }
    this.masks = MODULES.map(() => [0, 0]);
    this.order = DEFAULT_ORDER.map((k) => MODULES.indexOf(k));
    this.motions = MODULES.map(() => ({
      path: new Float32Array(MOTION_POINTS * 2),
      lengthBeats: 8,
      xParam: -1,
      yParam: -1,
      hasPath: false,
      playing: false,
      speed: 1,
      liveX: -1,
      liveY: -1
    }));
    this.scanTableData = Float32Array.from({ length: SCAN_TABLE_SIZE }, (_, i) => 0.5 + 0.4 * Math.sin(2 * Math.PI * i / SCAN_TABLE_SIZE * 3));
    this.demoEnabled = false;
    this.bpm = 120;
    this.presetName = "Init";
    this.presetBank = "FACTORY";
    this.focusModule = -1;
    this.analysis = makeAnalysis();
    this.rings = ringsOf(this.analysis);
    this.latency = 0;
    this.pending = {};
    this.listeners = /* @__PURE__ */ new Set();
  }
  // ---- the worklet link
  connect(port) {
    this.port = port;
    port.onmessage = (e) => this.receive(e.data);
    this.syncAll();
  }
  send(msg, transfer) {
    this.port?.postMessage(msg, transfer || []);
  }
  syncAll() {
    this.send({ type: "params", values: Object.fromEntries(this.values) });
    this.masks.forEach((lanes, m) => lanes.forEach((mask, lane) => this.send({ type: "mask", m, lane, mask })));
    this.send({ type: "order", order: this.order });
    this.motions.forEach((_, m) => this.pushMotion(m));
    this.send({ type: "scanTable", table: this.scanTableData });
    this.send({ type: "demo", on: this.demoEnabled });
    this.send({ type: "tempo", bpm: this.bpm });
  }
  receive(msg) {
    if (msg.type !== "frame") return;
    applyRingDeltas(this.rings, msg.deltas);
    applyScalars(this.analysis, msg.scalars);
    msg.motions.forEach(([x, y], m) => {
      this.motions[m].liveX = x;
      this.motions[m].liveY = y;
    });
    this.latency = msg.latency;
  }
  // parameter changes go out once per frame, batched
  flush() {
    const keys = Object.keys(this.pending);
    if (keys.length) {
      this.send({ type: "params", values: this.pending });
      this.pending = {};
    }
  }
  setFocus(m) {
    this.send({ type: "focus", m });
  }
  // ---- parameters
  param(m, i) {
    return this.params.get(moduleDef(m).params[i].id);
  }
  lfoParam(m, i) {
    return this.params.get(LFO_DEFS[typeof m === "number" ? m : MODULES.indexOf(m)][i].id);
  }
  global(id) {
    return this.params.get(id);
  }
  getParameter(id) {
    return this.params.get(id);
  }
  paramValue(m, i) {
    return this.values.get(moduleDef(m).params[i].id);
  }
  isModuleOn(m) {
    return this.paramValue(m, 0) > 0.5;
  }
  setValue(id, v) {
    const def = ALL_PARAMS.get(id);
    if (!def) return;
    v = Math.max(def.min, Math.min(def.max, v));
    if (def.kind !== "float") v = Math.round(v);
    if (this.values.get(id) === v) return;
    this.values.set(id, v);
    this.pending[id] = v;
    this.changed();
  }
  getRaw(id) {
    return this.values.get(id);
  }
  // ---- LFO lanes
  getModMask(m, lane) {
    return this.masks[m][lane] >>> 0;
  }
  setModMask(m, lane, mask) {
    this.masks[m][lane] = mask >>> 0;
    this.send({ type: "mask", m, lane, mask: mask >>> 0 });
    this.changed();
  }
  toggleModTarget(m, lane, paramIndex) {
    const p = moduleDef(m).params[paramIndex];
    if (!p || p.kind !== "float") return;
    this.setModMask(m, lane, this.masks[m][lane] ^ 1 << paramIndex);
  }
  // ---- chain order (module indices, first to last)
  getChainOrder() {
    return this.order.slice();
  }
  setChainOrder(order) {
    const ok = order.length === 8 && new Set(order).size === 8 && order.every((i) => i >= 0 && i < 8);
    this.order = ok ? order.slice() : DEFAULT_ORDER.map((k) => MODULES.indexOf(k));
    this.send({ type: "order", order: this.order });
    this.changed();
  }
  // ---- motion (XY recordings)
  motion(m) {
    return this.motions[m];
  }
  pushMotion(m) {
    const ms = this.motions[m];
    this.send({ type: "motion", m, data: {
      path: ms.path,
      lengthBeats: ms.lengthBeats,
      xParam: ms.xParam,
      yParam: ms.yParam,
      hasPath: ms.hasPath,
      playing: ms.playing,
      speed: ms.speed
    } });
  }
  // ---- scan's drawn shape
  scanTable() {
    return this.scanTableData;
  }
  pushScanTable() {
    this.send({ type: "scanTable", table: this.scanTableData });
  }
  // ---- demo and tempo
  setDemoEnabled(on) {
    this.demoEnabled = !!on;
    this.send({ type: "demo", on: this.demoEnabled });
    this.changed();
  }
  isDemoEnabled() {
    return this.demoEnabled;
  }
  setTempo(bpm) {
    this.bpm = Math.max(40, Math.min(240, Math.round(bpm)));
    this.send({ type: "tempo", bpm: this.bpm });
    this.changed();
  }
  getTotalLatency() {
    return this.latency;
  }
  onChange(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
  changed() {
    for (const fn of this.listeners) fn();
  }
  // The focus if it is switched on, otherwise the active module whose effect will be most visible on screen.
  suggestedFocus() {
    const f2 = this.focusModule;
    if (f2 >= 0 && f2 < 8 && this.isModuleOn(f2)) return f2;
    const weight = [0.85, 0.9, 1, 0.9, 1, 0.95, 1, 0.55];
    let best = -1, pick2 = f2 >= 0 && f2 < 8 ? f2 : 0;
    for (let m = 0; m < 8; ++m) {
      if (!this.isModuleOn(m)) continue;
      let wet = 0;
      for (const page2 of MODULE_DEFS[m].pages) {
        if (page2.enableParam >= 0 && this.paramValue(m, page2.enableParam) < 0.5) continue;
        wet = Math.max(wet, page2.mixParam >= 0 ? this.paramValue(m, page2.mixParam) : 1);
      }
      if (m === 0) wet *= Math.max(0.2, Math.min(1, this.paramValue(m, mp.drive.gain) / 18));
      const score = wet * weight[m];
      if (score > best) {
        best = score;
        pick2 = m;
      }
    }
    return pick2;
  }
  // ---- whole patches (presets, history)
  captureState() {
    return {
      values: Object.fromEntries(this.values),
      order: this.order.slice(),
      preset: this.presetName,
      bank: this.presetBank,
      focus: this.focusModule,
      masks: this.masks.map((l) => l.slice()),
      scanTable: Array.from(this.scanTableData),
      motions: this.motions.map((ms, m) => ms.hasPath ? {
        module: m,
        length: ms.lengthBeats,
        x: ms.xParam,
        y: ms.yParam,
        playing: ms.playing,
        speed: ms.speed,
        path: Array.from(ms.path)
      } : null).filter(Boolean)
    };
  }
  restoreState(s, keepPitchIfLocked) {
    if (!s || !s.values) return;
    const pitchNow = this.values.get("pitch");
    const locked = keepPitchIfLocked && this.values.get("pitch_lock") > 0.5;
    for (const [id, def] of ALL_PARAMS) this.setValue(id, id in s.values ? s.values[id] : def.def);
    if (locked) {
      this.setValue("pitch", pitchNow);
      this.setValue("pitch_lock", 1);
    }
    this.setChainOrder(s.order || []);
    this.presetName = s.preset ?? "Init";
    this.presetBank = s.bank ?? "FACTORY";
    this.focusModule = s.focus ?? -1;
    for (let m = 0; m < 8; ++m) for (let lane = 0; lane < 2; ++lane) this.setModMask(m, lane, s.masks?.[m]?.[lane] ?? 0);
    if (s.scanTable) {
      this.scanTableData.set(s.scanTable.slice(0, SCAN_TABLE_SIZE));
      this.pushScanTable();
    }
    this.motions.forEach((ms) => {
      ms.hasPath = false;
      ms.playing = false;
    });
    for (const mt of s.motions || []) {
      const ms = this.motions[mt.module];
      if (!ms) continue;
      ms.lengthBeats = mt.length;
      ms.xParam = mt.x;
      ms.yParam = mt.y;
      ms.speed = mt.speed ?? 1;
      ms.path.set(mt.path.slice(0, MOTION_POINTS * 2));
      ms.hasPath = mt.path.length === MOTION_POINTS * 2;
      ms.playing = !!mt.playing && ms.hasPath;
    }
    this.motions.forEach((_, m) => this.pushMotion(m));
    this.changed();
  }
};

// xray-demo-stage/src/app/component.js
var Component = class {
  constructor() {
    this.x = 0;
    this.y = 0;
    this.w = 0;
    this.h = 0;
    this.children = [];
    this.parent = null;
    this.visible = true;
    this.interceptsSelf = true;
    this.interceptsChildren = true;
    this.clipsChildren = true;
    this.cursor = null;
  }
  setBounds(x, y, w, h) {
    const changed = w !== this.w || h !== this.h;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    if (changed) this.resized();
  }
  getLocalBounds() {
    return { x: 0, y: 0, w: this.w, h: this.h };
  }
  getWidth() {
    return this.w;
  }
  getHeight() {
    return this.h;
  }
  setVisible(v) {
    this.visible = !!v;
  }
  isVisible() {
    return this.visible;
  }
  setInterceptsMouseClicks(self, children) {
    this.interceptsSelf = self;
    this.interceptsChildren = children;
  }
  addChild(c) {
    if (c.parent) c.parent.removeChild(c);
    c.parent = this;
    this.children.push(c);
    return c;
  }
  addAndMakeVisible(c) {
    c.visible = true;
    return this.addChild(c);
  }
  removeChild(c) {
    const i = this.children.indexOf(c);
    if (i >= 0) this.children.splice(i, 1);
    c.parent = null;
  }
  toFront(c) {
    this.removeChild(c);
    this.addChild(c);
  }
  contains(x, y) {
    return x >= 0 && y >= 0 && x < this.w && y < this.h && this.hitTest(x, y);
  }
  hitTest() {
    return true;
  }
  repaint() {
  }
  // the device redraws every frame
  resized() {
  }
  paint() {
  }
  paintOverChildren() {
  }
  // position of this component's origin on the device
  devicePos() {
    let x = 0, y = 0;
    for (let c = this; c; c = c.parent) {
      x += c.x;
      y += c.y;
    }
    return { x, y };
  }
  root() {
    let c = this;
    while (c.parent) c = c.parent;
    return c;
  }
  showInfo(text) {
    this.root().setInfo?.(text);
  }
  // ---- drawing (called by the root)
  render(ctx) {
    if (!this.visible || this.w <= 0 || this.h <= 0) return;
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.save();
    this.paint(ctx);
    ctx.restore();
    if (this.children.length) {
      if (this.clipsChildren) {
        ctx.beginPath();
        ctx.rect(0, 0, this.w, this.h);
        ctx.clip();
      }
      for (const c of this.children) c.render(ctx);
    }
    this.paintOverChildren(ctx);
    ctx.restore();
  }
  // deepest component under (x, y) (local coords) that takes clicks
  componentAt(x, y) {
    if (!this.visible || x < 0 || y < 0 || x >= this.w || y >= this.h) return null;
    if (this.interceptsChildren) {
      for (let i = this.children.length - 1; i >= 0; --i) {
        const c = this.children[i];
        const hit = c.componentAt(x - c.x, y - c.y);
        if (hit) return hit;
      }
    }
    return this.interceptsSelf && this.hitTest(x, y) ? this : null;
  }
  // drag-and-drop targets (juce::DragAndDropTarget): override these
  isInterestedInDragSource() {
    return false;
  }
  itemDragEnter() {
  }
  itemDragExit() {
  }
  itemDropped() {
  }
};
var Root = class extends Component {
  constructor(canvas2, width2, height2) {
    super();
    this.canvas = canvas2;
    this.ctx = canvas2.getContext("2d");
    this.setBounds(0, 0, width2, height2);
    this.scale = 1;
    this.hover = null;
    this.down = null;
    this.lastClick = { target: null, time: 0, x: 0, y: 0, count: 0 };
    this.drag = null;
    this.infoText = "";
    this.onInfo = null;
    this.onBeforePaint = null;
    this.listen();
  }
  setInfo(text) {
    this.infoText = text || "";
  }
  // the canvas fills its CSS box; the device is drawn scaled to fit it
  layoutCanvas() {
    const r = this.canvas.getBoundingClientRect();
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const pw = Math.round(r.width * dpr), ph = Math.round(r.height * dpr);
    if (this.canvas.width !== pw || this.canvas.height !== ph) {
      this.canvas.width = pw;
      this.canvas.height = ph;
    }
    this.scale = r.width / this.w;
    this.pixelScale = this.scale * dpr;
  }
  draw() {
    this.layoutCanvas();
    const ctx = this.ctx;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    ctx.setTransform(this.pixelScale, 0, 0, this.pixelScale, 0, 0);
    this.onBeforePaint?.(ctx);
    this.render(ctx);
    if (this.drag && this.drag.drawImage) {
      ctx.save();
      this.drag.drawImage(ctx, this.drag.x, this.drag.y);
      ctx.restore();
    }
  }
  // ---- events
  toDevice(ev) {
    const r = this.canvas.getBoundingClientRect();
    return { x: (ev.clientX - r.left) / this.scale, y: (ev.clientY - r.top) / this.scale };
  }
  makeEvent(target, p, ev, extra = {}) {
    const o = target.devicePos();
    const right3 = ev.button === 2 || ev.button === 0 && ev.ctrlKey;
    return {
      x: p.x - o.x,
      y: p.y - o.y,
      deviceX: p.x,
      deviceY: p.y,
      dx: this.down ? p.x - this.down.startX : 0,
      dy: this.down ? p.y - this.down.startY : 0,
      mods: { shift: ev.shiftKey, alt: ev.altKey, cmd: ev.metaKey || ev.ctrlKey && !right3, right: right3 },
      clicks: this.lastClick.count,
      dragged: this.down ? this.down.moved : false,
      ...extra
    };
  }
  setHover(target, p, ev) {
    if (target === this.hover) return;
    const prev = this.hover;
    this.hover = target;
    if (prev) prev.mouseExit?.(this.makeEvent(prev, p, ev));
    if (target) target.mouseEnter?.(this.makeEvent(target, p, ev));
  }
  updateCursor(target) {
    let c = null;
    for (let t = target; t && !c; t = t.parent) c = t.cursor;
    this.canvas.style.cursor = this.drag ? "grabbing" : c || "default";
  }
  listen() {
    const cv = this.canvas;
    cv.addEventListener("contextmenu", (ev) => ev.preventDefault());
    cv.addEventListener("touchmove", (ev) => ev.preventDefault(), { passive: false });
    cv.addEventListener("pointerdown", (ev) => {
      if (ev.pointerType === "mouse" && ev.button !== 0 && ev.button !== 2) return;
      ev.preventDefault();
      cv.setPointerCapture(ev.pointerId);
      const p = this.toDevice(ev);
      const target = this.componentAt(p.x, p.y);
      this.setHover(target, p, ev);
      if (!target) return;
      const now = performance.now(), lc = this.lastClick;
      const again = lc.target === target && now - lc.time < 400 && Math.hypot(p.x - lc.x, p.y - lc.y) < 6;
      lc.count = again ? lc.count + 1 : 1;
      lc.target = target;
      lc.time = now;
      lc.x = p.x;
      lc.y = p.y;
      this.down = { target, startX: p.x, startY: p.y, moved: false, button: ev.button, ctrl: ev.ctrlKey };
      target.mouseDown?.(this.makeEvent(target, p, ev));
      this.updateCursor(target);
    });
    cv.addEventListener("pointermove", (ev) => {
      const p = this.toDevice(ev);
      if (this.down) {
        const d = this.down;
        if (!d.moved && Math.hypot(p.x - d.startX, p.y - d.startY) > 2) d.moved = true;
        const e = this.makeEvent(d.target, p, { ...pick(ev), button: d.button, ctrlKey: d.ctrl });
        d.target.mouseDrag?.(e);
        if (this.drag) this.moveDrag(p);
        return;
      }
      const target = this.componentAt(p.x, p.y);
      this.setHover(target, p, ev);
      if (target) target.mouseMove?.(this.makeEvent(target, p, ev));
      this.updateCursor(target);
    });
    const up = (ev, cancelled) => {
      if (!this.down) return;
      const p = this.toDevice(ev);
      const d = this.down;
      const e = this.makeEvent(d.target, p, { ...pick(ev), button: d.button, ctrlKey: d.ctrl });
      if (this.drag) this.finishDrag(p, cancelled);
      this.down = null;
      d.target.mouseUp?.(e);
      if (!cancelled && !d.moved && this.lastClick.count >= 2 && this.lastClick.target === d.target)
        d.target.mouseDoubleClick?.(e);
      const target = this.componentAt(p.x, p.y);
      this.setHover(target, p, ev);
      this.updateCursor(target);
    };
    cv.addEventListener("pointerup", (ev) => up(ev, false));
    cv.addEventListener("pointercancel", (ev) => up(ev, true));
    cv.addEventListener("pointerleave", (ev) => {
      if (!this.down) {
        this.setHover(null, this.toDevice(ev), ev);
        this.updateCursor(null);
      }
    });
    cv.addEventListener("wheel", (ev) => {
      const p = this.toDevice(ev);
      for (let t = this.componentAt(p.x, p.y); t; t = t.parent) {
        if (t.mouseWheel) {
          ev.preventDefault();
          t.mouseWheel(this.makeEvent(t, p, ev, { wheelY: -ev.deltaY / 100 }));
          break;
        }
      }
    }, { passive: false });
  }
  // ---- drag and drop (juce::DragAndDropContainer)
  startDragging(description, source, drawImage) {
    this.drag = { description, source, target: null, x: this.down?.startX ?? 0, y: this.down?.startY ?? 0, drawImage };
    this.onDragStarted?.(this.drag);
  }
  isDragAndDropActive() {
    return !!this.drag;
  }
  dropTargetAt(p) {
    const details = { description: this.drag.description, source: this.drag.source };
    for (let t = this.componentAtAny(p.x, p.y); t; t = t.parent)
      if (t.isInterestedInDragSource(details)) return t;
    return null;
  }
  // like componentAt, but ignores the click-interception flags of parents (targets can sit under overlays)
  componentAtAny(x, y) {
    return this.componentAt(x, y);
  }
  moveDrag(p) {
    const d = this.drag;
    d.x = p.x;
    d.y = p.y;
    const t = this.dropTargetAt(p);
    if (t !== d.target) {
      const details = { description: d.description, source: d.source };
      d.target?.itemDragExit(details);
      d.target = t;
      t?.itemDragEnter(details);
    }
  }
  finishDrag(p, cancelled) {
    const d = this.drag;
    this.drag = null;
    const details = { description: d.description, source: d.source };
    if (d.target) {
      d.target.itemDragExit(details);
      if (!cancelled) d.target.itemDropped(details);
    }
    d.source?.dragFinished?.();
    this.onDragEnded?.(d);
  }
};
function pick(ev) {
  return { button: ev.button, shiftKey: ev.shiftKey, altKey: ev.altKey, metaKey: ev.metaKey, ctrlKey: ev.ctrlKey };
}

// xray-demo-stage/src/app/layout.js
var width = 1140;
var height = 680;
var margin = 28;
var right = width - margin;
var scopeGlass = { x: 31, y: 83, w: 214, h: 72 };
var scopeRadius = 11;
var display = { x: 274, y: 80, w: 550, h: 468 };
var displayGlass = { x: 278, y: 84, w: 542, h: 460 };
var displayRadius = 16;
var keyX = 28;
var keyY = 176;
var keyW = 104;
var keyH = 84;
var keyGap = 12;
var keyRadius = 16;
var keyMargin = 10;
var key = (i) => ({ x: keyX + i % 2 * (keyW + keyGap), y: keyY + Math.floor(i / 2) * (keyH + keyGap), w: keyW, h: keyH });
var keyLight = (i) => {
  const k = key(i);
  return { x: k.x + k.w - 23, y: k.y + 23 };
};
var keyLightBezel = 11;
var keyLightSprite = 34;
var barY = 38;
var logoX = 30;
var preset = { x: 399, y: 19, w: 300, h: 38 };
var save = { x: 713, y: 19, w: 52, h: 38 };
var diceButton = { x: 1095, y: barY };
var roundButtonRadius = 17;
var dial = { x: 968, y: 180 };
var dialRadius = 76;
var smallKnobs = [{ x: 886, y: 392 }, { x: 968, y: 392 }, { x: 1050, y: 392 }];
var smallKnobRadius = 24;
var meter = { x: 1100, y: 92, w: 12, h: 180 };
var meterSegments = 26;
var drawerButton = { x: 485, y: 562, w: 128, h: 28 };
var demoButton = { x: 920, y: 562, w: 96, h: 28 };
var dividerY = 606;
var rowY = 640;
var reduced = (r, dx, dy = dx) => ({ x: r.x + dx, y: r.y + dy, w: r.w - 2 * dx, h: r.h - 2 * dy });
var expanded = (r, dx, dy = dx) => reduced(r, -dx, -dy);
var withCentre = (w, h, c) => ({ x: c.x - w / 2, y: c.y - h / 2, w, h });
var centre = (r) => ({ x: r.x + r.w / 2, y: r.y + r.h / 2 });
var contains = (r, x, y) => x >= r.x && y >= r.y && x < r.x + r.w && y < r.y + r.h;
var translated = (r, dx, dy) => ({ x: r.x + dx, y: r.y + dy, w: r.w, h: r.h });
var union = (a, b) => {
  const x = Math.min(a.x, b.x), y = Math.min(a.y, b.y);
  return { x, y, w: Math.max(a.x + a.w, b.x + b.w) - x, h: Math.max(a.y + a.h, b.y + b.h) - y };
};

// xray-demo-stage/src/app/gfx.js
var ink = {
  primary: "#1d1d1f",
  secondary: "#808086",
  tertiary: "#b0b0b5",
  fill: "rgba(0,0,0,0.043)",
  hair: "rgba(0,0,0,0.086)"
};
var colours = {
  screen: "#020305",
  text: "#f5f5f7",
  textDim: "#a0a3aa",
  textFaint: "#6e727a",
  line: "#2c2f35",
  grid: "#16191e",
  glass: "#18191c",
  glassHi: "#25262a",
  film: "#e8eaee",
  lane1: "#64d2ff",
  lane2: "#ffb340",
  record: "#ff453a"
};
var MODULE_COLOURS = ["#f84b4b", "#ff8c1e", "#fbd530", "#3bca60", "#00d0e2", "#3789fd", "#9362f4", "#f061ba"];
var WEIGHTS = { regular: 400, medium: 500, semibold: 600 };
var FONT_FAMILY = "'Inter', -apple-system, 'Segoe UI', system-ui, sans-serif";
function sans(size, weight = "regular") {
  return `${WEIGHTS[weight] ?? 400} ${(size * 0.96).toFixed(2)}px ${FONT_FAMILY}`;
}
function drawTracked(ctx, text, x, y, font, trackingEm, align = "left") {
  ctx.font = font;
  const px = parseFloat(font.split(" ")[1]);
  const t = trackingEm * px;
  const widths = [...text].map((c) => ctx.measureText(c).width);
  const total = widths.reduce((a, b) => a + b, 0) + t * (text.length - 1);
  let cx = align === "center" ? x - total / 2 : align === "right" ? x - total : x;
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  [...text].forEach((c, i) => {
    ctx.fillText(c, cx, y);
    cx += widths[i] + t;
  });
  return total;
}
function textWidth(ctx, s, font) {
  ctx.font = font;
  return ctx.measureText(s).width;
}
var titleCase = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
var capitalised = (s) => s.charAt(0).toUpperCase() + s.slice(1);
function oklch(L, C3, hDeg) {
  const h = hDeg * Math.PI / 180;
  const a = C3 * Math.cos(h), b = C3 * Math.sin(h);
  const l_ = (L + 0.3963377774 * a + 0.2158037573 * b) ** 3;
  const m_ = (L - 0.1055613458 * a - 0.0638541728 * b) ** 3;
  const s_ = (L - 0.0894841775 * a - 1.291485548 * b) ** 3;
  const lin = [
    4.0767416621 * l_ - 3.3077115913 * m_ + 0.2309699292 * s_,
    -1.2684380046 * l_ + 2.6097574011 * m_ - 0.3413193965 * s_,
    -0.0041960863 * l_ - 0.7034186147 * m_ + 1.707614701 * s_
  ];
  return lin.map((x) => {
    x = Math.max(0, Math.min(1, x));
    return Math.round((x <= 31308e-7 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055) * 255);
  });
}
var hueOf = (u) => ((265 + 360 * u) % 360 + 720) % 360;
var SPEC_CACHE = /* @__PURE__ */ new Map();
function spectrumRgb(u, L = 0.8, C3 = 0.2) {
  const key2 = `${Math.round(u * 512)}|${L}|${C3}`;
  let v = SPEC_CACHE.get(key2);
  if (!v) {
    v = oklch(L, C3, hueOf(Math.round(u * 512) / 512));
    SPEC_CACHE.set(key2, v);
  }
  return v;
}
var rgba = (rgb, a = 1) => `rgba(${rgb[0]},${rgb[1]},${rgb[2]},${a})`;
function spectrumInk(u, alpha = 1) {
  const h = hueOf(u);
  return rgba(oklch(0.62 + 0.1 * Math.exp(-(((h - 100) / 38) ** 2)), 0.22, h), alpha);
}
var whiten = (rgb, t) => rgb.map((c) => Math.round(c + (255 - c) * t));
function hexRgb(h) {
  h = h.replace("#", "");
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
}
function spectrumGradient(ctx, x0, x1, u0, u1, alpha = 1, whitenAmt = 0) {
  const g = ctx.createLinearGradient(x0, 0, Math.max(x0 + 1, x1), 0);
  for (let k = 0; k <= 12; ++k) {
    const t = k / 12;
    g.addColorStop(t, rgba(whiten(spectrumRgb(u0 + (u1 - u0) * t), whitenAmt), alpha));
  }
  return g;
}
function drawSpectrumLine(ctx, path, x0, x1, u0 = 0.05, u1 = 0.95, width2 = 1.6, glow = 6, alpha = 1) {
  ctx.lineJoin = "bevel";
  ctx.lineCap = "butt";
  if (glow > 0) {
    ctx.strokeStyle = spectrumGradient(ctx, x0, x1, u0, u1, 0.24 * alpha);
    ctx.lineWidth = width2 + glow * 0.7;
    ctx.stroke(path);
  }
  ctx.strokeStyle = spectrumGradient(ctx, x0, x1, u0, u1, alpha, 0.38);
  ctx.lineWidth = width2;
  ctx.stroke(path);
}
function drawGlow(ctx, path, colour2, width2 = 1.6, glow = 6, alpha = 1) {
  ctx.lineJoin = "bevel";
  ctx.lineCap = "butt";
  const prev = ctx.globalAlpha;
  if (glow > 0) {
    ctx.globalAlpha = prev * 0.2 * alpha;
    ctx.strokeStyle = colour2;
    ctx.lineWidth = width2 + glow * 0.7;
    ctx.stroke(path);
  }
  ctx.globalAlpha = prev * alpha;
  ctx.strokeStyle = colour2;
  ctx.lineWidth = width2;
  ctx.stroke(path);
  ctx.globalAlpha = prev;
}
function drawGlassSheen(ctx, x, y, w, h, r, strength = 1) {
  ctx.save();
  roundRect(ctx, x, y, w, h, r);
  ctx.clip();
  const g = ctx.createLinearGradient(x, y, x + w * 0.42, y + h * 0.62);
  g.addColorStop(0, `rgba(255,255,255,${0.055 * strength})`);
  g.addColorStop(0.55, `rgba(255,255,255,${0.012 * strength})`);
  g.addColorStop(1, "rgba(255,255,255,0)");
  ctx.fillStyle = g;
  ctx.fillRect(x, y, w, h);
  const e = ctx.createLinearGradient(0, y, 0, y + 3);
  e.addColorStop(0, `rgba(255,255,255,${0.1 * strength})`);
  e.addColorStop(1, "rgba(255,255,255,0)");
  ctx.fillStyle = e;
  ctx.fillRect(x, y, w, 3);
  ctx.restore();
}
function roundRect(ctx, x, y, w, h, r) {
  r = Math.max(0, Math.min(r, w / 2, h / 2));
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}
function fillRoundRect(ctx, x, y, w, h, r, fill) {
  roundRect(ctx, x, y, w, h, r);
  ctx.fillStyle = fill;
  ctx.fill();
}
function strokeRoundRect(ctx, x, y, w, h, r, stroke, lw = 1) {
  roundRect(ctx, x, y, w, h, r);
  ctx.strokeStyle = stroke;
  ctx.lineWidth = lw;
  ctx.stroke();
}
function drawTextIn(ctx, s, r, font, colour2, just = "left", ellipsis = false) {
  ctx.font = font;
  ctx.fillStyle = colour2;
  ctx.textBaseline = "middle";
  if (ellipsis && ctx.measureText(s).width > r.w) {
    while (s.length > 1 && ctx.measureText(`${s}\u2026`).width > r.w) s = s.slice(0, -1);
    s = `${s.trimEnd()}\u2026`;
  }
  ctx.textAlign = just === "centre" ? "center" : just;
  ctx.fillText(s, just === "centre" ? r.x + r.w / 2 : just === "right" ? r.x + r.w : r.x, r.y + r.h / 2);
}
function drawTrackedIn(ctx, s, r, font, colour2, trackingEm, just = "left") {
  ctx.fillStyle = colour2;
  const x = just === "centre" ? r.x + r.w / 2 : just === "right" ? r.x + r.w : r.x;
  return drawTracked(ctx, s, x, r.y + r.h / 2, font, trackingEm, just === "centre" ? "center" : just);
}
function strokeLine(ctx, x0, y0, x1, y1, colour2, width2 = 1, cap = "butt") {
  ctx.beginPath();
  ctx.moveTo(x0, y0);
  ctx.lineTo(x1, y1);
  ctx.strokeStyle = colour2;
  ctx.lineWidth = width2;
  ctx.lineCap = cap;
  ctx.stroke();
}
function fillEllipse(ctx, x, y, w, h, colour2) {
  ctx.beginPath();
  ctx.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, Math.PI * 2);
  ctx.fillStyle = colour2;
  ctx.fill();
}
function brighter(hex, amount) {
  const k = 1 / (1 + amount);
  return rgba(hexRgb(hex).map((c) => Math.round(255 - (255 - c) * k)), 1);
}

// xray-demo-stage/src/app/menu.js
var open = null;
var css = `
.xm { position: fixed; z-index: 1000; min-width: 168px; padding: 5px 0; background: #fbfbfa; color: #1d1d1f;
      border: 1px solid rgba(0,0,0,0.086); border-radius: 9px; box-shadow: 0 12px 36px rgba(0,0,0,0.16), 0 2px 6px rgba(0,0,0,0.06);
      font: 400 12.96px 'Inter', -apple-system, system-ui, sans-serif; user-select: none; -webkit-user-select: none;
      transform-origin: top left; max-height: calc(100vh - 16px); overflow-y: auto; }
.xm-item { position: relative; display: flex; align-items: center; gap: 8px; height: 26px; padding: 0 26px 0 28px;
           white-space: nowrap; cursor: default; border-radius: 5px; margin: 0 5px; }
.xm-item.on, .xm-item:focus-visible { background: #ececee; outline: none; }
.xm-item.off { color: #b0b0b5; }
.xm-tick { position: absolute; left: 10px; top: 50%; width: 9px; height: 5px; margin-top: -4px;
           border-left: 1.6px solid #1d1d1f; border-bottom: 1.6px solid #1d1d1f; transform: rotate(-45deg); }
.xm-arrow { position: absolute; right: 11px; top: 50%; width: 5px; height: 5px; margin-top: -3px;
            border-right: 1.5px solid #808086; border-top: 1.5px solid #808086; transform: rotate(45deg); }
.xm-head { padding: 7px 18px 3px; color: #808086; font-weight: 600; font-size: 11px; letter-spacing: 0.06em; text-transform: uppercase; }
.xm-sep { height: 1px; margin: 5px 10px; background: rgba(0,0,0,0.086); }
.xd-veil { position: fixed; inset: 0; z-index: 1001; background: rgba(20,20,24,0.18); display: grid; place-items: center; }
.xd { width: 300px; padding: 20px 20px 16px; background: #fbfbfa; color: #1d1d1f; border-radius: 14px;
      border: 1px solid rgba(0,0,0,0.086); box-shadow: 0 24px 60px rgba(0,0,0,0.22);
      font: 400 12.5px 'Inter', -apple-system, system-ui, sans-serif; }
.xd h3 { margin: 0 0 4px; font-size: 14.4px; font-weight: 600; }
.xd p { margin: 0 0 12px; color: #808086; }
.xd input { box-sizing: border-box; width: 100%; height: 34px; padding: 0 11px; border-radius: 8px; border: 1px solid rgba(0,0,0,0.12);
            background: #fff; color: #1d1d1f; font: inherit; font-size: 13px; outline: none; }
.xd input:focus { border-color: #808086; }
.xd .row { display: flex; justify-content: flex-end; gap: 8px; margin-top: 16px; }
.xd button { height: 30px; padding: 0 16px; border-radius: 15px; border: 0; font: inherit; font-weight: 500; cursor: pointer;
             background: #ededef; color: #1d1d1f; }
.xd button.go { background: #1d1d1f; color: #fff; }
`;
var styled = false;
function style() {
  if (styled) return;
  styled = true;
  const s = document.createElement("style");
  s.textContent = css;
  document.head.appendChild(s);
}
function closeMenus() {
  if (open) {
    open.cleanup();
    open = null;
  }
}
function showMenu(items, at, scale = 1) {
  style();
  closeMenus();
  return new Promise((resolve) => {
    const layers = [];
    let done = false;
    const finish = (id) => {
      if (done) return;
      done = true;
      cleanup();
      open = null;
      resolve(id);
    };
    const onDown = (e) => {
      if (!layers.some((l) => l.contains(e.target))) finish(0);
    };
    const onKey = (e) => {
      if (e.key === "Escape") finish(0);
    };
    const cleanup = () => {
      layers.forEach((l) => l.remove());
      window.removeEventListener("pointerdown", onDown, true);
      window.removeEventListener("keydown", onKey, true);
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("resize", onBlur);
    };
    const onBlur = () => finish(0);
    open = { cleanup: () => {
      done = true;
      cleanup();
      resolve(0);
    } };
    const s = Math.max(0.85, Math.min(1.25, scale));
    let hoverTimer = 0;
    const build2 = (list, x, y, depth) => {
      while (layers.length > depth) layers.pop().remove();
      const el = document.createElement("div");
      el.className = "xm";
      el.style.transform = `scale(${s})`;
      el.addEventListener("contextmenu", (e) => e.preventDefault());
      el.addEventListener("pointerenter", () => {
        if (depth > 0) clearTimeout(hoverTimer);
      });
      for (const it of list) {
        if (it.separator) {
          el.appendChild(Object.assign(document.createElement("div"), { className: "xm-sep" }));
          continue;
        }
        if (it.header) {
          el.appendChild(Object.assign(document.createElement("div"), { className: "xm-head", textContent: it.header }));
          continue;
        }
        const row = document.createElement("div");
        const enabled = it.enabled !== false;
        row.className = `xm-item${enabled ? "" : " off"}`;
        row.tabIndex = -1;
        row.textContent = it.text;
        if (it.checked) row.appendChild(Object.assign(document.createElement("span"), { className: "xm-tick" }));
        if (it.sub) row.appendChild(Object.assign(document.createElement("span"), { className: "xm-arrow" }));
        row.addEventListener("pointerenter", () => {
          el.querySelectorAll(".xm-item.on").forEach((n) => n.classList.remove("on"));
          if (enabled) row.classList.add("on");
          clearTimeout(hoverTimer);
          const act = () => {
            if (done) return;
            if (it.sub) {
              const r2 = row.getBoundingClientRect();
              build2(it.sub, r2.right + 2, r2.top - 5 * s, depth + 1);
            } else {
              while (layers.length > depth + 1) layers.pop().remove();
            }
          };
          if (layers.length > depth + 1) hoverTimer = setTimeout(act, 220);
          else act();
        });
        row.addEventListener("click", (e) => {
          e.stopPropagation();
          if (!enabled || it.sub) return;
          finish(it.id);
        });
        el.appendChild(row);
      }
      document.body.appendChild(el);
      layers.push(el);
      const r = el.getBoundingClientRect();
      let left = x, top = y;
      if (left + r.width > window.innerWidth - 8) left = depth > 0 ? x - r.width - (layers[depth - 1]?.getBoundingClientRect().width ?? 0) - 4 : window.innerWidth - 8 - r.width;
      if (top + r.height > window.innerHeight - 8) top = Math.max(8, window.innerHeight - 8 - r.height);
      el.style.left = `${Math.max(8, left)}px`;
      el.style.top = `${top}px`;
      return el;
    };
    build2(items, at.left, at.bottom + 4, 0);
    setTimeout(() => {
      window.addEventListener("pointerdown", onDown, true);
      window.addEventListener("keydown", onKey, true);
      window.addEventListener("blur", onBlur);
      window.addEventListener("resize", onBlur);
    }, 0);
  });
}
function askName(title, message, initial = "") {
  style();
  closeMenus();
  return new Promise((resolve) => {
    const veil = document.createElement("div");
    veil.className = "xd-veil";
    veil.innerHTML = `<form class="xd"><h3></h3><p></p><input maxlength="64" autocomplete="off" spellcheck="false">
      <div class="row"><button type="button" class="no">Cancel</button><button type="submit" class="go">Save</button></div></form>`;
    veil.querySelector("h3").textContent = title;
    veil.querySelector("p").textContent = message;
    const input = veil.querySelector("input");
    input.value = initial;
    const end = (v) => {
      veil.remove();
      resolve(v);
    };
    veil.querySelector("form").addEventListener("submit", (e) => {
      e.preventDefault();
      end(input.value);
    });
    veil.querySelector(".no").addEventListener("click", () => end(null));
    veil.addEventListener("pointerdown", (e) => {
      if (e.target === veil) end(null);
    });
    veil.addEventListener("keydown", (e) => {
      if (e.key === "Escape") end(null);
    });
    document.body.appendChild(veil);
    input.focus();
    input.select();
  });
}

// xray-demo-stage/src/app/presets.js
var P = (name, category, values, mods = [], order = "") => ({ name, category, values, mods, order });
var FACTORY = [
  P("Init", "Init", { drive_on: 1, delay_on: 1, space_on: 1 }),
  P("Warm Tape Bus", "Mix", { drive_on: 1, drive_model: 1, drive_gain: 9, drive_character: 0.3, lofi_on: 1, lofi_mode: 1, lofi_type: 0, lofi_crush: 0.12, lofi_wow: 0.1, lofi_flutter: 0.12, lofi_noise_level: 0.08, lofi_dropouts: 0, space_on: 1, space_type: 0, space_size: 0.8, space_mix: 0.1, glue: 1 }),
  P("Cassette Memories", "Lofi", { lofi_on: 1, lofi_mode: 1, lofi_type: 1, lofi_crush: 0.35, lofi_wow: 0.5, lofi_flutter: 0.45, lofi_noise_level: 0.3, lofi_dropouts: 0.15, lofi_wear: 0.45, vibe_on: 1, vibe_ch_mode: 3, vibe_ch_mix: 0.35, space_on: 1, space_type: 2, space_size: 1.6, space_mix: 0.18 }),
  P("Sampler Dust", "Lofi", { lofi_on: 1, lofi_mode: 0, lofi_type: 0, lofi_crush: 0.5, lofi_bits: 12, lofi_noise: 1, lofi_noise_level: 0.35, lofi_duck: 1, lofi_wow: 0.15, drive_on: 1, drive_gain: 7, space_on: 1, space_type: 0, space_size: 0.9, space_mix: 0.12 }),
  P("Bitcrush Arcade", "Lofi", { lofi_on: 1, lofi_mode: 2, lofi_crush: 0.8, lofi_bits: 8, lofi_noise_level: 0, drive_on: 1, drive_model: 3, drive_gain: 9, drive_mix: 0.5, delay_on: 1, delay_an_div: 5, delay_an_stereo: 2, delay_an_feedback: 0.35, delay_an_mix: 0.25 }),
  P("Dub Echo Chamber", "Delay", { drive_on: 1, drive_model: 1, drive_gain: 7, delay_on: 1, delay_an_div: 9, delay_an_feedback: 0.68, delay_an_drive: 8, delay_an_mod: 0.3, delay_an_filter: -0.35, delay_an_mix: 0.35, space_on: 1, space_type: 3, space_size: 2.2, space_mix: 0.2 }),
  P("Shimmer Halo", "Ambient", { delay_on: 1, delay_an_on: 0, delay_pi_on: 1, delay_pi_mix: 0.35, delay_pi_int_a: 12, delay_pi_int_b: 7, delay_pi_feedback: 0.55, space_on: 1, space_type: 5, space_size: 9, space_mix: 0.38, space_damp: 0.3, grain_on: 1, grain_mode: 1, grain_pitch: 5, grain_mix: 0.22 }),
  P("Glass Micro Loops", "Granular", { grain_on: 1, grain_mode: 1, grain_size: 120, grain_density: 0.6, grain_position: 0.35, grain_feedback: 0.4, grain_mix: 0.5, vibe_on: 1, vibe_ch_mode: 1, vibe_ch_mix: 0.4, space_on: 1, space_size: 4, space_mix: 0.25 }),
  P("Granular Fog", "Granular", { grain_on: 1, grain_size: 220, grain_density: 0.75, grain_jitter: 0.6, grain_reverse: 0.4, grain_mix: 0.55, grain_filter: -0.3, grain_spread: 0.9, space_on: 1, space_size: 6, space_mix: 0.3 }),
  P("Stutter Edit", "Rhythm", { chop_on: 1, chop_repeat: 0.35, chop_stutter: 2, chop_shuffle: 0.2, chop_reverse: 0.2, chop_pitch_amt: 0.1, drive_on: 1, drive_model: 2, drive_gain: 10 }),
  P("Half-Speed Flip", "Rhythm", { chop_on: 1, chop_size: 2, chop_slice: 0, chop_pitch_down: 1, chop_pitch_up: 0, chop_pitch_amt: 0.5, chop_glide: 0.4, chop_reverse: 0.3, chop_repeat: 0.1, chop_shuffle: 0.1, lofi_on: 1, lofi_mode: 0, lofi_crush: 0.3 }),
  P("Low-End Chop", "Rhythm", { chop_on: 1, chop_target: 1, chop_repeat: 0.5, chop_stutter: 3, chop_shuffle: 0.2, drive_on: 1, drive_gain: 8 }),
  P("Comb Sweep", "Spectral", { scan_on: 1, scan_shape: 1, scan_strength: 1, scan_smooth: 0.4, scan_lfo_rate: 0.15, scan_lfo_shape: 2, scan_lfo_mod1: 0.9, space_on: 1, space_type: 2, space_size: 2, space_mix: 0.2 }, [["scan", 0, mp.scan.phase]]),
  P("Spectral Smear Pad", "Spectral", { scan_on: 1, scan_mode: 1, scan_shape: 2, scan_strength: 0.9, scan_smooth: 0.7, space_on: 1, space_type: 5, space_size: 10, space_mix: 0.4, grain_on: 1, grain_mode: 1, grain_mix: 0.3 }),
  P("Ghost Gate", "Spectral", { scan_on: 1, scan_mode: 2, scan_shape: 5, scan_strength: 0.75, delay_on: 1, delay_an_on: 0, delay_pi_on: 1, delay_pi_int_a: -12, delay_pi_int_b: -12, delay_pi_mix: 0.3, space_on: 1, space_size: 5, space_mix: 0.3 }),
  P("Jet Flanger", "Modulation", { vibe_on: 1, vibe_ch_mode: 2, vibe_ch_feedback: 0.7, vibe_ch_rate: 0.15, vibe_ch_depth: 0.9, vibe_ch_mix: 0.5, vibe_ch_delay: 8, drive_on: 1, drive_model: 2, drive_gain: 8 }),
  P("Phase Ring", "Modulation", { vibe_on: 1, vibe_ch_on: 0, vibe_ph_on: 1, vibe_ph_mode: 3, vibe_ph_rate: 22, vibe_ph_feedback: 0.6, vibe_ph_depth: 0.6, vibe_ph_mix: 0.8 }),
  P("Lush 80s Keys", "Modulation", { vibe_on: 1, vibe_ch_mode: 1, vibe_ch_mix: 0.5, vibe_ch_depth: 0.6, delay_on: 1, delay_an_mix: 0.22, delay_an_feedback: 0.35, space_on: 1, space_size: 3.5, space_mix: 0.26, space_predelay: 30 }),
  P("Wobble Drive", "Drive", { drive_on: 1, drive_gain: 22, drive_character: 0.6, drive_lfo_sync: 1, drive_lfo_div: 4, drive_lfo_shape: 1, drive_lfo_mod1: 0.6, space_on: 1, space_type: 0, space_size: 0.8, space_mix: 0.15 }, [["drive", 0, mp.drive.gain]]),
  P("Radio Transmission", "Lofi", { lofi_on: 1, lofi_mode: 2, lofi_crush: 0.4, lofi_rate: 9e3, lofi_bits: 10, lofi_noise: 3, lofi_noise_level: 0.22, filter: 0.45, drive_on: 1, drive_model: 2, drive_gain: 12, vibe_on: 1, vibe_ch_on: 0, vibe_ph_on: 1, vibe_ph_rate: 0.2, vibe_ph_mix: 0.5 }),
  P("Fuzz Wall", "Drive", { drive_on: 1, drive_model: 2, drive_gain: 32, drive_boost: 1, drive_tone: 0.2, drive_headroom: 0.7, space_on: 1, space_type: 4, space_size: 1.5, space_mix: 0.15 }),
  P("Folded Bells", "Drive", { drive_on: 1, drive_model: 3, drive_gain: 18, drive_mix: 0.6, drive_tone: 0.3, delay_on: 1, delay_an_stereo: 2, delay_an_mix: 0.3, space_on: 1, space_type: 2, space_size: 3, space_mix: 0.25 })
];
var SUB_PRESETS = [
  // drive
  [
    P("Gentle Warmth", "", { drive_model: 0, drive_gain: 6, drive_character: 0.2 }),
    P("Tube Push", "", { drive_model: 0, drive_gain: 16, drive_character: 0.5 }),
    P("Tape Saturation", "", { drive_model: 1, drive_gain: 14, drive_tone: -0.2 }),
    P("Op-Amp Crunch", "", { drive_model: 2, drive_gain: 18, drive_boost: 1 }),
    P("Fuzz Wall", "", { drive_model: 2, drive_gain: 32, drive_boost: 1, drive_headroom: 0.7 }),
    P("Wavefolder", "", { drive_model: 3, drive_gain: 16, drive_mix: 0.7 })
  ],
  // lofi
  [
    P("Fresh Cassette", "", { lofi_mode: 1, lofi_type: 0, lofi_crush: 0.1, lofi_wow: 0.15, lofi_flutter: 0.2, lofi_noise_level: 0.1 }),
    P("Worn Tape", "", { lofi_mode: 1, lofi_type: 1, lofi_crush: 0.35, lofi_wow: 0.45, lofi_flutter: 0.4, lofi_dropouts: 0.2, lofi_noise_level: 0.3 }),
    P("Old Sampler", "", { lofi_mode: 0, lofi_crush: 0.45, lofi_bits: 12, lofi_noise: 1, lofi_noise_level: 0.2 }),
    P("8-Bit", "", { lofi_mode: 2, lofi_crush: 0.85, lofi_bits: 8, lofi_noise_level: 0 }),
    P("Vinyl Dust", "", { lofi_mode: 0, lofi_crush: 0.15, lofi_noise: 1, lofi_noise_level: 0.45, lofi_duck: 1, lofi_wear: 0.4 }),
    P("Broken Walkman", "", { lofi_mode: 1, lofi_type: 3, lofi_crush: 0.5, lofi_wow: 0.8, lofi_dropouts: 0.6 })
  ],
  // chop
  [
    P("Basic Repeat", "", { chop_repeat: 0.4, chop_shuffle: 0, chop_reverse: 0, chop_pitch_amt: 0 }),
    P("Stutter Roll", "", { chop_repeat: 0.5, chop_stutter: 2, chop_shuffle: 0, chop_reverse: 0 }),
    P("Reverse Flips", "", { chop_reverse: 0.45, chop_repeat: 0.1, chop_shuffle: 0, chop_pitch_amt: 0 }),
    P("Octave Jumps", "", { chop_pitch_up: 1, chop_pitch_down: 1, chop_pitch_amt: 0.45, chop_glide: 0.2, chop_repeat: 0.1 }),
    P("Tape Stops", "", { chop_stretch: 0.3, chop_repeat: 0.1, chop_shuffle: 0 }),
    P("Chaos", "", { chop_repeat: 0.3, chop_shuffle: 0.3, chop_reverse: 0.3, chop_pitch_amt: 0.3, chop_chaos: 0.8, chop_lock: 0 })
  ],
  // vibe
  [
    P("Clean Chorus", "", { vibe_ch_on: 1, vibe_ch_mode: 0, vibe_ph_on: 0 }),
    P("Lush Ensemble", "", { vibe_ch_on: 1, vibe_ch_mode: 1, vibe_ch_depth: 0.7, vibe_ch_width: 1, vibe_ph_on: 0 }),
    P("Jet Flange", "", { vibe_ch_on: 1, vibe_ch_mode: 2, vibe_ch_feedback: 0.7, vibe_ch_rate: 0.15, vibe_ch_depth: 0.9, vibe_ph_on: 0 }),
    P("Vintage Chorus", "", { vibe_ch_on: 1, vibe_ch_mode: 3, vibe_ch_mix: 0.5, vibe_ph_on: 0 }),
    P("Slow Phase", "", { vibe_ch_on: 0, vibe_ph_on: 1, vibe_ph_mode: 0, vibe_ph_rate: 0.2, vibe_ph_feedback: 0.4 }),
    P("Ring Phase", "", { vibe_ch_on: 0, vibe_ph_on: 1, vibe_ph_mode: 3, vibe_ph_rate: 25, vibe_ph_feedback: 0.6 })
  ],
  // grain
  [
    P("Cloud", "", { grain_size: 160, grain_density: 0.6, grain_jitter: 0.4 }),
    P("Octave Shimmer", "", { grain_mode: 1, grain_pitch: 5, grain_feedback: 0.35 }),
    P("Reverse Haze", "", { grain_reverse: 0.7, grain_size: 250, grain_density: 0.55 }),
    P("Crystal Loops", "", { grain_mode: 1, grain_size: 100, grain_feedback: 0.45, grain_mix: 0.5 }),
    P("Sub Grains", "", { grain_pitch: 1, grain_filter: -0.4, grain_size: 140 })
  ],
  // delay
  [
    P("Quarter Note", "", { delay_an_on: 1, delay_pi_on: 0, delay_an_div: 8, delay_an_feedback: 0.4 }),
    P("Dotted Ping-Pong", "", { delay_an_on: 1, delay_pi_on: 0, delay_an_div: 6, delay_an_stereo: 2 }),
    P("Dub Throw", "", { delay_an_on: 1, delay_pi_on: 0, delay_an_div: 9, delay_an_feedback: 0.7, delay_an_drive: 10, delay_an_filter: -0.4 }),
    P("Tape Whip", "", { delay_an_on: 1, delay_pi_on: 0, delay_an_sync: 0, delay_an_time: 420, delay_an_mod: 0.6, delay_an_rate: 0.3 }),
    P("Pitch Climb", "", { delay_an_on: 0, delay_pi_on: 1, delay_pi_int_a: 12, delay_pi_int_b: 7 }),
    P("Octave Down Echo", "", { delay_an_on: 0, delay_pi_on: 1, delay_pi_int_a: -12, delay_pi_int_b: -12 })
  ],
  // scan
  [
    P("Comb Filter", "", { scan_mode: 0, scan_shape: 1, scan_strength: 0.9 }),
    P("Fine Comb", "", { scan_mode: 0, scan_shape: 2, scan_strength: 0.9 }),
    P("Smear Wash", "", { scan_mode: 1, scan_shape: 1, scan_smooth: 0.7 }),
    P("Spectral Gate", "", { scan_mode: 2, scan_shape: 5, scan_strength: 0.75 }),
    P("Saw Mask", "", { scan_mode: 0, scan_shape: 3, scan_strength: 1 }),
    P("Draw Your Own", "", { scan_mode: 0, scan_shape: 8, scan_strength: 1 })
  ],
  // space
  [
    P("Small Room", "", { space_type: 0, space_size: 0.7, space_mix: 0.18 }),
    P("Big Hall", "", { space_type: 1, space_size: 3.5, space_mix: 0.25 }),
    P("Bright Plate", "", { space_type: 2, space_size: 2.2, space_damp: 0.15, space_tilt: 0.25 }),
    P("Spring Tank", "", { space_type: 3, space_size: 2, space_mix: 0.25 }),
    P("Chamber", "", { space_type: 4, space_size: 1.6 }),
    P("Cathedral", "", { space_type: 5, space_size: 9, space_mix: 0.35, space_predelay: 40 })
  ]
];
var FOCUS_BY_CATEGORY = {
  Init: "delay",
  Mix: "drive",
  Drive: "drive",
  Lofi: "lofi",
  Rhythm: "chop",
  Modulation: "vibe",
  Granular: "grain",
  Delay: "delay",
  Ambient: "delay",
  Spectral: "scan"
};
var focusFor = (def) => def.category in FOCUS_BY_CATEGORY ? MODULES.indexOf(FOCUS_BY_CATEGORY[def.category]) : -1;
var LIMITS = {
  drive_gain: [4, 26],
  drive_headroom: [0.5, 1],
  drive_mix: [0.6, 1],
  lofi_mix: [0.6, 1],
  lofi_crush: [0, 0.75],
  lofi_noise_level: [0, 0.4],
  lofi_dropouts: [0, 0.35],
  lofi_wow: [0, 0.6],
  lofi_bits: [6, 16],
  chop_mix: [0.7, 1],
  chop_repeat: [0, 0.45],
  chop_shuffle: [0, 0.45],
  chop_reverse: [0, 0.45],
  chop_pitch_amt: [0, 0.45],
  chop_stretch: [0, 0.25],
  chop_chaos: [0, 0.4],
  vibe_ch_mix: [0.3, 0.8],
  vibe_ph_mix: [0.3, 0.8],
  vibe_ch_feedback: [0, 0.6],
  vibe_ph_rate: [0.05, 3],
  vibe_ph_feedback: [-0.7, 0.7],
  grain_mix: [0.2, 0.6],
  grain_feedback: [0, 0.5],
  delay_an_mix: [0.15, 0.45],
  delay_an_feedback: [0.2, 0.7],
  delay_pi_mix: [0.15, 0.45],
  delay_pi_feedback: [0.2, 0.65],
  delay_an_drive: [0, 10],
  scan_strength: [0.4, 1],
  scan_mix: [0.6, 1],
  space_mix: [0.12, 0.45],
  space_size: [0.8, 8]
};
var USER_KEY = "cymatics-xray.user-presets";
function readUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "{}") || {};
  } catch {
    return {};
  }
}
function writeUser(obj) {
  try {
    localStorage.setItem(USER_KEY, JSON.stringify(obj));
    return true;
  } catch {
    return false;
  }
}
var RandomMode = { active: 0, module: 1, generate: 2 };
var PresetManager = class {
  constructor(proc2) {
    this.proc = proc2;
    this.subIndex = new Array(8).fill(-1);
    this.history = [];
    this.randomMode = RandomMode.active;
  }
  // ---- full presets (factory + user, browsed as one list)
  factory() {
    return FACTORY;
  }
  userPresets() {
    return Object.keys(readUser()).sort((a, b) => a.localeCompare(b));
  }
  count() {
    return FACTORY.length + this.userPresets().length;
  }
  nameAt(i) {
    return this.isFactory(i) ? FACTORY[i].name : this.userPresets()[i - FACTORY.length];
  }
  isFactory(i) {
    return i < FACTORY.length;
  }
  currentIndex() {
    const proc2 = this.proc, n = this.count();
    for (let i = 0; i < n; ++i)
      if (this.nameAt(i) === proc2.presetName && this.isFactory(i) === (proc2.presetBank === "FACTORY")) return i;
    return -1;
  }
  setReal(id, value) {
    this.proc.setValue(id, value);
  }
  applyDef(def, resetEverything) {
    const proc2 = this.proc;
    if (resetEverything) {
      const lockPitch = proc2.getRaw("pitch_lock") > 0.5;
      for (const [id, p] of ALL_PARAMS) {
        if (lockPitch && (id === "pitch" || id === "pitch_lock")) continue;
        proc2.setValue(id, p.def);
      }
      for (let m = 0; m < 8; ++m) {
        this.setReal(`${MODULES[m]}_on`, 0);
        proc2.setModMask(m, 0, 0);
        proc2.setModMask(m, 1, 0);
        if (proc2.motion(m).playing) {
          proc2.motion(m).playing = false;
          proc2.pushMotion(m);
        }
      }
      proc2.setChainOrder(def.order ? def.order.split(",").map((k) => MODULES.indexOf(k.trim())) : []);
    }
    for (const [id, value] of Object.entries(def.values)) this.setReal(id, value);
    for (const [key2, lane, index] of def.mods) {
      const m = MODULES.indexOf(key2);
      proc2.setModMask(m, lane, proc2.getModMask(m, lane) | 1 << index);
    }
  }
  load(index) {
    const proc2 = this.proc;
    if (index < 0 || index >= this.count()) return;
    if (this.isFactory(index)) {
      this.applyDef(FACTORY[index], true);
      proc2.presetBank = "FACTORY";
      proc2.focusModule = focusFor(FACTORY[index]);
    } else {
      proc2.focusModule = -1;
      const state2 = readUser()[this.nameAt(index)];
      if (state2) proc2.restoreState(state2, true);
      proc2.presetBank = "USER";
    }
    proc2.presetName = this.nameAt(index);
    this.subIndex.fill(-1);
    proc2.changed();
  }
  step(direction) {
    const n = this.count();
    if (n === 0) return;
    const cur = this.currentIndex();
    this.load(((cur < 0 ? 0 : cur + direction) % n + n) % n);
  }
  saveUser(name) {
    const clean = String(name || "").trim().replace(/[\\/:*?"<>|]/g, "").slice(0, 64);
    if (!clean) return false;
    const proc2 = this.proc;
    proc2.presetName = clean;
    proc2.presetBank = "USER";
    const all = readUser();
    all[clean] = proc2.captureState();
    proc2.changed();
    return writeUser(all);
  }
  // ---- per-module sub-presets
  subPresets(m) {
    return SUB_PRESETS[m];
  }
  currentSub(m) {
    return this.subIndex[m];
  }
  loadSub(m, index) {
    const subs = SUB_PRESETS[m];
    if (!subs.length) return;
    index = (index % subs.length + subs.length) % subs.length;
    const def = moduleDef(m);
    for (let i = 1; i < def.params.length; ++i) this.proc.setValue(def.params[i].id, def.params[i].def);
    this.applyDef(subs[index], false);
    this.setReal(`${MODULES[m]}_on`, 1);
    this.subIndex[m] = index;
  }
  // ---- randomizer
  randomizeModule(m, rng) {
    const def = moduleDef(m);
    for (let i = 1; i < def.params.length; ++i) {
      const pd = def.params[i];
      if (pd.id === "scan_frame" || pd.id === "chop_lock") continue;
      const p = this.proc.param(m, i);
      let norm = rng();
      const lim = LIMITS[pd.id];
      if (lim) norm = p.convertTo0to1(lim[0] + rng() * (lim[1] - lim[0]));
      if (pd.kind === "bool" && pd.group > 0 && pd.cell === false) norm = rng() < 0.6 ? 1 : 0;
      p.setValueNotifyingHost(norm);
    }
  }
  randomize(mode, current) {
    const proc2 = this.proc, rng = Math.random;
    const nextInt = (n) => Math.min(n - 1, Math.floor(rng() * n));
    if (mode === RandomMode.module) {
      this.randomizeModule(current, rng);
      this.setReal(`${MODULES[current]}_on`, 1);
      return;
    }
    if (mode === RandomMode.active) {
      for (let m = 0; m < 8; ++m) if (proc2.isModuleOn(m)) this.randomizeModule(m, rng);
      return;
    }
    this.history.push(proc2.captureState());
    if (this.history.length > 10) this.history.shift();
    const on = new Array(8).fill(false);
    let count = 0;
    while (count < 2) {
      count = 0;
      for (let m = 0; m < 8; ++m) {
        const chance = MODULES[m] === "space" ? 0.7 : MODULES[m] === "drive" ? 0.55 : 0.32;
        on[m] = rng() < chance;
        count += on[m] ? 1 : 0;
      }
    }
    for (let m = 0; m < 8; ++m) {
      this.setReal(`${MODULES[m]}_on`, on[m] ? 1 : 0);
      proc2.setModMask(m, 0, 0);
      proc2.setModMask(m, 1, 0);
      if (on[m]) this.randomizeModule(m, rng);
    }
    const active = [];
    for (let m = 0; m < 8; ++m) if (on[m]) active.push(m);
    const target = active[nextInt(active.length)];
    const def = moduleDef(target);
    const candidates = [];
    for (let i = 2; i < def.params.length; ++i) if (def.params[i].kind === "float" && def.params[i].cell) candidates.push(i);
    if (candidates.length) {
      const idx = candidates[nextInt(candidates.length)];
      proc2.setModMask(target, 0, 1 << idx);
      const k = MODULES[target];
      this.setReal(`${k}_lfo_mod1`, (rng() < 0.5 ? 1 : -1) * (0.2 + 0.4 * rng()));
      this.setReal(`${k}_lfo_rate`, 0.1 + 2 * rng() * rng());
      this.setReal(`${k}_lfo_shape`, nextInt(8));
    }
    let o = ["drive", "lofi", "chop", "vibe", "scan", "grain", "delay", "space"].map((k) => MODULES.indexOf(k));
    for (let k = 7; k > 0; --k) {
      const j = nextInt(k + 1);
      [o[k], o[j]] = [o[j], o[k]];
    }
    if (rng() < 0.8) {
      const drive = MODULES.indexOf("drive"), space = MODULES.indexOf("space");
      o = [drive, ...o.filter((m) => m !== drive && m !== space), space];
    }
    proc2.setChainOrder(o);
    proc2.focusModule = -1;
    proc2.presetName = `Generated ${this.history.length}`;
    proc2.presetBank = "RANDOM";
    proc2.changed();
  }
  historySize() {
    return this.history.length;
  }
  restoreHistory(i) {
    if (i < 0 || i >= this.history.length) return;
    this.proc.restoreState(this.history[i], true);
  }
};

// xray-demo-stage/src/app/device.js
function meterNorm(amp, floorDb = -60, topDb = 6) {
  const db = amp > 1e-6 ? 20 * Math.log10(amp) : -120;
  return Math.max(0, Math.min(1, (db - floorDb) / (topDb - floorDb)));
}
function chevron(ctx, c, up, size, col) {
  const d = up ? -size * 0.5 : size * 0.5;
  ctx.beginPath();
  ctx.moveTo(c.x - size, c.y - d);
  ctx.lineTo(c.x, c.y + d);
  ctx.lineTo(c.x + size, c.y - d);
  ctx.strokeStyle = col;
  ctx.lineWidth = 1.5;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  ctx.stroke();
}
function toggleParam(p) {
  if (!p) return;
  p.setValueNotifyingHost(p.getValue() > 0.5 ? 0 : 1);
}
function screenRect(root, r) {
  const b = root.canvas.getBoundingClientRect();
  return { left: b.left + r.x * root.scale, top: b.top + r.y * root.scale, right: b.left + (r.x + r.w) * root.scale, bottom: b.top + (r.y + r.h) * root.scale };
}
function localToDevice(c, r) {
  const o = c.devicePos();
  return { x: r.x + o.x, y: r.y + o.y, w: r.w, h: r.h };
}
var ModuleKeys = class extends Component {
  constructor(proc2) {
    super();
    this.proc = proc2;
    this.onSelect = null;
    this.selected = 0;
    this.hover = -1;
    this.hoverToggle = false;
    this.clipsChildren = false;
  }
  static boundsOnDevice() {
    const r = expanded(union(key(0), key(7)), keyMargin);
    return { x: Math.floor(r.x), y: Math.floor(r.y), w: Math.ceil(r.w), h: Math.ceil(r.h) };
  }
  setSelected(m) {
    this.selected = m;
  }
  key(i) {
    const k = key(i);
    return { x: k.x - this.x, y: k.y - this.y, w: k.w, h: k.h };
  }
  toggle(i) {
    const c = keyLight(i);
    return withCentre(keyLightBezel * 2, keyLightBezel * 2, { x: c.x - this.x, y: c.y - this.y });
  }
  overToggle(i, x, y) {
    return contains(expanded(this.toggle(i), 9), x, y);
  }
  refresh() {
  }
  paint(ctx) {
    ctx.imageSmoothingQuality = "high";
    for (let i = 0; i < 8; ++i) {
      const r = this.key(i);
      const on = this.proc.isModuleOn(i);
      if (i === this.selected) {
        const e = expanded(r, keyMargin);
        ctx.drawImage(keyPressedImage(i), e.x, e.y, e.w, e.h);
      } else if (this.hover === i) {
        fillRoundRect(ctx, r.x + 1, r.y + 1, r.w - 2, r.h - 2, keyRadius, "rgba(0,0,0,0.018)");
      }
      if (on) {
        const half = keyLightSprite, c = centre(this.toggle(i));
        ctx.drawImage(keyLightImage(i, i === this.selected), c.x - half, c.y - half, half * 2, half * 2);
      }
      drawTrackedIn(
        ctx,
        TITLES[i],
        { x: r.x + 16, y: r.y + r.h - 30, w: r.w - 20, h: 16 },
        sans(11.5, "semibold"),
        on ? ink.primary : ink.tertiary,
        0.1,
        "left"
      );
    }
  }
  mouseDown(e) {
    for (let i = 0; i < 8; ++i) {
      if (!contains(this.key(i), e.x, e.y)) continue;
      if (e.mods.right || this.overToggle(i, e.x, e.y)) toggleParam(this.proc.param(i, 0));
      else this.onSelect?.(i);
      return;
    }
  }
  mouseMove(e) {
    let now = -1;
    for (let i = 0; i < 8; ++i) if (contains(this.key(i), e.x, e.y)) now = i;
    const onToggle = now >= 0 && this.overToggle(now, e.x, e.y);
    this.cursor = now >= 0 ? "pointer" : null;
    if (now !== this.hover || onToggle !== this.hoverToggle) {
      this.hover = now;
      this.hoverToggle = onToggle;
      const name = now < 0 ? "" : titleCase(TITLES[now]);
      this.showInfo(now < 0 ? "" : onToggle ? `Switch ${name} on or off.` : `${name}: click to open it. Click its light to turn it on or off.`);
    }
  }
  mouseExit() {
    this.hover = -1;
    this.hoverToggle = false;
    this.showInfo("");
  }
};
var Scope = class extends Component {
  constructor(proc2) {
    super();
    this.proc = proc2;
    this.window = 1024;
    this.startWindow = 1024;
    this.buffer = new Float32Array(8e3);
    this.shown = new Float32Array(4e3);
    this.shownN = 0;
    this.cursor = "ew-resize";
  }
  refresh() {
    const n = Math.max(128, Math.min(4e3, this.window));
    const buf = this.buffer.subarray(0, n * 2);
    this.proc.analysis.global.out.readLatest(buf, n * 2);
    let start = n;
    for (let k = n; k > 1; --k) if (buf[k - 1] < 0 && buf[k] >= 0) {
      start = k;
      break;
    }
    start = Math.min(start, n);
    this.shown.set(buf.subarray(start, start + n));
    this.shownN = n;
  }
  paint(ctx) {
    const r = { x: 0, y: 0, w: this.w, h: this.h };
    ctx.save();
    roundRect(ctx, 0, 0, r.w, r.h, scopeRadius);
    ctx.clip();
    const label = () => drawTrackedIn(ctx, "OUT", { x: 10, y: 7, w: r.w - 20, h: 12 }, sans(9, "semibold"), colours.textFaint, 0.08, "left");
    const n = this.shownN;
    if (n === 0) {
      label();
      ctx.restore();
      return;
    }
    let peak = 0.05;
    for (let i = 0; i < n; ++i) peak = Math.max(peak, Math.abs(this.shown[i]));
    const area = { x: 10, y: 14 + 4, w: r.w - 20, h: r.h - 28 - 4 };
    const p = new Path2D();
    const step = Math.max(1, Math.floor(n / area.w));
    const cy = area.y + area.h / 2;
    for (let i = 0; i < n; i += step) {
      const x = area.x + area.w * i / (n - 1);
      const y = cy - this.shown[i] / peak * area.h * 0.42;
      if (i === 0) p.moveTo(x, y);
      else p.lineTo(x, y);
    }
    drawSpectrumLine(ctx, p, area.x, area.x + area.w, 0, 1, 1.3, 5);
    label();
    ctx.restore();
    drawGlassSheen(ctx, 0, 0, r.w, r.h, scopeRadius, 0.8);
  }
  mouseDown() {
    this.startWindow = this.window;
  }
  mouseDrag(e) {
    this.window = Math.max(128, Math.min(4e3, Math.trunc(this.startWindow * Math.pow(2, -e.dx / 60))));
  }
  mouseEnter() {
    this.showInfo("Oscilloscope of the output. Drag left or right to zoom the time window.");
  }
  mouseExit() {
    this.showInfo("");
  }
};
var METER_COLOURS = Array.from({ length: meterSegments }, (_, k) => oklch(0.72, 0.2, (157 - 162 * k / (meterSegments - 1) + 360) % 360));
var OutputMeter = class extends Component {
  constructor(proc2) {
    super();
    this.proc = proc2;
    this.gain = proc2.global("out_gain");
    this.l = 0;
    this.r = 0;
    this.holdL = 0;
    this.holdR = 0;
    this.dragStart = 0;
    this.hot = false;
    this.cursor = "ns-resize";
  }
  static boundsOnDevice() {
    const m = meter;
    const r = withCentre(64, m.h + 34, { x: m.x + m.w / 2, y: m.y + m.h / 2 + 11 });
    return { x: Math.round(r.x), y: Math.round(r.y), w: Math.round(r.w), h: Math.round(r.h) };
  }
  slot() {
    return { x: meter.x - this.x, y: meter.y - this.y, w: meter.w, h: meter.h };
  }
  refresh() {
    const follow = (v, hold, target) => [v + (target > v ? 0.6 : 0.12) * (target - v), target > hold ? target : hold - 4e-3];
    const g = this.proc.analysis.global;
    [this.l, this.holdL] = follow(this.l, this.holdL, meterNorm(g.outPeakL));
    [this.r, this.holdR] = follow(this.r, this.holdR, meterNorm(g.outPeakR));
  }
  paint(ctx) {
    const s = this.slot();
    const pitch = (s.h - 12) / meterSegments;
    for (let ch = 0; ch < 2; ++ch) {
      const v = ch === 0 ? this.l : this.r, hold = ch === 0 ? this.holdL : this.holdR;
      const lit = Math.floor(v * meterSegments + 0.5);
      const held = Math.max(0, Math.min(meterSegments - 1, Math.floor(hold * meterSegments)));
      for (let k = 0; k < meterSegments; ++k) {
        if (k >= lit && !(k === held && hold > 0.02)) continue;
        const cx = s.x + 3.2 + ch * 5.6, cy = s.y + s.h - 6 - k * pitch;
        fillRoundRect(ctx, cx - 1.8, cy - 2.3, 3.6, 4.6, 0.8, rgba(METER_COLOURS[k], k < lit ? 1 : 0.7));
      }
    }
    const hot = this.hot || this.root().down?.target === this;
    const gy = s.y + s.h - s.h * this.gain.getValue();
    const sr = s.x + s.w;
    ctx.beginPath();
    ctx.moveTo(sr + 8, gy - 3.5);
    ctx.lineTo(sr + 8, gy + 3.5);
    ctx.lineTo(sr + 3, gy);
    ctx.closePath();
    ctx.fillStyle = hot ? ink.secondary : ink.tertiary;
    ctx.fill();
    const label = withCentre(this.w, 14, { x: s.x + s.w / 2, y: s.y + s.h + 14 });
    if (hot) drawTextIn(ctx, this.gain.getCurrentValueAsText(), label, sans(9.5, "medium"), ink.secondary, "centre");
    else drawTrackedIn(ctx, "OUT", label, sans(8.5, "semibold"), ink.tertiary, 0.2, "centre");
  }
  mouseDown() {
    this.dragStart = this.gain.getValue();
  }
  mouseDrag(e) {
    this.gain.setValueNotifyingHost(Math.max(0, Math.min(1, this.dragStart - e.dy / this.slot().h)));
  }
  mouseDoubleClick() {
    this.gain.setValueNotifyingHost(this.gain.getDefaultValue());
  }
  mouseEnter() {
    this.hot = true;
    this.showInfo("Output meter. Drag it up or down to set the output gain. Double-click resets it.");
  }
  mouseExit() {
    this.hot = false;
    this.showInfo("");
  }
};
var ROT_START = Math.PI * 1.25;
var ROT_END = Math.PI * 2.75;
var GlobalKnob = class extends Component {
  constructor(proc2, paramId, label, help, bipolar, big) {
    super();
    this.param = proc2.global(paramId);
    this.label = label;
    this.help = help;
    this.bipolar = bipolar;
    this.big = big;
    this.hot = false;
    this.start = 0;
    this.clipsChildren = false;
  }
  placeAt(c) {
    const half = this.big ? dialRadius + 15 : smallKnobRadius + 9;
    this.setBounds(Math.round(c.x - half), Math.round(c.y - half), Math.round(half * 2), Math.round(half * 2 + (this.big ? 44 : 26)));
  }
  // only the dial itself takes the mouse
  hitTest(x, y) {
    return Math.hypot(x - this.w / 2, y - this.w / 2) <= this.w * 0.5 - 2;
  }
  dragging() {
    return this.root().down?.target === this;
  }
  paint(ctx) {
    const c = { x: this.w / 2, y: this.w / 2 };
    const big = this.big;
    const body = big ? dialRadius : smallKnobRadius;
    const pos = this.param.getValue();
    const angle = ROT_START + pos * (ROT_END - ROT_START);
    const from = this.bipolar ? (ROT_START + ROT_END) * 0.5 : ROT_START;
    const ticks = big ? 41 : 21;
    const r0 = body + (big ? 9 : 5), r1 = body + (big ? 15 : 9);
    ctx.lineCap = "butt";
    for (let i = 0; i < ticks; ++i) {
      const t = i / (ticks - 1);
      const a = ROT_START + (ROT_END - ROT_START) * t;
      const lit = a >= Math.min(from, angle) - 1e-3 && a <= Math.max(from, angle) + 1e-3;
      strokeLine(
        ctx,
        c.x + r0 * Math.sin(a),
        c.y - r0 * Math.cos(a),
        c.x + r1 * Math.sin(a),
        c.y - r1 * Math.cos(a),
        lit ? spectrumInk(t) : "rgba(176,176,181,0.6)",
        big ? 1.4 : 1.1
      );
    }
    const p0 = big ? 18.6 : 5, p1 = big ? 55.8 : 14.9;
    strokeLine(
      ctx,
      c.x + p0 * Math.sin(angle),
      c.y - p0 * Math.cos(angle),
      c.x + p1 * Math.sin(angle),
      c.y - p1 * Math.cos(angle),
      ink.primary,
      big ? 3 : 2.2,
      "round"
    );
    const w = this.w, top = w * 0.5 + body;
    const hot = this.hot || this.dragging();
    const value = this.param.getCurrentValueAsText();
    if (big) {
      drawTrackedIn(ctx, this.label.toUpperCase(), { x: 0, y: top + 19, w, h: 14 }, sans(10.5, "semibold"), ink.secondary, 0.24, "centre");
      drawTextIn(ctx, value, { x: 0, y: top + 33, w, h: 20 }, sans(15, "medium"), ink.primary, "centre");
      return;
    }
    drawTextIn(ctx, hot ? value : this.label, { x: -12, y: top + 15, w: w + 24, h: 14 }, sans(10.5, "medium"), hot ? ink.primary : ink.secondary, "centre");
  }
  mouseDown() {
    this.start = this.param.getValue();
  }
  mouseDrag(e) {
    const sens = (this.big ? 320 : 220) * (e.mods.shift ? 4 : 1);
    this.param.setValueNotifyingHost(Math.max(0, Math.min(1, this.start + (e.dx - e.dy) / sens)));
  }
  mouseDoubleClick() {
    this.param.setValueNotifyingHost(this.param.getDefaultValue());
  }
  mouseWheel(e) {
    this.param.setValueNotifyingHost(Math.max(0, Math.min(1, this.param.getValue() + e.wheelY * 0.05)));
  }
  mouseEnter() {
    this.hot = true;
    this.showInfo(this.help);
  }
  mouseExit() {
    this.hot = false;
    this.showInfo("");
  }
};
var ValueField = class extends Component {
  constructor(proc2, paramId, label, help) {
    super();
    this.param = proc2.global(paramId);
    this.label = label;
    this.help = help;
    this.isSwitch = this.param.def.kind === "bool";
    this.hot = false;
    this.moved = false;
    this.start = 0;
    this.cursor = this.isSwitch ? "pointer" : "ns-resize";
  }
  valueText() {
    return capitalised(this.param.getCurrentValueAsText());
  }
  refresh() {
  }
  paint(ctx) {
    const r = { x: 0, y: 0, w: this.w, h: this.h };
    const hot = this.hot || this.root().down?.target === this;
    if (this.isSwitch) {
      const on = this.param.getValue() > 0.5;
      const f2 = sans(11, on ? "medium" : "regular");
      const col = on || hot ? ink.primary : ink.secondary;
      drawTextIn(ctx, this.label, r, f2, col, "left");
      if (on) {
        const x = textWidth(ctx, this.label, sans(11, "medium")) + 5;
        fillEllipse(ctx, x, r.h / 2 - 2, 4, 4, col);
      }
      return;
    }
    const lf = sans(11);
    drawTextIn(ctx, this.label, r, lf, hot ? ink.primary : ink.secondary, "left");
    const lw = textWidth(ctx, this.label, lf) + 7;
    drawTextIn(ctx, this.valueText(), { x: lw, y: 0, w: r.w - lw, h: r.h }, sans(11.5, "medium"), ink.primary, "left");
  }
  mouseDown() {
    this.moved = false;
    this.start = this.param.getValue();
  }
  mouseDrag(e) {
    if (this.isSwitch || Math.abs(e.dy) < 3) return;
    this.moved = true;
    this.param.setValueNotifyingHost(Math.max(0, Math.min(1, this.start - e.dy / 180)));
  }
  mouseUp() {
    if (this.isSwitch) toggleParam(this.param);
  }
  mouseDoubleClick() {
    if (!this.isSwitch) this.param.setValueNotifyingHost(this.param.getDefaultValue());
  }
  mouseEnter() {
    this.hot = true;
    this.showInfo(this.help);
  }
  mouseExit() {
    this.hot = false;
    this.showInfo("");
  }
};
var PillButton = class extends Component {
  constructor(text, help, style2 = "outlined") {
    super();
    this.text = text;
    this.help = help;
    this.style = style2;
    this.icon = "none";
    this.lit = false;
    this.alarm = false;
    this.dimmed = false;
    this.hot = false;
    this.onClick = null;
    this.cursor = "pointer";
  }
  setText(t) {
    this.text = t;
  }
  setLit(l) {
    this.lit = l;
  }
  setIcon(i) {
    this.icon = i;
  }
  setAlarm(a) {
    this.alarm = a;
  }
  setDimmed(d) {
    this.dimmed = d;
    this.cursor = d ? null : "pointer";
  }
  preferredWidth(ctx) {
    return textWidth(ctx, this.text, sans(11, "medium")) + 22 + (this.icon !== "none" ? 14 : 0);
  }
  paint(ctx) {
    const r = { x: 0.5, y: 0.5, w: this.w - 1, h: this.h - 1 };
    const rad = r.h * 0.5;
    const hot = this.hot && !this.dimmed;
    let fg;
    if (this.lit) {
      fillRoundRect(ctx, r.x, r.y, r.w, r.h, rad, hot ? brighter(ink.primary, 0.15) : ink.primary);
      fg = "#ffffff";
    } else if (this.alarm) {
      fillRoundRect(ctx, r.x, r.y, r.w, r.h, rad, "rgba(255,69,58,0.07)");
      strokeRoundRect(ctx, r.x, r.y, r.w, r.h, rad, "rgba(255,69,58,0.55)", 1);
      fg = colours.record;
    } else if (this.style === "filled") {
      fillRoundRect(ctx, r.x, r.y, r.w, r.h, rad, hot ? "rgba(0,0,0,0.075)" : ink.fill);
      fg = this.dimmed ? ink.tertiary : ink.primary;
    } else {
      if (hot) fillRoundRect(ctx, r.x, r.y, r.w, r.h, rad, ink.fill);
      strokeRoundRect(ctx, r.x, r.y, r.w, r.h, rad, this.dimmed ? "rgba(0,0,0,0.052)" : ink.hair, 1);
      fg = this.dimmed ? ink.tertiary : hot ? ink.primary : ink.secondary;
    }
    const f2 = sans(11, "medium");
    const tw = textWidth(ctx, this.text, f2);
    const iconW = this.icon !== "none" ? 14 : 0;
    let x = r.x + r.w / 2 - (tw + iconW) * 0.5;
    const cy = r.y + r.h / 2;
    if (this.icon === "play") {
      ctx.beginPath();
      ctx.moveTo(x, cy - 4);
      ctx.lineTo(x, cy + 4);
      ctx.lineTo(x + 7, cy);
      ctx.closePath();
      ctx.fillStyle = fg;
      ctx.fill();
      x += iconW;
    }
    drawTextIn(ctx, this.text, { x, y: r.y, w: tw + 2, h: r.h }, f2, fg, "left");
    if (this.icon === "chevronUp" || this.icon === "chevronDown") chevron(ctx, { x: x + tw + 9, y: cy }, this.icon === "chevronUp", 3.6, fg);
  }
  mouseUp(e) {
    if (this.onClick && !this.dimmed && this.contains(e.x, e.y)) this.onClick(e);
  }
  mouseEnter() {
    this.hot = true;
    this.showInfo(this.help);
  }
  mouseExit() {
    this.hot = false;
    this.showInfo("");
  }
};
var Segmented = class extends Component {
  constructor(items, help) {
    super();
    this.items = items;
    this.help = help;
    this.selected = 0;
    this.onChange = null;
    this.cursor = "pointer";
  }
  setSelected(i) {
    this.selected = i;
  }
  getSelected() {
    return this.selected;
  }
  paint(ctx) {
    const r = { x: 0, y: 0, w: this.w, h: this.h };
    fillRoundRect(ctx, 0, 0, r.w, r.h, r.h * 0.5, ink.fill);
    const w = (r.w - 6) / this.items.length;
    this.items.forEach((item, i) => {
      const seg = { x: 3 + i * w, y: 3, w, h: r.h - 6 };
      const sel = i === this.selected;
      if (sel) {
        fillRoundRect(ctx, seg.x, seg.y + 0.6, seg.w, seg.h, seg.h * 0.5, "rgba(0,0,0,0.06)");
        fillRoundRect(ctx, seg.x, seg.y, seg.w, seg.h, seg.h * 0.5, "#ffffff");
      }
      drawTextIn(ctx, item, seg, sans(11, sel ? "semibold" : "medium"), sel ? ink.primary : ink.secondary, "centre");
    });
  }
  mouseUp(e) {
    if (!this.contains(e.x, e.y)) return;
    const i = Math.max(0, Math.min(this.items.length - 1, Math.trunc((e.x - 3) / ((this.w - 6) / this.items.length))));
    if (i !== this.selected) {
      this.selected = i;
      this.onChange?.(i);
    }
  }
  mouseEnter() {
    this.showInfo(this.help);
  }
  mouseExit() {
    this.showInfo("");
  }
};
var ZONES = ["prev", "next", "name", "save", "dice"];
var PresetBar = class extends Component {
  constructor(proc2, presets) {
    super();
    this.proc = proc2;
    this.presets = presets;
    this.onPresetLoaded = null;
    this.currentModule = null;
    this.hover = "none";
  }
  static boundsOnDevice() {
    const d = diceButton;
    return { x: preset.x, y: d.y - 23, w: Math.round(d.x + roundButtonRadius + 3 - preset.x), h: 46 };
  }
  zone(z) {
    const pill = { x: preset.x - this.x, y: preset.y - this.y, w: preset.w, h: preset.h };
    switch (z) {
      case "prev":
        return { ...pill, w: 40 };
      case "next":
        return { ...pill, x: pill.x + pill.w - 40, w: 40 };
      case "name":
        return { ...pill, x: pill.x + 40, w: pill.w - 80 };
      case "save":
        return { x: save.x - this.x, y: save.y - this.y, w: save.w, h: save.h };
      case "dice":
        return withCentre(roundButtonRadius * 2, roundButtonRadius * 2, { x: diceButton.x - this.x, y: diceButton.y - this.y });
      default:
        return { x: 0, y: 0, w: 0, h: 0 };
    }
  }
  zoneAt(x, y) {
    return ZONES.find((z) => contains(this.zone(z), x, y)) ?? "none";
  }
  refresh() {
  }
  paint(ctx) {
    const proc2 = this.proc, hover = this.hover;
    const pill = union(this.zone("prev"), this.zone("next"));
    fillRoundRect(ctx, pill.x, pill.y, pill.w, pill.h, pill.h * 0.5, hover === "name" ? "rgba(0,0,0,0.065)" : ink.fill);
    const arrow = (z, left) => {
      const c2 = centre(this.zone(z));
      c2.x += left ? -2 : 2;
      ctx.beginPath();
      ctx.moveTo(c2.x + (left ? 2.5 : -2.5), c2.y - 5);
      ctx.lineTo(c2.x + (left ? -2.5 : 2.5), c2.y);
      ctx.lineTo(c2.x + (left ? 2.5 : -2.5), c2.y + 5);
      ctx.strokeStyle = hover === z ? ink.primary : ink.secondary;
      ctx.lineWidth = 1.5;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.stroke();
    };
    arrow("prev", true);
    arrow("next", false);
    const bankFont = sans(10.5, "medium"), nameFont = sans(14, "semibold");
    const bank = titleCase(proc2.presetBank);
    const nz = this.zone("name");
    const wb = textWidth(ctx, bank, bankFont);
    const wn = Math.min(textWidth(ctx, proc2.presetName, nameFont), nz.w - wb - 16);
    const x0 = nz.x + nz.w / 2 - (wb + 10 + wn) * 0.5;
    drawTextIn(ctx, bank, { x: x0, y: nz.y, w: wb + 2, h: nz.h }, bankFont, ink.tertiary, "left");
    drawTextIn(ctx, proc2.presetName, { x: x0 + wb + 10, y: nz.y, w: wn + 2, h: nz.h }, nameFont, ink.primary, "left", true);
    drawTextIn(ctx, "Save", this.zone("save"), sans(12, "medium"), hover === "save" ? ink.primary : ink.secondary, "centre");
    const d = this.zone("dice");
    if (hover === "dice") fillEllipse(ctx, d.x + 1, d.y + 1, d.w - 2, d.h - 2, "rgba(0,0,0,0.035)");
    const c = centre(d);
    const col = hover === "dice" ? ink.primary : ink.secondary;
    strokeRoundRect(ctx, c.x - 6.5, c.y - 6.5, 13, 13, 3, col, 1.4);
    for (const [dx, dy] of [[-3, -3], [3, 3], [0, 0], [3, -3], [-3, 3]]) fillEllipse(ctx, c.x + dx - 1.1, c.y + dy - 1.1, 2.2, 2.2, col);
  }
  mouseUp(e) {
    switch (this.zoneAt(e.x, e.y)) {
      case "prev":
        this.presets.step(-1);
        break;
      case "next":
        this.presets.step(1);
        break;
      case "name":
        this.showBrowser();
        return;
      case "save":
        this.showSaveDialog();
        return;
      case "dice":
        if (e.mods.right) {
          this.showDiceMenu();
          return;
        }
        this.presets.randomize(this.presets.randomMode, this.currentModule ? this.currentModule() : 0);
        break;
      default:
        return;
    }
    this.onPresetLoaded?.();
  }
  mouseMove(e) {
    const z = this.zoneAt(e.x, e.y);
    this.hover = z;
    this.cursor = z === "none" ? null : "pointer";
    const modes = ["the modules that are on", "the module on screen", "a whole new patch"];
    switch (z) {
      case "prev":
      case "next":
        this.showInfo("Previous or next preset.");
        break;
      case "name":
        this.showInfo("Open the preset browser.");
        break;
      case "save":
        this.showInfo("Save the current sound as a user preset (kept in this browser).");
        break;
      case "dice":
        this.showInfo(`Randomize ${modes[this.presets.randomMode]}. Right-click to choose what it randomizes, or to go back to a recent patch.`);
        break;
      default:
        this.showInfo("");
        break;
    }
  }
  mouseExit() {
    this.hover = "none";
    this.showInfo("");
  }
  anchor(z) {
    return screenRect(this.root(), localToDevice(this, this.zone(z)));
  }
  async showBrowser() {
    const proc2 = this.proc, presets = this.presets;
    const order = [], cats = {};
    FACTORY.forEach((p, i) => {
      var _a;
      if (!order.includes(p.category)) order.push(p.category);
      (cats[_a = p.category] || (cats[_a] = [])).push({ id: i + 1, text: p.name, checked: proc2.presetBank === "FACTORY" && proc2.presetName === p.name });
    });
    const items = [{ header: "Factory" }, ...order.map((c) => ({ text: titleCase(c), sub: cats[c] }))];
    const user = presets.userPresets();
    items.push({ header: "User" });
    if (!user.length) items.push({ id: -1, text: "Save a preset to see it here", enabled: false });
    user.forEach((u, i) => items.push({ id: FACTORY.length + i + 1, text: u, checked: proc2.presetBank === "USER" && proc2.presetName === u }));
    const r = await showMenu(items, this.anchor("name"), this.root().scale);
    if (r <= 0) return;
    presets.load(r - 1);
    this.onPresetLoaded?.();
  }
  async showSaveDialog() {
    const name = await askName("Save preset", "Name your sound:", this.proc.presetBank === "USER" ? this.proc.presetName : "");
    if (name != null) this.presets.saveUser(name);
  }
  async showDiceMenu() {
    const presets = this.presets;
    const modes = ["Active: the modules that are on", "Module: the one on screen", "Generate: a whole new patch"];
    const items = [{ header: "The dice randomizes" }, ...modes.map((t, i) => ({ id: i + 1, text: t, checked: presets.randomMode === i }))];
    if (presets.historySize() > 0) {
      const recent = [];
      for (let i = presets.historySize() - 1; i >= 0; --i) recent.push({ id: 100 + i, text: `Before generate #${i + 1}` });
      items.push({ text: "Go back to", sub: recent });
    }
    const r = await showMenu(items, this.anchor("dice"), this.root().scale);
    if (r <= 0) return;
    if (r >= 100) {
      presets.restoreHistory(r - 100);
      this.onPresetLoaded?.();
    } else presets.randomMode = r - 1;
  }
};

// xray-demo-stage/src/engine/modules/scan.js
var P2 = mp.scan;
var f = Math.fround;
var TWO_PI_F = f(2 * Math.PI);
var PI_F = f(Math.PI);
var LOG_1000_F = f(Math.log(1e3));
var C_0_15 = f(0.15);
var C_0_65 = f(0.65);
var C_0_3 = f(0.3);
var PEAK_FLOOR = f(1e-9);
var OLA_NORM = f(1 / 1.5);
var SCAN_BANDS2 = 96;
var jlimit = (lo, hi, v) => v < lo ? lo : v > hi ? hi : v;
var FFT = class {
  constructor(order) {
    this.order = order;
    this.size = 1 << order;
    const m = Math.max(1, this.size >> 1);
    this.half = m;
    this.re = new Float64Array(m);
    this.im = new Float64Array(m);
    const bits = Math.max(0, order - 1);
    this.rev = new Uint32Array(m);
    for (let i = 0; i < m; ++i) {
      let r = 0;
      for (let b = 0; b < bits; ++b) r |= (i >>> b & 1) << bits - 1 - b;
      this.rev[i] = r;
    }
    this.cosT = new Float64Array(Math.max(1, m >> 1));
    this.sinT = new Float64Array(Math.max(1, m >> 1));
    for (let j = 0; j < m >> 1; ++j) {
      this.cosT[j] = Math.cos(2 * Math.PI * j / m);
      this.sinT[j] = Math.sin(2 * Math.PI * j / m);
    }
    this.wr = new Float64Array(m + 1);
    this.wi = new Float64Array(m + 1);
    for (let k = 0; k <= m; ++k) {
      this.wr[k] = Math.cos(2 * Math.PI * k / this.size);
      this.wi[k] = -Math.sin(2 * Math.PI * k / this.size);
    }
  }
  getSize() {
    return this.size;
  }
  // in-place complex FFT of size m on this.re / this.im, unscaled; sign -1 forward, +1 inverse
  complex(inverse) {
    const re = this.re, im = this.im, m = this.half, rev = this.rev, cosT = this.cosT, sinT = this.sinT;
    for (let i = 0; i < m; ++i) {
      const j = rev[i];
      if (j > i) {
        const tr = re[i];
        re[i] = re[j];
        re[j] = tr;
        const ti = im[i];
        im[i] = im[j];
        im[j] = ti;
      }
    }
    const sgn = inverse ? 1 : -1;
    for (let len = 2; len <= m; len <<= 1) {
      const h = len >> 1, step = m / len;
      for (let i = 0; i < m; i += len) {
        for (let j = 0, t = 0; j < h; ++j, t += step) {
          const wr = cosT[t], wi = sgn * sinT[t];
          const a = i + j, b = a + h;
          const br = re[b] * wr - im[b] * wi;
          const bi = re[b] * wi + im[b] * wr;
          re[b] = re[a] - br;
          im[b] = im[a] - bi;
          re[a] += br;
          im[a] += bi;
        }
      }
    }
  }
  performRealOnlyForwardTransform(d, onlyCalculateNonNegativeFrequencies = false) {
    const n = this.size;
    if (n === 1) return;
    const m = this.half, re = this.re, im = this.im, wr = this.wr, wi = this.wi;
    for (let i = 0; i < m; ++i) {
      re[i] = d[2 * i];
      im[i] = d[2 * i + 1];
    }
    this.complex(false);
    d[0] = re[0] + im[0];
    d[1] = 0;
    for (let k = 1; k < m; ++k) {
      const zr = re[k], zi = im[k], cr = re[m - k], ci = -im[m - k];
      const er = 0.5 * (zr + cr), ei = 0.5 * (zi + ci);
      const or = 0.5 * (zi - ci), oi = -0.5 * (zr - cr);
      d[2 * k] = er + wr[k] * or - wi[k] * oi;
      d[2 * k + 1] = ei + wr[k] * oi + wi[k] * or;
    }
    d[2 * m] = re[0] - im[0];
    d[2 * m + 1] = 0;
    if (!onlyCalculateNonNegativeFrequencies)
      for (let k = m + 1; k < n; ++k) {
        d[2 * k] = d[2 * (n - k)];
        d[2 * k + 1] = -d[2 * (n - k) + 1];
      }
  }
  performRealOnlyInverseTransform(d) {
    const n = this.size;
    if (n === 1) return;
    const m = this.half, re = this.re, im = this.im, wr = this.wr, wi = this.wi;
    const x0 = d[0], xm = d[2 * m];
    re[0] = 0.5 * (x0 + xm);
    im[0] = 0.5 * (x0 - xm);
    for (let k = 1; k < m; ++k) {
      const xr = d[2 * k], xi = d[2 * k + 1], cr = d[2 * (m - k)], ci = -d[2 * (m - k) + 1];
      const er = 0.5 * (xr + cr), ei = 0.5 * (xi + ci);
      const ar = xr - cr, ai = xi - ci;
      const or = 0.5 * (ar * wr[k] + ai * wi[k]), oi = 0.5 * (ai * wr[k] - ar * wi[k]);
      re[k] = er - oi;
      im[k] = ei + or;
    }
    this.complex(true);
    const scale = 1 / m;
    for (let i = 0; i < m; ++i) {
      d[2 * i] = re[i] * scale;
      d[2 * i + 1] = im[i] * scale;
    }
    d.fill(0, n, 2 * n);
  }
  performFrequencyOnlyForwardTransform(d, onlyCalculateNonNegativeFrequencies = false) {
    const n = this.size;
    if (n === 1) return;
    this.performRealOnlyForwardTransform(d, onlyCalculateNonNegativeFrequencies);
    const limit = onlyCalculateNonNegativeFrequencies ? (n >> 1) + 1 : n;
    for (let i = 0; i < limit; ++i) {
      const a = d[2 * i], b = d[2 * i + 1];
      d[i] = Math.sqrt(a * a + b * b);
    }
    d.fill(0, limit, 2 * n);
  }
};
var frac = (x) => f(x - Math.floor(x));
function trapezoid(x) {
  if (x < C_0_15) return f(x / C_0_15);
  if (x < 0.5) return 1;
  if (x < C_0_65) return f(1 - f(f(x - 0.5) / C_0_15));
  return 0;
}
var _ScanModule = class _ScanModule {
  static frameForIndex(idx) {
    return 512 << jlimit(0, 3, idx | 0);
  }
  // the mask value (0..1) of shape s at log-frequency position u (0..1), slid by phase ph; table = the drawn mask
  static shapeValue(s, u, ph, table) {
    u = f(u);
    ph = f(ph);
    switch (s) {
      case 0:
        return trapezoid(frac(f(2 * u + ph)));
      case 1:
        return trapezoid(frac(f(4 * u + ph)));
      case 2:
        return trapezoid(frac(f(8 * u + ph)));
      case 3:
        return frac(f(2 * u + ph));
      case 4:
        return f(1 - frac(f(2 * u + ph)));
      case 5:
        return f(0.5 + 0.5 * f(Math.sin(f(TWO_PI_F * f(3 * u + ph)))));
      case 6:
        return frac(f(4 * u + ph)) < C_0_3 ? 1 : 0;
      case 7:
        return f(Math.floor(f(frac(f(u + ph)) * 6)) / 5);
      case 8:
      default: {
        const tableSize = _ScanModule.tableSize;
        const x = f(frac(f(u + ph)) * tableSize);
        const i0 = Math.trunc(x) % tableSize, i1 = (i0 + 1) % tableSize;
        const fr = x - Math.floor(x);
        return f(table[i0] + fr * f(table[i1] - table[i0]));
      }
    }
  }
  constructor(analysis) {
    this.tel = analysis.scan;
    this.sampleRate = 48e3;
    this.mode = 0;
    this.shape = 1;
    this.frameIdx = 2;
    this.frameSize = 2048;
    this.hop = 512;
    this.order = 11;
    this.strength = f(0.85);
    this.phase = 0;
    this.smooth = f(0.25);
    this.shift = 0;
    this.invert = false;
    this.ffts = [null, null, null, null];
    this.windows = [null, null, null, null];
    this.binU = [null, null, null, null];
    this.binBand = [null, null, null, null];
    this.inRing = [null, null];
    this.outRing = [null, null];
    this.magHold = [null, null];
    this.fft = null;
    this.maskNow = null;
    this.gainSm = null;
    this.tableCopy = null;
    this.sampleCount = 0;
    this.hopCounter = 0;
    this.rng = new Rng(23721);
    this.drawTable = new Float32Array(_ScanModule.tableSize);
    this.fillDefaultDrawTable();
  }
  fillDefaultDrawTable() {
    const n = _ScanModule.tableSize;
    for (let i = 0; i < n; ++i)
      if (this.drawTable[i] === 0)
        this.drawTable[i] = f(0.5 + f(0.4) * f(Math.sin(f(f(f(TWO_PI_F * i) / n) * 3))));
  }
  prepare(sr, maxBlock) {
    this.sampleRate = sr;
    const maxFrame = _ScanModule.maxFrame;
    for (let i = 0; i < 4; ++i) {
      const n = 512 << i;
      this.ffts[i] = new FFT(9 + i);
      const w = this.windows[i] = new Float32Array(n);
      for (let k = 0; k < n; ++k)
        w[k] = f(0.5 - 0.5 * f(Math.cos(f(f(TWO_PI_F * k) / n))));
      const half = n / 2;
      const binHz = f(f(sr) / n);
      const us = this.binU[i] = new Float32Array(half + 1);
      const bands = this.binBand[i] = new Int32Array(half + 1);
      for (let k = 0; k <= half; ++k) {
        const fq = Math.max(1, f(k * binHz));
        const u = jlimit(0, 1, f(f(Math.log(f(fq / 20))) / LOG_1000_F));
        us[k] = u;
        bands[k] = jlimit(0, SCAN_BANDS2 - 1, Math.trunc(f(u * SCAN_BANDS2)));
      }
    }
    for (let ch = 0; ch < 2; ++ch) {
      this.inRing[ch] = new Float32Array(maxFrame);
      this.outRing[ch] = new Float32Array(maxFrame * 2);
      this.magHold[ch] = new Float32Array(maxFrame / 2 + 1);
    }
    this.fft = new Float32Array(maxFrame * 2);
    this.maskNow = new Float32Array(maxFrame / 2 + 1).fill(1);
    this.gainSm = new Float32Array(maxFrame / 2 + 1).fill(1);
    this.tableCopy = new Float32Array(_ScanModule.tableSize).fill(0.5);
    this.fillDefaultDrawTable();
    this.setFrame(_ScanModule.frameForIndex(this.frameIdx));
  }
  setFrame(n) {
    this.frameSize = n;
    this.hop = n / 4;
    let order = 9;
    while (512 << order - 9 < n) ++order;
    this.order = order;
    this.reset();
  }
  reset() {
    if (!this.fft) return;
    for (let ch = 0; ch < 2; ++ch) {
      this.inRing[ch].fill(0);
      this.outRing[ch].fill(0);
      this.magHold[ch].fill(0);
    }
    this.gainSm.fill(1);
    this.sampleCount = 0;
    this.hopCounter = 0;
  }
  setParams(v) {
    this.mode = jlimit(0, 2, roundToInt(v[P2.mode]));
    this.shape = jlimit(0, 8, roundToInt(v[P2.shape]));
    this.strength = f(v[P2.strength]);
    this.phase = f(v[P2.phase]);
    this.smooth = f(v[P2.smooth]);
    this.shift = f(v[P2.shift]);
    this.invert = v[P2.invert] > 0.5;
    const idx = jlimit(0, 3, roundToInt(v[P2.frame]));
    if (idx !== this.frameIdx) {
      this.frameIdx = idx;
      this.setFrame(_ScanModule.frameForIndex(idx));
    }
  }
  latency() {
    return this.frameSize;
  }
  processFrame(ch) {
    const n = this.frameSize, half = n / 2;
    const oi = this.order - 9;
    const w = this.windows[oi];
    const fft = this.fft, inRing = this.inRing[ch];
    const mode = this.mode, strength = this.strength, smooth = this.smooth;
    const maskNow = this.maskNow, gainSm = this.gainSm, hold = this.magHold[ch];
    const us = this.binU[oi], bands = this.binBand[oi];
    const tel = this.tel;
    const start = this.sampleCount - n;
    for (let k = 0; k < n; ++k)
      fft[k] = inRing[start + k & _ScanModule.maxFrame - 1] * w[k];
    fft.fill(0, n, 2 * n);
    this.ffts[oi].performRealOnlyForwardTransform(fft);
    let peak = PEAK_FLOOR;
    if (mode === 2)
      for (let k = 1; k <= half; ++k) {
        const a = fft[2 * k], b = fft[2 * k + 1];
        peak = Math.max(peak, Math.sqrt(a * a + b * b));
      }
    const smoothCoef = 0.6 * smooth + 0.39 * smooth * smooth;
    const holdCoef = 0.85 + 0.14 * smooth;
    const gateThreshold = peak * Math.pow(10, -(6 + 54 * (1 - strength)) / 20);
    const norm = 4 / n;
    for (let k = 0; k <= half; ++k) {
      const u = us[k];
      let m;
      if (ch === 0) {
        m = _ScanModule.shapeValue(this.shape, u, this.phase, this.tableCopy);
        if (this.invert) m = 1 - m;
        maskNow[k] = m;
      } else {
        m = maskNow[k];
      }
      let re = fft[2 * k], im = fft[2 * k + 1];
      const mag = Math.sqrt(re * re + im * im);
      let gain = 1;
      switch (mode) {
        case 0:
          gain = 1 - strength + strength * m;
          break;
        case 1: {
          hold[k] = holdCoef * hold[k] + (1 - holdCoef) * mag;
          const h = hold[k];
          const amt = strength * m;
          const targetMag = mag + amt * (h * 1.6 - mag);
          const ph = Math.atan2(im, re) + amt * PI_F * this.rng.bi();
          re = targetMag * Math.cos(ph);
          im = targetMag * Math.sin(ph);
          break;
        }
        case 2: {
          const thr = gateThreshold * (1.6 - 1.2 * m);
          gain = mag > thr ? 1 : Math.max(0, (mag / thr - 0.5) * 2);
          gain *= 0.4 + 0.6 * (1 - strength + strength * m);
          break;
        }
        default:
          break;
      }
      if (mode !== 1) {
        if (ch === 0)
          gainSm[k] = smoothCoef * gainSm[k] + (1 - smoothCoef) * gain;
        const gs = gainSm[k];
        re *= gs;
        im *= gs;
      }
      fft[2 * k] = re;
      fft[2 * k + 1] = im;
      if (ch === 0 && k > 0) {
        const band = bands[k];
        const outMag = Math.sqrt(re * re + im * im);
        if (mag * norm > tel.in[band]) tel.in[band] = mag * norm;
        if (outMag * norm > tel.out[band]) tel.out[band] = outMag * norm;
        tel.mask[band] = m;
      }
    }
    const s = roundToInt(f(this.shift * n) / 32);
    if (s !== 0) {
      if (s > 0)
        for (let k = half; k >= 0; --k) {
          const src = k - s;
          fft[2 * k] = src >= 1 ? fft[2 * src] : 0;
          fft[2 * k + 1] = src >= 1 ? fft[2 * src + 1] : 0;
        }
      else
        for (let k = 0; k <= half; ++k) {
          const src = k - s;
          fft[2 * k] = src <= half ? fft[2 * src] : 0;
          fft[2 * k + 1] = src <= half ? fft[2 * src + 1] : 0;
        }
    }
    fft[1] = 0;
    fft[2 * half + 1] = 0;
    for (let k = 1; k < half; ++k) {
      fft[2 * (n - k)] = fft[2 * k];
      fft[2 * (n - k) + 1] = -fft[2 * k + 1];
    }
    this.ffts[oi].performRealOnlyInverseTransform(fft);
    const out2 = this.outRing[ch], sc = this.sampleCount, mask2 = 2 * _ScanModule.maxFrame - 1;
    for (let k = 0; k < n; ++k)
      out2[sc + k & mask2] += fft[k] * w[k] * OLA_NORM;
  }
  process(l, r, n, ctx) {
    const tableCopy = this.tableCopy, drawTable = this.drawTable;
    for (let i = 0; i < _ScanModule.tableSize; ++i)
      tableCopy[i] = drawTable[i];
    const inL = this.inRing[0], inR = this.inRing[1], outL = this.outRing[0], outR = this.outRing[1];
    const inMask = _ScanModule.maxFrame - 1, outMask = 2 * _ScanModule.maxFrame - 1;
    const tel = this.tel;
    for (let i = 0; i < n; ++i) {
      const w = this.sampleCount & inMask;
      inL[w] = l[i];
      inR[w] = r[i];
      ++this.sampleCount;
      if (++this.hopCounter >= this.hop) {
        this.hopCounter = 0;
        if (this.sampleCount >= this.frameSize) {
          tel.in.fill(0);
          tel.out.fill(0);
          this.processFrame(0);
          this.processFrame(1);
        }
      }
      const o = this.sampleCount - 1 & outMask;
      l[i] = outL[o];
      outL[o] = 0;
      r[i] = outR[o];
      outR[o] = 0;
    }
    tel.frame = this.frameSize;
  }
};
__publicField(_ScanModule, "maxFrame", 4096);
__publicField(_ScanModule, "tableSize", 64);
var ScanModule = _ScanModule;

// xray-demo-stage/src/app/visuals.js
var TWO_PI2 = 2 * Math.PI;
var fround = Math.fround;
var jlimit2 = (lo, hi, v) => v < lo ? lo : hi < v ? hi : v;
var jmap = (v, s0, s1, t0, t1) => t0 + (v - s0) * (t1 - t0) / (s1 - s0);
var rect = (x, y, w, h) => ({ x, y, w, h });
var right2 = (r) => r.x + r.w;
var bottom = (r) => r.y + r.h;
var centreX = (r) => r.x + r.w * 0.5;
var centreY = (r) => r.y + r.h * 0.5;
var reduced2 = (r, dx, dy = dx) => rect(r.x + dx, r.y + dy, Math.max(0, r.w - 2 * dx), Math.max(0, r.h - 2 * dy));
var expanded2 = (r, d) => rect(r.x - d, r.y - d, r.w + 2 * d, r.h + 2 * d);
var translated2 = (r, dx, dy) => rect(r.x + dx, r.y + dy, r.w, r.h);
var withTrimmedBottom = (r, a) => rect(r.x, r.y, r.w, Math.max(0, r.h - a));
var withTrimmedLeft = (r, a) => rect(r.x + a, r.y, Math.max(0, r.w - a), r.h);
var withHeight = (r, h) => rect(r.x, r.y, r.w, h);
var withTop = (r, top) => rect(r.x, top, r.w, Math.max(0, r.y + r.h - top));
var withSizeKeepingCentre = (r, w, h) => rect(r.x + (r.w - w) / 2, r.y + (r.h - h) / 2, w, h);
var removeFromBottom = (r, a) => rect(r.x, r.y + Math.max(0, r.h - a), r.w, Math.min(a, r.h));
var localBounds = (c) => rect(0, 0, c.w, c.h);
var colour = (hex, a = 1) => [...hexRgb(hex), a];
var C2 = {
  screen: colour(colours.screen),
  text: colour(colours.text),
  textDim: colour(colours.textDim),
  textFaint: colour(colours.textFaint),
  grid: colour(colours.grid),
  film: colour(colours.film),
  white: [255, 255, 255, 1]
};
var withAlpha = (c, a) => [c[0], c[1], c[2], a];
var css2 = (c) => rgba(c, jlimit2(0, 1, c[3]));
var spectrum = (u) => [...spectrumRgb(u), 1];
function brighter2(c, amount) {
  const k = fround(1 / fround(1 + amount));
  const ch = (v) => Math.trunc(fround(255 - fround(k * (255 - v))));
  return [ch(c[0]), ch(c[1]), ch(c[2]), c[3]];
}
function interpolatedWith(a, b, p) {
  if (p <= 0) return a;
  if (p >= 1) return b;
  const amount = roundToInt(p * 255);
  const d = (a[0] << 16 | a[1] << 8 | a[2]) >>> 0, s = (b[0] << 16 | b[1] << 8 | b[2]) >>> 0;
  let dE = d & 16711935;
  dE = dE + (Math.imul((s & 16711935) - dE >>> 0, amount) >>> 8) & 16711935;
  let dO = d >>> 8 & 16711935;
  dO = dO + (Math.imul((s >>> 8 & 16711935) - dO >>> 0, amount) >>> 8) & 16711935;
  return [dE >>> 16 & 255, dO & 255, dE & 255, 1];
}
var JuceRandom = class {
  constructor(seed) {
    this.lo = seed % 16777216;
    this.hi = Math.floor(seed / 16777216) % 16777216;
  }
  nextInt() {
    const p0 = this.lo * 15525485 + 11;
    const carry = Math.floor(p0 / 16777216);
    this.hi = (this.lo * 1502 + this.hi * 15525485 + carry) % 16777216;
    this.lo = p0 % 16777216;
    return this.hi * 256 + Math.floor(this.lo / 65536);
  }
  nextFloat() {
    return Math.min(fround(fround(this.nextInt()) / 4294967296), 1 - 2 ** -23);
  }
};
var MITER_LIMIT = Math.sqrt(37);
function setColour(ctx, c) {
  ctx.fillStyle = ctx.strokeStyle = css2(c);
}
function setGradientFill(ctx, g) {
  ctx.fillStyle = ctx.strokeStyle = g;
}
function strokePath(ctx, p, width2) {
  ctx.lineJoin = "miter";
  ctx.miterLimit = MITER_LIMIT;
  ctx.lineCap = "butt";
  ctx.lineWidth = width2;
  ctx.stroke(p);
}
function drawHorizontalLine(ctx, y, x0, x1) {
  ctx.fillRect(x0, y, x1 - x0, 1);
}
function drawLine(ctx, x1, y1, x2, y2, thickness) {
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.lineCap = "butt";
  ctx.lineWidth = thickness;
  ctx.stroke();
}
function fillRoundedRectangle(ctx, r, cornerSize) {
  roundRect(ctx, r.x, r.y, r.w, r.h, cornerSize);
  ctx.fill();
}
function fillEllipse2(ctx, x, y, w, h) {
  ctx.beginPath();
  ctx.ellipse(x + w * 0.5, y + h * 0.5, w * 0.5, h * 0.5, 0, 0, TWO_PI2);
  ctx.fill();
}
function drawEllipse(ctx, x, y, w, h, thickness) {
  ctx.beginPath();
  ctx.ellipse(x + w * 0.5, y + h * 0.5, w * 0.5, h * 0.5, 0, 0, TWO_PI2);
  ctx.lineWidth = thickness;
  ctx.stroke();
}
var fontPx = 12;
function setFont(ctx, size, weight = "regular") {
  ctx.font = sans(size, weight);
  fontPx = size * 0.96;
}
var Justification = {
  centred: { h: "center", v: "middle" },
  centredLeft: { h: "left", v: "middle" },
  centredRight: { h: "right", v: "middle" },
  topLeft: { h: "left", v: "top" },
  bottomLeft: { h: "left", v: "bottom" }
};
var LINE_HEIGHT = 1.2109375;
function drawText(ctx, s, r, j) {
  if (!s || r.w <= 0) return;
  if (ctx.measureText(s).width > r.w + 1) {
    let t = s;
    while (t.length > 0 && ctx.measureText(`${t}...`).width > r.w) t = t.slice(0, -1);
    s = `${t}...`;
  }
  const lh = fontPx * LINE_HEIGHT;
  ctx.textAlign = j.h;
  ctx.textBaseline = "middle";
  const x = j.h === "left" ? r.x : j.h === "right" ? r.x + r.w : r.x + r.w * 0.5;
  const y = j.v === "top" ? r.y + lh * 0.5 : j.v === "bottom" ? r.y + r.h - lh * 0.5 : r.y + r.h * 0.5;
  ctx.fillText(s, x, y);
}
var ModuleVisual = class extends Component {
  constructor(proc2, m) {
    super();
    this.proc = proc2;
    this.id = m;
    this.page = 0;
    this.clock = 0;
    this.setInterceptsMouseClicks(false, false);
  }
  tick() {
  }
  setPage(p) {
    this.page = p;
  }
  accent() {
    return MODULE_COLOURS[this.id];
  }
  isOn() {
    return this.proc.isModuleOn(this.id);
  }
};
function findTrigger(x, size, from, to) {
  from = Math.max(1, from);
  to = Math.min(size - 1, to);
  for (let i = to; i > from; --i)
    if (x[i - 1] < 0 && x[i] >= 0)
      return i;
  return to;
}
function wavePath(v, off, n, r, scale, steps = false) {
  const p = new Path2D();
  const cy = centreY(r);
  const stride = steps ? 1 : Math.max(1, Math.ceil(n / Math.max(1, r.w / 2.5)));
  let currentY = 0;
  for (let i = 0; i < n; i += stride) {
    const x = r.x + r.w * i / Math.max(1, n - 1);
    const y = jlimit2(r.y, bottom(r), cy - v[off + i] * scale);
    if (i === 0)
      p.moveTo(x, y);
    else if (steps) {
      p.lineTo(x, currentY);
      p.lineTo(x, y);
    } else
      p.lineTo(x, y);
    currentY = y;
  }
  return p;
}
function peakOf(v, off, n) {
  let p = 0;
  for (let i = off; i < off + n; ++i)
    p = Math.max(p, Math.abs(v[i]));
  return p;
}
function drawOffHint(ctx, r, id) {
  setColour(ctx, C2.textDim);
  setFont(ctx, 12.5);
  drawText(ctx, `${titleCase(TITLES[id])} is off. Right-click its key to switch it on.`, r, Justification.centred);
}
var _DriveVisual = class _DriveVisual extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    const { N } = _DriveVisual;
    this.pre = new Float32Array(N + 1024);
    this.post = new Float32Array(N);
    this.winStart = 0;
    this.winSize = 0;
    this.shownPeak = 0.1;
  }
  tick() {
    const { N, W } = _DriveVisual;
    const slot = this.proc.analysis.slots[this.id];
    const lat = jlimit2(0, 1024, slot.latency | 0);
    slot.pre.readLatest(this.pre, N + lat);
    slot.post.readLatest(this.post, N);
    const start = findTrigger(this.pre, N + lat, N - W - 900, N - W);
    this.winStart = start;
    this.winSize = W;
    const pk = Math.max(peakOf(this.pre, start, W), peakOf(this.post, start, W));
    this.shownPeak = Math.max(pk, this.shownPeak * 0.96);
  }
  paint(ctx) {
    const r = reduced2(localBounds(this), 28, 30);
    if (!this.isOn())
      return drawOffHint(ctx, r, this.id);
    const scale = r.h * 0.44 / Math.max(1e-3, this.shownPeak);
    setColour(ctx, withAlpha(C2.film, 0.1));
    drawHorizontalLine(ctx, Math.trunc(centreY(r)), r.x, right2(r));
    setColour(ctx, withAlpha(C2.textDim, 0.55));
    strokePath(ctx, wavePath(this.pre, this.winStart, this.winSize, r, scale), 1.2);
    const out2 = wavePath(this.post, this.winStart, this.winSize, r, scale);
    const fill = new Path2D(out2);
    fill.lineTo(right2(r), centreY(r));
    fill.lineTo(r.x, centreY(r));
    fill.closePath();
    setGradientFill(ctx, spectrumGradient(ctx, r.x, right2(r), 0.05, 0.95, 0.08));
    ctx.fill(fill);
    drawSpectrumLine(ctx, out2, r.x, right2(r), 0.05, 0.95, 2, 7);
  }
};
__publicField(_DriveVisual, "N", 4096);
__publicField(_DriveVisual, "W", 640);
var DriveVisual = _DriveVisual;
var _LofiVisual = class _LofiVisual extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    this.wet = new Float32Array(_LofiVisual.N);
    this.winStart = 0;
    this.winSize = 0;
    this.shownPeak = 0.1;
    this.bits = 24;
    this.rate = 48e3;
    this.dropout = 1;
    this.noise = 0;
    this.frame = 0;
  }
  tick() {
    const { N, W } = _LofiVisual;
    const t = this.proc.analysis.lofi;
    this.bits = t.bits;
    const w = this.bits < 23.5 ? W : 900;
    t.wet.readLatest(this.wet, N);
    const start = findTrigger(this.wet, N, N - w - 200, N - w);
    this.winStart = start;
    this.winSize = w;
    this.shownPeak = Math.max(peakOf(this.wet, start, w), this.shownPeak * 0.96);
    this.rate = t.rate;
    this.dropout = t.dropout;
    this.noise = t.noise;
    ++this.frame;
  }
  paint(ctx) {
    const r = reduced2(localBounds(this), 28, 30);
    if (!this.isOn())
      return drawOffHint(ctx, r, this.id);
    const scale = r.h * 0.44 / Math.max(1e-3, this.shownPeak);
    if (this.bits < 10.5) {
      const step = scale / Math.pow(2, this.bits - 1);
      if (step > 3) {
        setColour(ctx, withAlpha(C2.film, 0.07));
        for (let y = centreY(r); y > r.y; y -= step)
          drawHorizontalLine(ctx, Math.trunc(y), r.x, right2(r));
        for (let y = centreY(r) + step; y < bottom(r); y += step)
          drawHorizontalLine(ctx, Math.trunc(y), r.x, right2(r));
      }
    }
    const rng = new JuceRandom(this.frame);
    const specks = jlimit2(0, 400, Math.trunc(this.noise * 5e3));
    setColour(ctx, withAlpha(C2.text, 0.35));
    for (let i = 0; i < specks; ++i) {
      const x = r.x + rng.nextFloat() * r.w;
      const y = r.y + rng.nextFloat() * r.h;
      ctx.fillRect(x, y, 1.5, 1.5);
    }
    drawSpectrumLine(
      ctx,
      wavePath(this.wet, this.winStart, this.winSize, r, scale, this.bits < 23.5),
      r.x,
      right2(r),
      0.05,
      0.95,
      1.8,
      6,
      0.35 + 0.65 * this.dropout
    );
    setFont(ctx, 11, "medium");
    setColour(ctx, C2.textDim);
    const readout = this.bits < 23.5 ? `${roundToInt(this.bits)} bit  \xB7  ${(this.rate / 1e3).toFixed(1)} kHz` : "Tape";
    drawText(
      ctx,
      readout + (this.dropout < 0.8 ? "  \xB7  dropout" : ""),
      removeFromBottom(reduced2(localBounds(this), 16, 4), 18),
      Justification.centredLeft
    );
  }
};
__publicField(_LofiVisual, "N", 2048);
__publicField(_LofiVisual, "W", 360);
var LofiVisual = _LofiVisual;
var ChopAction = { pass: 0, repeat: 1, stutter: 2, reverse: 3, shuffle: 4, pitchUp: 5, pitchDown: 6, stretch: 7 };
var ChopVisual = class _ChopVisual extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    this.slots = 16;
    this.current = 0;
    this.progress = 0;
    this.actions = new Int32Array(CHOP_MAX_SLOTS);
    this.levels = new Float32Array(CHOP_MAX_SLOTS);
  }
  tick() {
    const t = this.proc.analysis.chop;
    this.slots = jlimit2(1, CHOP_MAX_SLOTS, t.numSlots | 0);
    this.current = t.current;
    this.progress = t.progress;
    for (let i = 0; i < this.slots; ++i) {
      this.actions[i] = t.action[i];
      const target = t.level[i];
      this.levels[i] += 0.3 * (target - this.levels[i]);
    }
  }
  paint(ctx) {
    const full = reduced2(localBounds(this), 24, 26);
    if (!this.isOn())
      return drawOffHint(ctx, full, this.id);
    const slots = this.slots;
    const r = withTrimmedBottom(full, 34);
    const gap = slots > 32 ? 2 : 4;
    const w = (r.w - gap * (slots - 1)) / slots;
    const cy = centreY(r);
    for (let i = 0; i < slots; ++i) {
      const a = this.actions[i];
      const x = r.x + i * (w + gap);
      const lvl = jlimit2(0, 1, 0.15 + 0.85 * Math.sqrt(Math.min(1, this.levels[i] * 2)));
      const h = r.h * 0.8 * lvl;
      let bar = rect(x, cy - h * 0.5, w, h);
      if (a === ChopAction.pitchUp)
        bar = translated2(bar, 0, -r.h * 0.08);
      if (a === ChopAction.pitchDown)
        bar = translated2(bar, 0, r.h * 0.08);
      const live = a === ChopAction.pass;
      const now = i === this.current;
      let c = live ? withAlpha(C2.textDim, 0.4) : spectrum(i / Math.max(1, slots - 1) * 0.9 + 0.05);
      if (a === ChopAction.shuffle)
        c = C2.text;
      if (now) {
        setColour(ctx, withAlpha(c, 0.25));
        fillRoundedRectangle(ctx, expanded2(bar, 3), 3);
      }
      if (a === ChopAction.reverse || a === ChopAction.stretch) {
        const g = ctx.createLinearGradient(bar.x, 0, right2(bar), 0);
        g.addColorStop(0, css2(a === ChopAction.reverse ? withAlpha(c, 0.15) : c));
        g.addColorStop(1, css2(a === ChopAction.reverse ? c : withAlpha(c, 0.1)));
        setGradientFill(ctx, g);
      } else
        setColour(ctx, withAlpha(c, now ? 1 : 0.8));
      fillRoundedRectangle(ctx, bar, 2);
      if (a === ChopAction.stutter) {
        setColour(ctx, withAlpha(C2.screen, 0.8));
        for (let yy = bar.y + 4; yy < bottom(bar); yy += 6)
          ctx.fillRect(bar.x, yy, bar.w, 2);
      }
      if (!live && w >= 9)
        _ChopVisual.drawIcon(ctx, a, rect(x, r.y - 2, w, 12), c);
      if (now) {
        const px = x + w * this.progress;
        setColour(ctx, C2.text);
        drawLine(ctx, px, r.y + 12, px, bottom(r), 1.2);
      }
    }
    const legend = removeFromBottom(full, 16);
    const items = [
      ChopAction.repeat,
      ChopAction.stutter,
      ChopAction.reverse,
      ChopAction.shuffle,
      ChopAction.pitchUp,
      ChopAction.pitchDown,
      ChopAction.stretch
    ];
    const names = ["repeat", "stutter", "reverse", "shuffle", "+12", "-12", "stretch"];
    const iw = legend.w / 7;
    for (let k = 0; k < 7; ++k) {
      const cell = rect(legend.x + k * iw, legend.y, iw, legend.h);
      const icon = rect(cell.x, cell.y, Math.min(14, cell.w), cell.h);
      _ChopVisual.drawIcon(ctx, items[k], icon, C2.textDim);
      setColour(ctx, C2.textFaint);
      setFont(ctx, 10.5);
      drawText(ctx, capitalised(names[k]), withTrimmedLeft(withTrimmedLeft(cell, icon.w), 3), Justification.centredLeft);
    }
  }
  static drawIcon(ctx, action, r, c) {
    const b = withSizeKeepingCentre(r, 8, 8);
    const p = new Path2D();
    const triangle = (x1, y1, x2, y2, x3, y3) => {
      p.moveTo(x1, y1);
      p.lineTo(x2, y2);
      p.lineTo(x3, y3);
      p.closePath();
    };
    switch (action) {
      case ChopAction.repeat: {
        const cx = centreX(b), cy = centreY(b);
        p.moveTo(cx + 3.5 * Math.sin(0.6), cy - 3.5 * Math.cos(0.6));
        p.arc(cx, cy, 3.5, 0.6 - Math.PI / 2, 5.6 - Math.PI / 2, false);
        triangle(centreX(b) + 2, b.y - 0.5, right2(b) + 0.5, b.y + 2.5, centreX(b) + 0.5, b.y + 3.5);
        break;
      }
      case ChopAction.stutter:
        for (let i = 0; i < 3; ++i)
          p.rect(b.x + i * 3, b.y, 1.5, b.h);
        break;
      case ChopAction.reverse:
        triangle(right2(b), b.y, right2(b), bottom(b), b.x, centreY(b));
        break;
      case ChopAction.shuffle:
        p.moveTo(b.x, b.y);
        p.lineTo(right2(b), bottom(b));
        p.moveTo(b.x, bottom(b));
        p.lineTo(right2(b), b.y);
        break;
      case ChopAction.pitchUp:
        triangle(b.x, bottom(b), right2(b), bottom(b), centreX(b), b.y);
        break;
      case ChopAction.pitchDown:
        triangle(b.x, b.y, right2(b), b.y, centreX(b), bottom(b));
        break;
      case ChopAction.stretch:
        p.moveTo(b.x, b.y);
        p.quadraticCurveTo(right2(b), b.y, right2(b), bottom(b));
        break;
      default:
        break;
    }
    setColour(ctx, c);
    if (action === ChopAction.shuffle || action === ChopAction.stretch || action === ChopAction.repeat)
      strokePath(ctx, p, 1.3);
    if (action !== ChopAction.shuffle && action !== ChopAction.stretch)
      ctx.fill(p);
  }
};
var _VibeVisual = class _VibeVisual extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    this.in = new Float32Array(_VibeVisual.N);
    this.winStart = 0;
    this.winSize = 0;
    this.shownPeak = 0.1;
    this.voices = 2;
    this.stages = 6;
    this.msL = new Float32Array(4);
    this.msR = new Float32Array(4);
    this.fcL = 1e3;
    this.fcR = 1e3;
    this.fb = 0;
  }
  tick() {
    const { N, W } = _VibeVisual;
    const t = this.proc.analysis.vibe;
    if (this.page === 0) {
      const slot = this.proc.analysis.slots[this.id];
      slot.pre.readLatest(this.in, N);
      const start = findTrigger(this.in, N, N - W - 1600, N - W - 1300);
      this.winStart = start - 1200;
      this.winSize = 1200 + W;
      this.shownPeak = Math.max(peakOf(this.in, this.winStart, this.winSize), this.shownPeak * 0.96);
      this.voices = jlimit2(1, 4, t.voices | 0);
      for (let v = 0; v < 4; ++v) {
        this.msL[v] += 0.5 * (t.voiceMsL[v] - this.msL[v]);
        this.msR[v] += 0.5 * (t.voiceMsR[v] - this.msR[v]);
      }
    } else {
      this.fcL = t.phaserHz;
      this.fcR = t.phaserHzR;
      this.stages = t.phaserStages;
      this.fb = t.phaserFeedback;
    }
  }
  paint(ctx) {
    const r = reduced2(localBounds(this), 28, 30);
    if (!this.isOn())
      return drawOffHint(ctx, r, this.id);
    if (this.page === 0)
      this.paintChorus(ctx, r);
    else
      this.paintPhaser(ctx, r);
  }
  paintChorus(ctx, r) {
    const { W } = _VibeVisual;
    const proc2 = this.proc;
    if (proc2.paramValue(this.id, mp.vibe.chOn) < 0.5)
      return drawOffHint(ctx, r, this.id);
    if (this.winSize < 1200 + W)
      return;
    const sr = proc2.analysis.sampleRate;
    const scale = r.h * 0.2 / Math.max(1e-3, this.shownPeak);
    const width2 = proc2.paramValue(this.id, mp.vibe.chWidth);
    setColour(ctx, withAlpha(C2.textDim, 0.5));
    strokePath(ctx, wavePath(this.in, this.winStart + 1200, W, r, scale), 1);
    for (let side = 0; side < 2; ++side)
      for (let v = 0; v < this.voices; ++v) {
        const ms = side === 0 ? this.msL[v] : this.msR[v];
        const shift = jlimit2(0, 1199, Math.trunc(ms * 1e-3 * sr));
        const yOff = (side === 0 ? -1 : 1) * r.h * 0.18 * (0.25 + width2);
        const p = wavePath(this.in, this.winStart + 1200 - shift, W, translated2(r, 0, yOff), scale);
        const u0 = side === 0 ? 0.05 : 0.5;
        drawSpectrumLine(ctx, p, r.x, right2(r), u0, u0 + 0.45, 1.4, v === 0 ? 4 : 0, 0.8 - 0.12 * v);
      }
    setFont(ctx, 10.5, "medium");
    setColour(ctx, C2.textFaint);
    drawText(ctx, "Left voices", withHeight(r, 14), Justification.topLeft);
    drawText(ctx, "Right voices", withTop(r, bottom(r) - 14), Justification.bottomLeft);
  }
  paintPhaser(ctx, r) {
    const proc2 = this.proc;
    if (proc2.paramValue(this.id, mp.vibe.phOn) < 0.5)
      return drawOffHint(ctx, r, this.id);
    const sr = proc2.analysis.sampleRate;
    const mix = proc2.paramValue(this.id, mp.vibe.phMix);
    const stages = this.stages, fb = this.fb;
    for (let side = 1; side >= 0; --side) {
      const fc = side === 0 ? this.fcL : this.fcR;
      const t = Math.tan(Math.PI * Math.min(fc, 0.45 * sr) / sr);
      const a = (t - 1) / (t + 1);
      const p = new Path2D();
      for (let i = 0; i <= 200; ++i) {
        const f2 = 20 * Math.pow(1e3, i / 200);
        const zr = Math.cos(-TWO_PI2 * f2 / sr), zi = Math.sin(-TWO_PI2 * f2 / sr);
        const nr = a + zr, ni = zi, dr = 1 + a * zr, di = a * zi, dd = dr * dr + di * di;
        const apr = (nr * dr + ni * di) / dd, api = (ni * dr - nr * di) / dd;
        const lm = Math.exp(stages * Math.log(Math.hypot(apr, api))), th = stages * Math.atan2(api, apr);
        const Ar = lm * Math.cos(th), Ai = lm * Math.sin(th);
        const er = 1 - fb * Ar, ei = -fb * Ai, ee = er * er + ei * ei;
        const wr = (Ar * er + Ai * ei) / ee, wi = (Ai * er - Ar * ei) / ee;
        const mag = Math.hypot(1 - 0.5 * mix + 0.5 * mix * wr, 0.5 * mix * wi);
        const dB = jlimit2(-36, 9, 20 * Math.log10(mag + 1e-9));
        const x = r.x + r.w * i / 200;
        const y = jmap(dB, -36, 9, bottom(r), r.y);
        if (i === 0)
          p.moveTo(x, y);
        else
          p.lineTo(x, y);
      }
      if (side === 0) {
        const fill = new Path2D(p);
        fill.lineTo(right2(r), bottom(r));
        fill.lineTo(r.x, bottom(r));
        fill.closePath();
        setGradientFill(ctx, spectrumGradient(ctx, r.x, right2(r), 0.05, 0.95, 0.08));
        ctx.fill(fill);
        drawSpectrumLine(ctx, p, r.x, right2(r), 0.05, 0.95, 2, 6);
      } else {
        setColour(ctx, withAlpha(C2.text, 0.35));
        strokePath(ctx, p, 1);
      }
    }
    setFont(ctx, 10, "medium");
    setColour(ctx, C2.textFaint);
    for (const f2 of [100, 1e3, 1e4]) {
      const x = r.x + r.w * Math.log(f2 / 20) / Math.log(1e3);
      drawText(
        ctx,
        f2 >= 1e3 ? `${Math.trunc(f2 / 1e3)}k` : `${Math.trunc(f2)}`,
        rect(x - 20, bottom(r) + 2, 40, 12),
        Justification.centred
      );
    }
  }
};
__publicField(_VibeVisual, "N", 4096);
__publicField(_VibeVisual, "W", 520);
var VibeVisual = _VibeVisual;
var G = class _G {
  constructor() {
    this.alive = false;
    this.reverse = false;
    this.position = 0;
    this.semis = 0;
    this.env = 0;
    this.size = 0;
    this.pan = 0;
  }
  copy() {
    return Object.assign(new _G(), this);
  }
};
var pitchColour = (semis) => spectrum(0.62 - jlimit2(-26, 26, semis) / 26 * 0.42);
var GRID_BRIGHT = brighter2(C2.grid, 0.25);
var GrainVisual = class extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    this.grains = Array.from({ length: GRAIN_MAX }, () => new G());
    this.trails = [];
    this.bufferSeconds = 2.5;
  }
  tick() {
    const t = this.proc.analysis.grain;
    this.bufferSeconds = t.bufferSeconds;
    const trails = this.trails;
    for (const tr of trails)
      tr.env = fround(tr.env * fround(0.94));
    let kept = 0;
    for (const tr of trails)
      if (!(tr.env < 0.03)) trails[kept++] = tr;
    trails.length = kept;
    for (let k = 0; k < this.grains.length; ++k) {
      const v = t.grains[k];
      const gview = this.grains[k];
      const wasAlive = gview.alive;
      gview.alive = !!v.alive;
      if (wasAlive && !gview.alive && trails.length < 256) {
        const tr = gview.copy();
        tr.env = fround(0.7);
        trails.push(tr);
      }
      if (!gview.alive)
        continue;
      gview.position = v.position;
      gview.semis = v.semis;
      gview.env = v.env;
      gview.size = v.size;
      gview.reverse = !!v.reverse;
      gview.pan = v.pan;
    }
    this.clock += 0.016;
  }
  paint(ctx) {
    const r = reduced2(localBounds(this), 30, 30);
    if (!this.isOn())
      return drawOffHint(ctx, r, this.id);
    setFont(ctx, 10, "medium");
    for (const st of [-24, -12, 0, 12, 24]) {
      const y = centreY(r) - st / 26 * r.h * 0.5;
      setColour(ctx, st === 0 ? withAlpha(C2.film, 0.1) : GRID_BRIGHT);
      drawHorizontalLine(ctx, Math.trunc(y), r.x, right2(r));
      setColour(ctx, C2.textFaint);
      drawText(ctx, `${st > 0 ? "+" : ""}${st}`, rect(r.x - 28, y - 6, 24, 12), Justification.centredRight);
    }
    setColour(ctx, C2.textFaint);
    drawText(ctx, "Now", rect(right2(r) - 30, bottom(r) + 2, 30, 12), Justification.centredRight);
    drawText(ctx, `-${this.bufferSeconds.toFixed(1)} s`, rect(r.x, bottom(r) + 2, 60, 12), Justification.centredLeft);
    for (const tr of this.trails) {
      const x = right2(r) - tr.position * r.w;
      const y = centreY(r) - tr.semis / 26 * r.h * 0.5 - tr.pan * 22;
      const w = Math.max(6, tr.size / this.bufferSeconds * r.w);
      setColour(ctx, withAlpha(tr.reverse ? C2.text : pitchColour(tr.semis), 0.35 * tr.env));
      fillRoundedRectangle(ctx, rect(x - (tr.reverse ? w : 0), y - 2.5, w, 5), 2.5);
    }
    for (const gr of this.grains) {
      if (!gr.alive)
        continue;
      const x = right2(r) - gr.position * r.w;
      const y = centreY(r) - gr.semis / 26 * r.h * 0.5 - gr.pan * 22;
      const w = Math.max(6, gr.size / this.bufferSeconds * r.w);
      const h = 5 + 9 * gr.env;
      const c = gr.reverse ? C2.text : pitchColour(gr.semis);
      const blob = rect(x - (gr.reverse ? w : 0), y - h * 0.5, w, h);
      setColour(ctx, withAlpha(c, 0.12 * gr.env + 0.03));
      fillRoundedRectangle(ctx, expanded2(blob, 4), h);
      setColour(ctx, withAlpha(c, 0.25 + 0.7 * gr.env));
      fillRoundedRectangle(ctx, blob, h * 0.5);
      setColour(ctx, withAlpha(C2.text, 0.8 * gr.env));
      fillEllipse2(ctx, x - 2, y - 2, 4, 4);
    }
  }
};
var _DelayVisual = class _DelayVisual extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    const n = _DelayVisual.maxCount;
    this.l = new Float32Array(n);
    this.r = new Float32Array(n);
    this.lSize = 0;
    this.rSize = 0;
    this.count = 16;
    this.ms = 375;
    this.feedback = 0;
    this.pts = new Float32Array(2 * n);
    this.hue = new Float32Array(n);
  }
  tick() {
    const t = this.proc.analysis.delay;
    this.ms = Math.max(5, 0.5 * (t.msL + t.msR));
    const pps = t.pointsPerSecond;
    this.count = jlimit2(16, _DelayVisual.maxCount, Math.trunc(this.ms * 1e-3 * pps));
    this.lSize = this.rSize = this.count;
    t.writeL.ring.readLatest(this.l, this.count);
    t.writeR.ring.readLatest(this.r, this.count);
    this.feedback = t.feedback;
  }
  paint(ctx) {
    const area = reduced2(localBounds(this), 20);
    if (!this.isOn())
      return drawOffHint(ctx, area, this.id);
    const c = { x: centreX(area), y: centreY(area) };
    const base = Math.min(area.w, area.h) * 0.5;
    const pitchPage = this.page === 1;
    const hueShift = pitchPage ? 0.5 : 0;
    const stereo = roundToInt(this.proc.paramValue(this.id, mp.delay.anStereo));
    const count = this.count;
    const ring = (env, envSize, radius, whiten2) => {
      if (envSize < count)
        return;
      const pts = this.pts, hue = this.hue;
      let n = 0;
      const stride = Math.max(1, Math.trunc(count / 360));
      for (let k = 0; k < count; k += stride) {
        const a = TWO_PI2 * k / count;
        let v = 0;
        for (let j = k; j < Math.min(count, k + stride); ++j)
          v = Math.max(v, env[count - 1 - j]);
        const rr = radius + base * 0.28 * jlimit2(0, 1, (20 * Math.log10(v + 1e-6) + 54) / 54);
        pts[2 * n] = c.x + rr * Math.sin(-a);
        pts[2 * n + 1] = c.y - rr * Math.cos(-a);
        hue[n] = 1 - k / count + hueShift;
        ++n;
      }
      setColour(ctx, withAlpha(C2.film, 0.1));
      drawEllipse(ctx, c.x - radius, c.y - radius, radius * 2, radius * 2, 1);
      const run = 8;
      ctx.lineJoin = "bevel";
      ctx.lineCap = "butt";
      for (let pass = 0; pass < 2; ++pass)
        for (let s = 0; s < n; s += run) {
          ctx.beginPath();
          ctx.moveTo(pts[2 * s], pts[2 * s + 1]);
          for (let j = s + 1; j <= Math.min(s + run, n); ++j)
            ctx.lineTo(pts[2 * (j % n)], pts[2 * (j % n) + 1]);
          const col = spectrum(hue[Math.min(n - 1, s + run / 2)]);
          if (pass === 0) {
            setColour(ctx, withAlpha(col, 0.24));
            ctx.lineWidth = 1.5 + 6 * 0.7;
          } else {
            setColour(ctx, interpolatedWith(col, C2.white, 0.38 + whiten2));
            ctx.lineWidth = 1.5;
          }
          ctx.stroke();
        }
    };
    if (stereo === 0 && !pitchPage)
      ring(this.l, this.lSize, base * 0.42, 0);
    else {
      ring(this.l, this.lSize, base * 0.48, 0);
      ring(this.r, this.rSize, base * 0.3, 0.2);
    }
    const head = new Path2D();
    head.moveTo(c.x - 4, c.y - base * 0.95);
    head.lineTo(c.x + 4, c.y - base * 0.95);
    head.lineTo(c.x, c.y - base * 0.89);
    head.closePath();
    setColour(ctx, C2.textDim);
    ctx.fill(head);
    setFont(ctx, 11, "medium");
    setColour(ctx, C2.textDim);
    drawText(ctx, `${roundToInt(this.ms)} ms`, removeFromBottom(reduced2(localBounds(this), 16, 4), 18), Justification.centredLeft);
  }
};
__publicField(_DelayVisual, "maxCount", 4e3);
var DelayVisual = _DelayVisual;
var ScanVisual = class extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    this.in = new Float32Array(SCAN_BANDS);
    this.out = new Float32Array(SCAN_BANDS);
    this.drawMode = false;
    this.lastIdx = -1;
  }
  tick() {
    const t = this.proc.analysis.scan;
    const toDb = (v) => jlimit2(-84, 0, 20 * Math.log10(v + 1e-7));
    for (let b = 0; b < SCAN_BANDS; ++b) {
      const i = toDb(t.in[b]), o = toDb(t.out[b]);
      this.in[b] += (i > this.in[b] ? 0.6 : 0.15) * (i - this.in[b]);
      this.out[b] += (o > this.out[b] ? 0.6 : 0.15) * (o - this.out[b]);
    }
    this.drawMode = roundToInt(this.proc.paramValue(this.id, mp.scan.shape)) === 8;
    this.setInterceptsMouseClicks(this.drawMode, false);
  }
  paint(ctx) {
    const proc2 = this.proc, id = this.id;
    const r = reduced2(localBounds(this), 26, 28);
    if (!this.isOn())
      return drawOffHint(ctx, r, id);
    const bw = r.w / SCAN_BANDS;
    const yFor = (db) => jmap(db, -84, 0, bottom(r), r.y);
    for (let b = 0; b < SCAN_BANDS; ++b) {
      const x = r.x + b * bw;
      setColour(ctx, withAlpha(C2.white, 0.12));
      ctx.fillRect(x + 0.5, yFor(this.in[b]), bw - 1, bottom(r) - yFor(this.in[b]));
      setColour(ctx, withAlpha(spectrum(0.05 + 0.9 * b / (SCAN_BANDS - 1)), 0.88));
      ctx.fillRect(x + 0.5, yFor(this.out[b]), bw - 1, bottom(r) - yFor(this.out[b]));
    }
    const shape = roundToInt(proc2.paramValue(id, mp.scan.shape));
    const phase = proc2.analysis.slots[id].effective[mp.scan.phase];
    const phaseModded = ((proc2.getModMask(id, 0) | proc2.getModMask(id, 1)) >>> mp.scan.phase & 1) !== 0;
    const ph = phaseModded ? phase : proc2.paramValue(id, mp.scan.phase);
    const invert = proc2.paramValue(id, mp.scan.invert) > 0.5;
    const table = proc2.scanTable();
    const mask = new Path2D();
    for (let i = 0; i <= 240; ++i) {
      const u = i / 240;
      let m = ScanModule.shapeValue(shape, u, ph, table);
      if (invert)
        m = 1 - m;
      const x = r.x + u * r.w, y = bottom(r) - m * r.h;
      if (i === 0)
        mask.moveTo(x, y);
      else
        mask.lineTo(x, y);
    }
    drawGlow(ctx, mask, colours.text, 1.4, 5, 0.85);
    if (this.drawMode) {
      setFont(ctx, 11, "medium");
      setColour(ctx, C2.textDim);
      drawText(
        ctx,
        "Draw on the display to shape the mask",
        withHeight(reduced2(localBounds(this), 16, 4), 18),
        Justification.centredRight
      );
    }
  }
  mouseDown(e) {
    this.lastIdx = -1;
    this.mouseDrag(e);
  }
  mouseDrag(e) {
    if (!this.drawMode)
      return;
    const proc2 = this.proc, tableSize = ScanModule.tableSize;
    const r = reduced2(localBounds(this), 26, 28);
    const u = jlimit2(0, 0.999, (e.x - r.x) / r.w);
    const v = jlimit2(0, 1, (bottom(r) - e.y) / r.h);
    const ph = proc2.paramValue(this.id, mp.scan.phase);
    let pos = u + ph;
    pos -= Math.floor(pos);
    const idx = jlimit2(0, tableSize - 1, Math.trunc(pos * tableSize));
    const table = proc2.scanTable();
    if (this.lastIdx >= 0 && Math.abs(idx - this.lastIdx) < tableSize / 2) {
      const a = Math.min(idx, this.lastIdx), b = Math.max(idx, this.lastIdx);
      for (let i = a; i <= b; ++i)
        table[i] = v;
    }
    table[idx] = v;
    this.lastIdx = idx;
    proc2.pushScanTable();
  }
};
var Spectrum = class {
  constructor(order = 11, points = 128) {
    this.fftSize = 1 << order;
    this.numPoints = points;
    this.fft = new FFT(order);
    this.window = new Float32Array(this.fftSize);
    for (let i = 0; i < this.fftSize; ++i)
      this.window[i] = 0.5 - 0.5 * Math.cos(TWO_PI2 * i / (this.fftSize - 1));
    this.data = new Float32Array(this.fftSize * 2);
    this.smoothed = new Float32Array(this.numPoints).fill(-120);
  }
  // returns per-point level in dB (0 dBFS sine ~ 0 dB), smoothed with fast attack / slow release
  process(ring, sampleRate, attack = 0.6, release = 0.2) {
    const data = this.data, fftSize = this.fftSize, numPoints = this.numPoints;
    data.fill(0);
    ring.readLatest(data, fftSize);
    for (let i = 0; i < fftSize; ++i)
      data[i] *= this.window[i];
    this.fft.performFrequencyOnlyForwardTransform(data);
    const norm = 4 / fftSize;
    const binHz = sampleRate / fftSize;
    const maxBin = fftSize / 2 - 1;
    for (let p = 0; p < numPoints; ++p) {
      const f0 = 20 * Math.pow(1e3, p / numPoints);
      const f1 = 20 * Math.pow(1e3, (p + 1) / numPoints);
      let mag = 0;
      for (let b = jlimit2(0, maxBin, Math.trunc(f0 / binHz)); b <= jlimit2(0, maxBin, Math.trunc(f1 / binHz)); ++b)
        mag = Math.max(mag, data[b]);
      const db = Math.max(-120, 20 * Math.log10(mag * norm + 1e-7) + 3 * Math.log2(f0 / 1e3));
      const s = this.smoothed[p];
      this.smoothed[p] = s + (db > s ? attack : release) * (db - s);
    }
    return this.smoothed;
  }
  db() {
    return this.smoothed;
  }
  size() {
    return this.numPoints;
  }
};
function createImage(w, h) {
  let canvas2 = null, ctx = null;
  if (typeof OffscreenCanvas !== "undefined") {
    try {
      canvas2 = new OffscreenCanvas(w, h);
      ctx = canvas2.getContext("2d");
    } catch {
      ctx = null;
    }
  }
  if (!ctx && typeof document !== "undefined") {
    canvas2 = document.createElement("canvas");
    canvas2.width = w;
    canvas2.height = h;
    ctx = canvas2.getContext("2d");
  }
  if (!ctx)
    return null;
  return { canvas: canvas2, ctx, pixels: ctx.createImageData(w, h), w, h };
}
var SpaceVisual = class extends ModuleVisual {
  constructor(proc2, m) {
    super(proc2, m);
    this.analyser = new Spectrum(11, 96);
    this.image = null;
    this.rowColour = [];
  }
  resized() {
    const rw = Math.max(0, Math.round(this.w) - 48), rh = Math.max(0, Math.round(this.h) - 52);
    this.image = createImage(Math.max(8, Math.trunc(rw / 2)), Math.max(8, Math.trunc(rh / 2)));
    if (!this.image)
      return;
    const h = this.image.h;
    this.rowColour = [];
    for (let y = 0; y < h; ++y)
      this.rowColour.push(spectrumRgb(0.05 + 0.9 * y / (h - 1)));
  }
  tick() {
    const image = this.image;
    if (!image)
      return;
    const analyser = this.analyser;
    const spec = analyser.process(this.proc.analysis.space.wet, this.proc.analysis.sampleRate, 1, 1);
    const d = image.pixels.data;
    d.copyWithin(0, 4);
    const x = image.w - 1, h = image.h;
    for (let y = 0; y < h; ++y) {
      const c = this.rowColour[y];
      const p = jlimit2(0, analyser.size() - 1, Math.trunc((1 - y / (h - 1)) * (analyser.size() - 1)));
      const level = jlimit2(0, 1, (spec[p] + 84) / 72);
      const px = level < 0.75 ? c : interpolatedWith(c, C2.text, (level - 0.75) * 3);
      const alpha = level < 0.75 ? level * level * 1.3 : 1;
      const o = 4 * (y * image.w + x);
      d[o] = px[0];
      d[o + 1] = px[1];
      d[o + 2] = px[2];
      d[o + 3] = alpha <= 0 ? 0 : alpha >= 1 ? 255 : roundToInt(alpha * 255);
    }
    image.ctx.putImageData(image.pixels, 0, 0);
  }
  paint(ctx) {
    const r = reduced2(localBounds(this), 24, 26);
    if (!this.isOn())
      return drawOffHint(ctx, r, this.id);
    if (this.image) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "low";
      ctx.drawImage(this.image.canvas, r.x, r.y, r.w, r.h);
    }
    setFont(ctx, 10, "medium");
    setColour(ctx, C2.textFaint);
    for (const f2 of [100, 1e3, 1e4]) {
      const y = bottom(r) - r.h * Math.log(f2 / 20) / Math.log(1e3);
      drawText(
        ctx,
        f2 >= 1e3 ? `${Math.trunc(f2 / 1e3)}k` : `${Math.trunc(f2)}`,
        rect(r.x + 2, y - 6, 30, 12),
        Justification.centredLeft
      );
    }
    drawText(ctx, "Now", rect(right2(r) - 30, bottom(r) + 2, 30, 12), Justification.centredRight);
    drawText(ctx, "Tail \u2192", rect(r.x, bottom(r) + 2, 80, 12), Justification.centredLeft);
  }
};
function createVisual(proc2, m) {
  switch (m) {
    case 0:
      return new DriveVisual(proc2, m);
    case 1:
      return new LofiVisual(proc2, m);
    case 2:
      return new ChopVisual(proc2, m);
    case 3:
      return new VibeVisual(proc2, m);
    case 4:
      return new GrainVisual(proc2, m);
    case 5:
      return new DelayVisual(proc2, m);
    case 6:
      return new ScanVisual(proc2, m);
    case 7:
      return new SpaceVisual(proc2, m);
    default:
      return null;
  }
}

// xray-demo-stage/src/app/screen.js
var white = (a) => `rgba(255,255,255,${a})`;
var withAlpha2 = (hex, a) => rgba(hexRgb(hex), a);
function smallChevron(ctx, c, col) {
  ctx.beginPath();
  ctx.moveTo(c.x - 3, c.y - 1.5);
  ctx.lineTo(c.x, c.y + 1.5);
  ctx.lineTo(c.x + 3, c.y - 1.5);
  ctx.strokeStyle = col;
  ctx.lineWidth = 1.3;
  ctx.lineCap = "round";
  ctx.lineJoin = "round";
  ctx.stroke();
}
function starPath(cx, cy, points, inner, outer) {
  const p = new Path2D();
  for (let i = 0; i < points * 2; ++i) {
    const a = i * Math.PI / points, r = i & 1 ? inner : outer;
    const x = cx + r * Math.sin(a), y = cy - r * Math.cos(a);
    if (i === 0) p.moveTo(x, y);
    else p.lineTo(x, y);
  }
  p.closePath();
  return p;
}
var DESCRIPTIONS = {
  // drive
  drive_model: "Drive model. tube: warm and lopsided (even harmonics). tape: soft, treble squashes first. opamp: hard rail clipping. fold: the wave folds back on itself.",
  drive_gain: "How hard the signal hits the drive stage.",
  drive_tone: "Tilt EQ after the drive: left darker, right brighter.",
  drive_bias: "Pushes the signal off-centre into the curve, which adds even harmonics.",
  drive_character: "Sag: louder notes push the bias further, like a tube power supply struggling. Adds bloom and squish.",
  drive_headroom: "Output ceiling. Lower it to clamp the peaks harder.",
  drive_boost: "A boost pedal in front: +8 dB with a mid hump.",
  drive_match: "Auto gain: keeps the output as loud as the input, so you judge the tone, not the volume.",
  // lofi
  lofi_mode: "sample: vintage sampler (aliasing, crushed bits). tape: cassette (wow, flutter, saturation). digital: harsh bitcrush and sample-and-hold.",
  lofi_type: "How worn the machine is: clean, worn, warped, broken, ancient.",
  lofi_crush: "The main amount: lower sample rate and bit depth (sample/digital), harder saturation (tape).",
  lofi_flutter: "Fast pitch wobble.",
  lofi_wow: "Slow pitch drift, like a stretched tape or a warped record.",
  lofi_dropouts: "Random volume dips, like worn tape losing contact.",
  lofi_wear: "Treble loss from age.",
  lofi_noise: "Noise bed: hiss, crackle, hum, rain or room. It runs through the crusher too.",
  lofi_noise_level: "Level of the noise bed.",
  lofi_duck: "Noise ducks under the music and comes up in the gaps.",
  lofi_tilt: "Tilt EQ: left darker, right brighter.",
  lofi_bits: "Bit depth ceiling (crush lowers it further).",
  lofi_rate: "Sample rate ceiling (crush lowers it further).",
  // chop
  chop_size: "How much audio one chop pattern spans before it repeats or re-rolls.",
  chop_slice: "Length of each slice.",
  chop_repeat: "Chance a slice replays the one before it.",
  chop_stutter: "Repeated slices stutter at this fraction of a slice.",
  chop_shuffle: "Chance a slice is swapped for an earlier one.",
  chop_reverse: "Chance a slice plays backwards.",
  chop_pitch_up: "Allow octave-up jumps.",
  chop_pitch_down: "Allow octave-down jumps.",
  chop_pitch_amt: "Chance a slice jumps an octave.",
  chop_glide: "How slowly pitch jumps slide into place.",
  chop_smooth: "Crossfade length at slice edges: 0 = tight cuts, higher = softer.",
  chop_stretch: "Chance of a tape-stop slowdown.",
  chop_chaos: "Randomises all the chances every cycle.",
  chop_target: "Chop the full signal, or only its low, mid or high band.",
  chop_seed: "The pattern's seed: the same seed always gives the same pattern.",
  chop_lock: "On: the pattern repeats every cycle. Off: a new pattern each cycle (still from the seed).",
  // vibe
  vibe_ch_mode: "clean chorus: two voices. lush chorus: four detuned voices. flanger: short delay with feedback. vintage: dark, gritty bucket-brigade chorus.",
  vibe_ch_depth: "How far the voices drift in time.",
  vibe_ch_width: "How far apart left and right move.",
  vibe_ch_rate: "Modulation speed.",
  vibe_ch_color: "Tone of the chorus voices: left darker, right brighter.",
  vibe_ch_motion: "Random drift of speed and depth, like an old unit.",
  vibe_ch_delay: "Base delay of the voices.",
  vibe_ch_feedback: "Feeds the voices back in (strongest in flanger mode).",
  vibe_ph_mode: "smooth: 6 stages. deep: 10 stages. vintage: 4 saturated stages. ring: inverted feedback, try very fast rates.",
  vibe_ph_depth: "How wide the notches sweep.",
  vibe_ph_rate: "Sweep speed (up to audio-rate wobble).",
  vibe_ph_feedback: "Resonance of the notches.",
  vibe_ph_sync: "Lock the sweep to the tempo.",
  vibe_ph_div: "Sweep length as a note value.",
  // grain
  grain_mode: "classic: grains from the recent past. crystal: a frozen loop replayed with octave and reversed layers.",
  grain_size: "Length of each grain.",
  grain_density: "How many grains per second.",
  grain_position: "How far back in time grains are taken from.",
  grain_pitch: "Pitch of the grains.",
  grain_jitter: "Randomises grain timing, position and pitch.",
  grain_reverse: "Chance a grain plays backwards.",
  grain_feedback: "Feeds the grain cloud back into the buffer, so layers build up.",
  grain_filter: "One knob: left low-pass, right high-pass.",
  grain_spread: "Stereo spread of the grains.",
  // delay
  delay_an_sync: "Lock the delay time to the tempo.",
  delay_an_div: "Delay time as a note value.",
  delay_an_time: "Delay time. Changing it glides like tape: drag the XY pad for whips.",
  delay_an_feedback: "How many repeats.",
  delay_an_mod: "How much the delay time wobbles.",
  delay_an_rate: "Wobble speed.",
  delay_an_drive: "Saturation inside the feedback loop.",
  delay_an_filter: "Tone of the repeats: left low-pass, right high-pass.",
  delay_an_stereo: "mono, wide (left/right wobble apart), or ping-pong.",
  delay_pi_sync: "Lock the delay time to the tempo.",
  delay_pi_div: "Delay time as a note value.",
  delay_pi_time: "Delay time.",
  delay_pi_feedback: "How many repeats; each repeat is shifted again, so they climb or fall.",
  delay_pi_int_a: "Pitch interval of every left repeat.",
  delay_pi_int_b: "Pitch interval of every right repeat.",
  delay_pi_glide: "How slowly interval changes slide.",
  delay_pi_spread: "Offsets the left and right delay times.",
  delay_pi_filter: "Tone of the repeats: left low-pass, right high-pass.",
  // scan
  scan_mode: "filter: carve the spectrum with the shape. smear: hold and blur what the shape lets through. gate: only strong partials pass.",
  scan_shape: "The shape laid across the spectrum. Pick draw, then paint your own on the display.",
  scan_strength: "How strongly the shape is applied.",
  scan_phase: "Slides the shape across the spectrum. Put an LFO on it for moving combs.",
  scan_smooth: "Smooths the mask over time, from crisp to dreamy.",
  scan_shift: "Shifts the whole output spectrum up or down (inharmonic).",
  scan_invert: "Flips the shape: open becomes closed.",
  scan_frame: "FFT frame size: bigger = finer frequency detail, more latency.",
  // space
  space_type: "room, hall, plate, spring, chamber or cathedral.",
  space_size: "How long the tail rings (time to fall 60 dB).",
  space_width: "Stereo width of the tail.",
  space_damp: "How fast the highs die away in the tail.",
  space_predelay: "Gap before the reverb starts, keeps the dry hit clear.",
  space_tilt: "Tilt EQ of the tail: left darker, right brighter.",
  space_filter: "One knob on the tail: left low-pass, right high-pass."
};
function describeParam(id) {
  if (DESCRIPTIONS[id]) return DESCRIPTIONS[id];
  if (id.includes("_lfo_")) {
    if (id.endsWith("mod1") || id.endsWith("mod2"))
      return "Modulation lane. Drag the star onto any parameter to modulate it (drag again to remove, right-click the star to clear). The value sets how far and in which direction.";
    if (id.endsWith("rate")) return "LFO speed when running freely.";
    if (id.endsWith("div")) return "LFO cycle length as a note value.";
    if (id.endsWith("sync")) return "Lock the LFO to the tempo.";
    if (id.endsWith("shape")) return "LFO shape: sine, triangle, saw, reverse saw, square, random steps, stairs or drift (slow wandering).";
    if (id.endsWith("warp")) return "Bends the LFO cycle so it lingers at the ends.";
    if (id.endsWith("asym")) return "Moves the middle of the cycle earlier or later.";
    if (id.endsWith("slew")) return "Rounds off jumps in the LFO.";
    if (id.endsWith("polarity")) return "bi: swings both ways around the setting. uni: only pushes one way.";
  }
  return "";
}
var ParamCell = class extends Component {
  // lfoIndex >= 0: this cell edits the module's LFO parameter instead of a module parameter
  constructor(proc2, module, paramIndex, lfoIndex) {
    super();
    this.proc = proc2;
    this.module = module;
    this.index = paramIndex;
    this.lfoIndex = lfoIndex;
    if (lfoIndex >= 0) {
      this.def = { ...LFO_DEFS[module][lfoIndex] };
      this.param = proc2.lfoParam(module, lfoIndex);
    } else {
      this.def = { ...MODULE_DEFS[module].params[paramIndex] };
      this.param = proc2.param(module, paramIndex);
    }
    this.lastText = "";
    this.lastEffective = -1;
    this.dragStart = 0;
    this.dragging = false;
    this.dropHover = false;
    this.moved = false;
    this.frameless = false;
    this.hot = false;
    this.cursor = this.def.kind === "float" || this.def.kind === "int" ? "ns-resize" : "pointer";
    this.refresh();
  }
  setFrameless(f2) {
    this.frameless = f2;
  }
  refresh() {
    this.lastText = this.param.getCurrentValueAsText();
    let eff = -1;
    if (this.lfoIndex < 0) {
      const bit = 1 << this.index >>> 0;
      if (((this.proc.getModMask(this.module, 0) | this.proc.getModMask(this.module, 1)) & bit) !== 0)
        eff = this.proc.analysis.slots[this.module].effective[this.index];
    }
    this.lastEffective = eff;
  }
  valueArea() {
    return { x: 10, y: 0, w: this.w - 20, h: this.h };
  }
  displayLabel() {
    const shorter = { "lp/hp": "Filter", "phase warp": "Warp", asymmetry: "Asym" };
    return shorter[this.def.label] ?? capitalised(this.def.label);
  }
  paint(ctx) {
    const proc2 = this.proc;
    const r = { x: 0.5, y: 0.5, w: this.w - 1, h: this.h - 1 };
    const hot = this.hot || this.dragging;
    const bit = this.lfoIndex < 0 ? 1 << this.index >>> 0 : 0;
    const in1 = (proc2.getModMask(this.module, 0) & bit) !== 0, in2 = (proc2.getModMask(this.module, 1) & bit) !== 0;
    if (!this.frameless || this.dropHover) {
      fillRoundRect(ctx, r.x, r.y, r.w, r.h, 9, white(this.dropHover ? 0.14 : hot ? 0.1 : 0.063));
      if (this.dropHover || in1 || in2)
        strokeRoundRect(
          ctx,
          r.x + 0.5,
          r.y + 0.5,
          r.w - 1,
          r.h - 1,
          9,
          this.dropHover ? colours.lane1 : withAlpha2(in1 ? colours.lane1 : colours.lane2, 0.45),
          this.dropHover ? 1.4 : 1
        );
    }
    const area = this.valueArea();
    const isBool = this.def.kind === "bool";
    const on = isBool && this.param.getValue() > 0.5;
    const value = isBool ? on ? "On" : "Off" : capitalised(this.lastText);
    const labelText = this.displayLabel();
    const labelFont = this.frameless ? sans(12, "medium") : sans(11);
    const valueFont = sans(12, "medium");
    const lw = labelText ? textWidth(ctx, labelText, labelFont) : 0;
    const vw = textWidth(ctx, value, valueFont);
    if (this.frameless) {
      drawTextIn(ctx, labelText, { ...area, w: area.w - vw - 5 }, labelFont, colours.textDim, "right");
      drawTextIn(ctx, value, area, valueFont, hot ? colours.text : "rgba(245,245,247,0.92)", "right");
    } else {
      const labelRoom = area.w - vw - 6;
      const showLabel = lw > 0 && labelRoom >= 22;
      if (showLabel) drawTextIn(ctx, labelText, { ...area, w: labelRoom }, labelFont, colours.textDim, "left", true);
      const col = isBool && !on ? colours.textDim : hot ? "#ffffff" : colours.text;
      drawFitted(ctx, value, area, valueFont, col, showLabel || lw > 0 ? "right" : "centre");
    }
    this.paintExtra(ctx, r);
    if (in1 || in2) {
      const bar = { x: r.x + 10, y: r.y + r.h - 4.5, w: r.w - 20, h: 1.5 };
      const base = this.param.getValue();
      const scale = proc2.lfoParam(this.module, lfoIdx.polarity).getValue() > 0.5 ? 1 : 0.5;
      let amt = 0;
      if (in1) amt += proc2.lfoParam(this.module, lfoIdx.mod1).get();
      if (in2) amt += proc2.lfoParam(this.module, lfoIdx.mod2).get();
      const lo = Math.max(0, Math.min(1, base - Math.abs(amt) * scale)), hi = Math.max(0, Math.min(1, base + Math.abs(amt) * scale));
      fillRoundRect(ctx, bar.x, bar.y, bar.w, bar.h, 0.75, white(0.08));
      fillRoundRect(ctx, bar.x + bar.w * lo, bar.y, Math.max(1.5, bar.w * (hi - lo)), bar.h, 0.75, withAlpha2(in1 ? colours.lane1 : colours.lane2, 0.55));
      if (this.lastEffective >= 0)
        fillEllipse(ctx, bar.x + bar.w * this.lastEffective - 2.5, bar.y + bar.h / 2 - 2.5, 5, 5, in1 ? colours.lane1 : colours.lane2);
    }
  }
  paintExtra() {
  }
  mouseDown() {
    this.dragging = false;
    this.moved = false;
    this.dragStart = this.param.getValue();
    if (this.def.kind !== "bool") this.dragging = true;
  }
  mouseDrag(e) {
    if (!this.dragging) return;
    const dy = e.dy;
    if (Math.abs(dy) < 3 && !this.moved) return;
    this.moved = true;
    let v;
    if (this.def.kind === "choice" || this.def.kind === "int") {
      const steps = this.def.max - this.def.min;
      const perStep = this.def.kind === "choice" ? 18 : Math.max(2, 120 / steps);
      v = this.dragStart + Math.round(-dy / perStep) / Math.max(1, steps);
    } else {
      v = this.dragStart - dy / (e.mods.shift ? 700 : 170);
    }
    this.param.setValueNotifyingHost(Math.max(0, Math.min(1, v)));
  }
  mouseUp(e) {
    this.dragging = false;
    if (this.moved || e.mods.right) return;
    if (this.def.kind === "bool") toggleParam(this.param);
    else if (this.def.kind === "choice") this.showChoices();
  }
  async showChoices() {
    const current = Math.round(this.param.get());
    const items = this.def.choices.map((c, i) => ({ id: i + 1, text: capitalised(c), checked: i === current }));
    const at = screenRect(this.root(), localToDevice(this, { x: 0, y: 0, w: this.w, h: this.h }));
    const r = await showMenu(items, at, this.root().scale);
    if (r > 0) this.param.set(r - 1);
  }
  mouseDoubleClick() {
    if (this.def.kind === "choice" || this.def.kind === "bool") return;
    this.param.setValueNotifyingHost(this.param.getDefaultValue());
  }
  mouseEnter() {
    this.hot = true;
    const d = describeParam(this.def.id);
    const name = this.displayLabel() || this.def.name.split("LFO ").slice(1).join("LFO ") || this.def.name;
    this.showInfo(`${name}: ${d || this.def.name}`);
  }
  mouseExit() {
    this.hot = false;
    this.showInfo("");
  }
  isInterestedInDragSource(d) {
    return this.lfoIndex < 0 && this.def.kind === "float" && String(d.description).startsWith(`lfo:${this.module}:`);
  }
  itemDragEnter() {
    this.dropHover = true;
  }
  itemDragExit() {
    this.dropHover = false;
  }
  itemDropped(d) {
    this.dropHover = false;
    const lane = parseInt(String(d.description).split(":").pop(), 10) || 0;
    this.proc.toggleModTarget(this.module, Math.max(0, Math.min(1, lane)), this.index);
    this.lastEffective = -2;
  }
};
function drawFitted(ctx, s, r, font, colour2, just) {
  ctx.font = font;
  const w = ctx.measureText(s).width;
  if (w <= r.w) {
    drawTextIn(ctx, s, r, font, colour2, just);
    return;
  }
  const sx = Math.max(0.8, r.w / w);
  ctx.save();
  const ax = just === "right" ? r.x + r.w : just === "centre" ? r.x + r.w / 2 : r.x;
  ctx.translate(ax, 0);
  ctx.scale(sx, 1);
  drawTextIn(ctx, s, { x: just === "right" ? -r.w / sx : just === "centre" ? -r.w / sx / 2 : 0, y: r.y, w: r.w / sx, h: r.h }, font, colour2, just, sx === 0.8);
  ctx.restore();
}
var ModLaneCell = class extends ParamCell {
  constructor(proc2, module, lane) {
    super(proc2, module, -1, lane === 0 ? lfoIdx.mod1 : lfoIdx.mod2);
    this.lane = lane;
    this.def.label = "";
    this.starDrag = false;
  }
  starArea() {
    return { x: 0, y: 0, w: 30, h: this.h };
  }
  valueArea() {
    return { x: 28 + 4, y: 0, w: this.w - 28 - 8 - 6, h: this.h };
  }
  paintExtra(ctx) {
    const c = this.lane === 0 ? colours.lane1 : colours.lane2;
    const a = centre(this.starArea());
    const star = starPath(a.x, a.y, 4, 2, 7.5);
    const assigned = this.proc.getModMask(this.module, this.lane) !== 0;
    drawGlow(ctx, star, assigned ? c : withAlpha2(c, 0.55), 1.2, assigned ? 5 : 0);
    if (assigned) {
      ctx.fillStyle = withAlpha2(c, 0.35);
      ctx.fill(star);
    }
  }
  mouseDown(e) {
    this.starDrag = false;
    this.rootRef = this.root();
    if (contains(this.starArea(), e.x, e.y)) {
      if (e.mods.right) {
        this.proc.setModMask(this.module, this.lane, 0);
        return;
      }
      this.starDrag = true;
      this.cursor = "grab";
      return;
    }
    super.mouseDown(e);
  }
  mouseDrag(e) {
    if (this.starDrag) {
      const root = this.rootRef;
      if (root && !root.isDragAndDropActive()) {
        const col = this.lane === 0 ? colours.lane1 : colours.lane2;
        root.startDragging(`lfo:${this.module}:${this.lane}`, this, (ctx, x, y) => {
          ctx.fillStyle = col;
          ctx.fill(starPath(x, y, 4, 3, 11));
        });
        root.moveDrag({ x: e.deviceX, y: e.deviceY });
      }
      return;
    }
    super.mouseDrag(e);
  }
  mouseMove(e) {
    this.cursor = contains(this.starArea(), e.x, e.y) ? "grab" : "ns-resize";
  }
};
var ShapeCell = class extends ParamCell {
  constructor(proc2, module) {
    super(proc2, module, -1, lfoIdx.shape);
    this.def.label = "";
  }
  valueArea() {
    return { x: 48 + 4, y: 0, w: this.w - 48 - 8 - 6, h: this.h };
  }
  paintExtra(ctx, r) {
    const box = { x: r.x + 10, y: r.y + 10, w: 44 - 20, h: r.h - 20 };
    const shape = Math.round(this.param.get());
    const p = new Path2D();
    for (let i = 0; i <= 40; ++i) {
      const ph = i / 40;
      let v2;
      switch (shape) {
        case 0:
          v2 = Math.sin(2 * Math.PI * ph);
          break;
        case 1:
          v2 = 1 - 4 * Math.abs(ph - 0.5);
          break;
        case 2:
          v2 = 2 * ph - 1;
          break;
        case 3:
          v2 = 1 - 2 * ph;
          break;
        case 4:
          v2 = ph < 0.5 ? 1 : -1;
          break;
        case 5:
          v2 = Math.sin(37 * Math.floor(ph * 6));
          break;
        case 6:
          v2 = Math.floor(ph * 8) / 3.5 - 1;
          break;
        default:
          v2 = 0.6 * Math.sin(2 * Math.PI * ph * 1.3) + 0.3 * Math.sin(11 * ph);
          break;
      }
      const x = box.x + box.w * ph, y = box.y + box.h / 2 - v2 * box.h * 0.5;
      if (i === 0) p.moveTo(x, y);
      else p.lineTo(x, y);
    }
    drawSpectrumLine(ctx, p, box.x, box.x + box.w, 0, 1, 1.2, 3);
    const lv = this.proc.analysis.slots[this.module].lfo;
    const uni = this.proc.lfoParam(this.module, lfoIdx.polarity).getValue() > 0.5;
    const v = uni ? lv * 2 - 1 : lv;
    fillEllipse(ctx, box.x + box.w + 2, box.y + box.h / 2 - v * box.h * 0.5 - 2.5, 5, 5, colours.text);
  }
};
var XYOverlay = class extends Component {
  constructor(proc2) {
    super();
    this.proc = proc2;
    this.module = 0;
    this.pageDef = null;
    this.xIndex = -1;
    this.yIndex = -1;
    this.xLabel = "";
    this.yLabel = "";
    this.dragging = false;
    this.recordArmed = false;
    this.recording = false;
    this.take = [];
    this.onRecordingFinished = null;
    this.cursor = "crosshair";
  }
  setModule(m, page2) {
    this.module = m;
    this.pageDef = page2;
    this.xIndex = page2.xParam;
    this.yIndex = page2.yParam;
    this.xLabel = page2.xLabel;
    this.yLabel = page2.yLabel;
    this.recording = false;
    this.setInterceptsMouseClicks(this.hasAxes(), false);
    this.setVisible(this.hasAxes());
  }
  hasAxes() {
    return this.xIndex >= 0 && this.yIndex >= 0;
  }
  setRecordArmed(a) {
    this.recordArmed = a;
  }
  isRecordArmed() {
    return this.recordArmed;
  }
  pad() {
    return { x: 24, y: 22, w: this.w - 48, h: this.h - 44 };
  }
  resolvedY() {
    const pd = this.pageDef;
    if (pd.syncParam >= 0 && this.proc.paramValue(this.module, pd.syncParam) > 0.5) return pd.yParamSynced;
    return this.yIndex;
  }
  xParam() {
    return this.xIndex >= 0 ? this.proc.param(this.module, this.xIndex) : null;
  }
  yParam() {
    const y = this.resolvedY();
    return y >= 0 ? this.proc.param(this.module, y) : null;
  }
  currentNorm() {
    const ms = this.proc.motion(this.module);
    if (ms.playing && ms.xParam === this.xIndex && ms.yParam === this.resolvedY() && ms.liveX >= 0) return { x: ms.liveX, y: ms.liveY };
    const eff = this.proc.analysis.slots[this.module].effective;
    const mods = this.proc.getModMask(this.module, 0) | this.proc.getModMask(this.module, 1);
    const value = (index, p) => p == null ? 0.5 : mods >>> index & 1 ? eff[index] : p.getValue();
    return { x: value(this.xIndex, this.xParam()), y: value(this.resolvedY(), this.yParam()) };
  }
  refresh() {
  }
  paint(ctx) {
    if (!this.hasAxes()) return;
    const r = this.pad();
    const n = this.currentNorm();
    const p = { x: r.x + n.x * r.w, y: r.y + r.h - n.y * r.h };
    ctx.fillStyle = withAlpha2(colours.film, 0.08);
    ctx.fillRect(r.x, Math.trunc(p.y), r.w, 1);
    ctx.fillRect(Math.trunc(p.x), r.y, 1, r.h);
    const ring = this.recordArmed ? colours.record : colours.text;
    const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, 18);
    g.addColorStop(0, withAlpha2(ring, 0.22));
    g.addColorStop(1, withAlpha2(ring, 0));
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.arc(p.x, p.y, 18, 0, Math.PI * 2);
    ctx.fill();
    const ringPath = new Path2D();
    ringPath.arc(p.x, p.y, 9.5, 0, Math.PI * 2);
    drawGlow(ctx, ringPath, ring, 1.8, 5);
    fillEllipse(ctx, p.x - 2.5, p.y - 2.5, 5, 5, colours.text);
    const f2 = sans(10.5, "medium");
    const col = this.dragging ? colours.textDim : colours.textFaint;
    const xp = this.xParam(), yp = this.yParam();
    const xs = capitalised(this.xLabel) + (this.dragging && xp ? `  ${xp.getCurrentValueAsText()}` : "");
    const ys = capitalised(this.yLabel) + (this.dragging && yp ? `  ${yp.getCurrentValueAsText()}` : "");
    drawTextIn(ctx, xs, { x: 0, y: this.h - 18, w: this.w, h: 18 }, f2, col, "centre");
    ctx.save();
    const cy = this.h * 0.5;
    ctx.translate(11, cy);
    ctx.rotate(-Math.PI / 2);
    drawTextIn(ctx, ys, { x: -150, y: -9, w: 300, h: 18 }, f2, col, "centre");
    ctx.restore();
    if (this.recordArmed)
      drawTextIn(
        ctx,
        this.recording ? "Recording\u2026" : "Armed: drag the dot to record a movement",
        { x: 16, y: 4, w: this.w - 32, h: 18 },
        sans(11, "semibold"),
        colours.record,
        "right"
      );
  }
  setFrom(pos) {
    const r = this.pad();
    const x = Math.max(0, Math.min(1, (pos.x - r.x) / r.w));
    const y = Math.max(0, Math.min(1, (r.y + r.h - pos.y) / r.h));
    this.xParam()?.setValueNotifyingHost(x);
    this.yParam()?.setValueNotifyingHost(y);
    if (this.recording) this.take.push([this.proc.analysis.beat, { x, y }]);
  }
  mouseDown(e) {
    if (!this.hasAxes()) return;
    const ms = this.proc.motion(this.module);
    if (ms.playing) {
      ms.playing = false;
      this.proc.pushMotion(this.module);
    }
    this.dragging = true;
    if (this.recordArmed) {
      this.recording = true;
      this.take = [];
    }
    this.setFrom(e);
  }
  mouseDrag(e) {
    if (this.dragging) this.setFrom(e);
  }
  mouseUp() {
    if (!this.dragging) return;
    this.dragging = false;
    if (this.recording) this.finishRecording();
  }
  finishRecording() {
    this.recording = false;
    this.recordArmed = false;
    const take = this.take;
    if (take.length < 4) return;
    const first = take[0][0], span = take[take.length - 1][0] - first;
    let length = 1;
    while (length < span && length < 16) length *= 2;
    const ms = this.proc.motion(this.module);
    for (let k = 0; k < MOTION_POINTS; ++k) {
      const loopBeat = length * k / MOTION_POINTS;
      let t = (loopBeat - first) % length;
      if (t < 0) t += length;
      t += first;
      let lo = 0, hi = take.length;
      while (lo < hi) {
        const mid = lo + hi >> 1;
        if (take[mid][0] < t) lo = mid + 1;
        else hi = mid;
      }
      let v = lo === take.length ? take[take.length - 1][1] : take[lo][1];
      if (lo > 0 && lo < take.length) {
        const a = take[lo - 1];
        const span2 = take[lo][0] - a[0];
        const f2 = span2 > 1e-9 ? (t - a[0]) / span2 : 0;
        v = { x: a[1].x + (take[lo][1].x - a[1].x) * f2, y: a[1].y + (take[lo][1].y - a[1].y) * f2 };
      }
      ms.path[2 * k] = v.x;
      ms.path[2 * k + 1] = v.y;
    }
    ms.lengthBeats = length;
    ms.xParam = this.xIndex;
    ms.yParam = this.resolvedY();
    ms.hasPath = true;
    ms.playing = true;
    this.proc.pushMotion(this.module);
    this.onRecordingFinished?.();
  }
  generateMotion() {
    if (!this.hasAxes()) return;
    const c = this.currentNorm();
    const a = 1 + Math.floor(Math.random() * 2), b = 1 + Math.floor(Math.random() * 3), phi = Math.random() * Math.PI * 2;
    const ms = this.proc.motion(this.module);
    for (let k = 0; k < MOTION_POINTS; ++k) {
      const t = k / MOTION_POINTS * Math.PI * 2;
      ms.path[2 * k] = Math.max(0, Math.min(1, c.x + 0.28 * Math.sin(a * t + phi)));
      ms.path[2 * k + 1] = Math.max(0, Math.min(1, c.y + 0.28 * Math.sin(b * t)));
    }
    ms.lengthBeats = 8;
    ms.xParam = this.xIndex;
    ms.yParam = this.resolvedY();
    ms.hasPath = true;
    ms.playing = true;
    this.proc.pushMotion(this.module);
  }
  mouseDoubleClick() {
    for (const p of [this.xParam(), this.yParam()]) p?.setValueNotifyingHost(p.getDefaultValue());
  }
  mouseEnter() {
    this.showInfo(`XY pad: drag the dot to move ${this.xLabel} (left/right) and ${this.yLabel} (up/down) together. Double-click to reset.`);
  }
  mouseExit() {
    this.showInfo("");
  }
};
var ScreenButton = class extends Component {
  constructor(text, help) {
    super();
    this.text = text;
    this.help = help;
    this.onClick = null;
    this.hot = false;
    this.cursor = "pointer";
  }
  setText(t) {
    this.text = t;
  }
  paint(ctx) {
    const r = { x: 0.5, y: 0.5, w: this.w - 1, h: this.h - 1 };
    fillRoundRect(ctx, r.x, r.y, r.w, r.h, 9, white(this.hot ? 0.1 : 0.063));
    drawTextIn(ctx, this.text, r, sans(12, "medium"), this.hot ? colours.text : colours.textDim, "centre");
  }
  mouseUp(e) {
    if (this.onClick && this.contains(e.x, e.y)) this.onClick(e);
  }
  mouseEnter() {
    this.hot = true;
    this.showInfo(this.help);
  }
  mouseExit() {
    this.hot = false;
    this.showInfo("");
  }
};
var Drawer = class extends Component {
  paint(ctx) {
    const r = { x: 0.5, y: 0.5, w: this.w - 1, h: this.h - 1 };
    fillRoundRect(ctx, r.x, r.y, r.w, r.h, 14, "rgba(24,25,28,0.94)");
    const g = ctx.createLinearGradient(0, r.y, 0, r.y + 24);
    g.addColorStop(0, white(0.045));
    g.addColorStop(1, white(0));
    fillRoundRect(ctx, r.x, r.y, r.w, r.h, 14, g);
    strokeRoundRect(ctx, r.x, r.y, r.w, r.h, 14, white(0.09), 1);
  }
};
__publicField(Drawer, "pad", 12);
__publicField(Drawer, "gap", 8);
__publicField(Drawer, "cellHeight", 36);
__publicField(Drawer, "height", 12 * 2 + 36 * 2 + 8);
var ChainStrip = class extends Component {
  constructor(proc2) {
    super();
    this.proc = proc2;
    this.order = proc2.getChainOrder();
    this.onSelect = null;
    this.dragSlot = -1;
    this.dropSlot = -1;
    this.dragging = false;
    this.hoverShuffle = false;
    this.dragX = 0;
    this.grab = 0;
    this.clipsChildren = false;
  }
  refresh() {
    if (!this.dragging) this.order = this.proc.getChainOrder();
  }
  chip(slot) {
    const b = { x: 0, y: 26, w: this.w, h: this.h - 26 };
    const gap = 10, w = (b.w - gap * 7) / 8;
    return { x: b.x + slot * (w + gap), y: b.y, w, h: b.h };
  }
  shuffleArea() {
    return { x: this.w - 64, y: -1, w: 64, h: 20 };
  }
  slotAt(x) {
    let best = 0;
    for (let s = 1; s < 8; ++s) if (Math.abs(centre(this.chip(s)).x - x) < Math.abs(centre(this.chip(best)).x - x)) best = s;
    return best;
  }
  shown() {
    if (!this.dragging || this.dragSlot < 0 || this.dropSlot < 0) return this.order;
    const v = this.order.slice();
    const [moving] = v.splice(this.dragSlot, 1);
    v.splice(this.dropSlot, 0, moving);
    return v;
  }
  paint(ctx) {
    const proc2 = this.proc;
    const top = { x: 2, y: 0, w: this.w - 2, h: 18 };
    drawTextIn(ctx, "Signal chain", top, sans(11.5, "semibold"), colours.text, "left");
    drawTextIn(ctx, "In to out  \xB7  drag to reorder  \xB7  right-click switches on or off", { ...top, w: top.w - 76 }, sans(10.5), colours.textFaint, "right");
    const sh = this.shuffleArea();
    fillRoundRect(ctx, sh.x, sh.y, sh.w, sh.h, sh.h * 0.5, white(this.hoverShuffle ? 0.14 : 0.07));
    drawTextIn(ctx, "Shuffle", sh, sans(11, "medium"), this.hoverShuffle ? colours.text : colours.textDim, "centre");
    const drawChip = (r, m, number, lifted) => {
      const on = proc2.isModuleOn(m);
      fillRoundRect(ctx, r.x, r.y, r.w, r.h, 9, white(lifted ? 0.16 : on ? 0.08 : 0.035));
      if (on) fillEllipse(ctx, r.x + r.w - 12, r.y + 7, 5, 5, MODULE_COLOURS[m]);
      drawTrackedIn(ctx, TITLES[m], { x: r.x, y: r.y + 6, w: r.w, h: r.h - 6 }, sans(10, "semibold"), on ? colours.text : colours.textFaint, 0.08, "centre");
      if (number > 0) {
        ctx.font = sans(9.5, "medium");
        ctx.fillStyle = colours.textFaint;
        ctx.textAlign = "left";
        ctx.textBaseline = "top";
        ctx.fillText(String(number), r.x + 8, r.y + 5 + 1);
      }
    };
    const o = this.shown();
    for (let s = 0; s < 8; ++s) {
      const r = this.chip(s);
      if (s < 7) {
        const x = r.x + r.w + 5, y = r.y + r.h / 2;
        ctx.beginPath();
        ctx.moveTo(x - 1.5, y - 3);
        ctx.lineTo(x + 1.5, y);
        ctx.lineTo(x - 1.5, y + 3);
        ctx.strokeStyle = withAlpha2(colours.textFaint, 0.6);
        ctx.lineWidth = 1.1;
        ctx.stroke();
      }
      if (this.dragging && s === this.dropSlot) {
        strokeRoundRect(ctx, r.x + 0.5, r.y + 0.5, r.w - 1, r.h - 1, 9, white(0.05), 1);
        continue;
      }
      drawChip(r, o[s], s + 1, false);
    }
    if (this.dragging && this.dragSlot >= 0) {
      const c0 = this.chip(0);
      drawChip({ ...c0, x: this.dragX - this.grab, y: c0.y - 3 }, this.order[this.dragSlot], 0, true);
    }
  }
  mouseDown(e) {
    this.dragging = false;
    this.dragSlot = -1;
    if (contains(this.shuffleArea(), e.x, e.y)) {
      const o = this.proc.getChainOrder();
      for (let k = 7; k > 0; --k) {
        const j = Math.floor(Math.random() * (k + 1));
        [o[k], o[j]] = [o[j], o[k]];
      }
      this.proc.setChainOrder(o);
      this.order = o;
      return;
    }
    for (let s = 0; s < 8; ++s) {
      const c = this.chip(s);
      if (!contains(c, e.x, e.y)) continue;
      const m = this.order[s];
      if (e.mods.right) {
        toggleParam(this.proc.param(m, 0));
        return;
      }
      this.dragSlot = s;
      this.grab = e.x - c.x;
      this.dragX = e.x;
    }
  }
  mouseDrag(e) {
    if (this.dragSlot < 0) return;
    if (!this.dragging && Math.hypot(e.dx, e.dy) > 5) this.dragging = true;
    if (this.dragging) {
      this.dragX = e.x;
      this.dropSlot = this.slotAt(this.dragX - this.grab + this.chip(0).w * 0.5);
    }
  }
  mouseUp() {
    if (this.dragSlot >= 0) {
      if (this.dragging) {
        const o = this.shown();
        this.dragging = false;
        this.order = o;
        this.proc.setChainOrder(o);
      } else this.onSelect?.(this.order[this.dragSlot]);
    }
    this.dragging = false;
    this.dragSlot = this.dropSlot = -1;
  }
  mouseMove(e) {
    this.hoverShuffle = contains(this.shuffleArea(), e.x, e.y);
    this.cursor = this.hoverShuffle ? "pointer" : "grab";
    this.showInfo(this.hoverShuffle ? "Shuffle: put the effects in a random order." : "Signal chain: audio flows left to right. Drag a module to move it, click to open it, right-click to switch it on or off.");
  }
  mouseExit() {
    this.hoverShuffle = false;
    this.showInfo("");
  }
};
var lastPage = new Array(8).fill(0);
var Screen = class extends Component {
  constructor(proc2, presets) {
    super();
    this.proc = proc2;
    this.presets = presets;
    this.module = 0;
    this.page = 0;
    this.cellPage = 0;
    this.lfoMode = false;
    this.chainMode = false;
    this.starDrag = false;
    this.drawerOpen = false;
    this.onModuleChosen = null;
    this.visuals = [];
    for (let m = 0; m < 8; ++m) {
      const v = createVisual(proc2, m);
      v.setVisible(false);
      this.addChild(v);
      this.visuals.push(v);
    }
    this.xy = this.addAndMakeVisible(new XYOverlay(proc2));
    this.drawer = this.addChild(new Drawer());
    this.drawer.setVisible(false);
    this.moreButton = this.drawer.addChild(new ScreenButton("More", "More parameters for this module."));
    this.moreButton.setVisible(false);
    this.chain = this.drawer.addChild(new ChainStrip(proc2));
    this.chain.setVisible(false);
    this.chain.onSelect = (m) => this.onModuleChosen?.(m);
    this.moreButton.onClick = () => {
      ++this.cellPage;
      this.rebuildCells();
    };
    this.mixCell = null;
    this.cells = [];
    this.cellLayoutKey = [];
    this.setModule(0);
  }
  pageDef() {
    const pages = MODULE_DEFS[this.module].pages;
    return pages[Math.max(0, Math.min(pages.length - 1, this.page))];
  }
  setModule(m) {
    lastPage[this.module] = this.page;
    this.module = m;
    this.page = lastPage[m];
    const pages = MODULE_DEFS[m].pages;
    const pageOn = (p) => pages[p].enableParam < 0 || this.proc.paramValue(m, pages[p].enableParam) > 0.5;
    this.page = Math.max(0, Math.min(pages.length - 1, this.page));
    if (!pageOn(this.page)) {
      for (let p = 0; p < pages.length; ++p) if (pageOn(p)) {
        this.page = p;
        break;
      }
    }
    this.cellPage = 0;
    this.visuals.forEach((v, i) => {
      v.setVisible(i === m);
      v.setPage(i === m ? this.page : 0);
    });
    this.xy.setModule(m, this.pageDef());
    this.xy.setRecordArmed(false);
    this.proc.setFocus?.(m);
    this.rebuildCells();
    this.resized();
  }
  getModule() {
    return this.module;
  }
  setChainMode(on) {
    this.chainMode = on;
    this.chain.setVisible(on);
    if (on) this.setDrawerOpen(true);
    this.rebuildCells();
  }
  isChainMode() {
    return this.chainMode;
  }
  setLfoMode(on) {
    this.lfoMode = on;
    this.cellPage = 0;
    if (on) this.setDrawerOpen(true);
    this.rebuildCells();
  }
  isLfoMode() {
    return this.lfoMode;
  }
  setDrawerOpen(open2) {
    if (!open2 && this.chainMode) {
      this.chainMode = false;
      this.chain.setVisible(false);
      this.rebuildCells();
    }
    this.drawerOpen = open2;
    this.drawer.setVisible(open2);
    this.layoutCells();
  }
  isDrawerOpen() {
    return this.drawerOpen;
  }
  setStarDrag(active) {
    this.starDrag = active;
    this.rebuildCells();
  }
  // the XY motion recorder (its buttons are printed on the device below the screen)
  hasMotion() {
    return this.xy.hasAxes();
  }
  toggleMotion() {
    const ms = this.proc.motion(this.module);
    if (ms.playing) {
      ms.playing = false;
      this.proc.pushMotion(this.module);
      return;
    }
    if (ms.hasPath && ms.xParam === this.pageDef().xParam) {
      ms.playing = true;
      this.proc.pushMotion(this.module);
    } else this.xy.generateMotion();
  }
  cycleMotionSpeed() {
    const ms = this.proc.motion(this.module);
    ms.speed = (ms.speed + 1) % 3;
    this.proc.pushMotion(this.module);
  }
  toggleRecord() {
    this.xy.setRecordArmed(!this.xy.isRecordArmed());
  }
  isMotionPlaying() {
    return this.proc.motion(this.module).playing;
  }
  motionSpeed() {
    return this.proc.motion(this.module).speed;
  }
  isRecordArmed() {
    return this.xy.isRecordArmed();
  }
  visibleFxParams() {
    const def = MODULE_DEFS[this.module], pd = this.pageDef();
    const out2 = [];
    for (let i = 1; i < def.params.length; ++i) {
      const p = def.params[i];
      if (!p.cell || i === pd.mixParam || i === pd.enableParam) continue;
      if (p.group !== 0 && p.group !== pd.group) continue;
      if (p.showIf >= 0 && Math.abs(this.proc.paramValue(this.module, p.showIf) - p.showIfValue) > 0.5) continue;
      out2.push(i);
    }
    return out2;
  }
  rebuildCells() {
    for (const c of this.cells) this.drawer.removeChild(c);
    this.cells = [];
    this.moreButton.setVisible(false);
    this.cellLayoutKey = [];
    const pd = this.pageDef();
    if (this.mixCell) this.removeChild(this.mixCell);
    this.mixCell = null;
    if (pd.mixParam >= 0) {
      this.mixCell = new ParamCell(this.proc, this.module, pd.mixParam, -1);
      this.mixCell.setFrameless(true);
      this.addAndMakeVisible(this.mixCell);
    }
    const showLfo = this.lfoMode && !this.starDrag;
    this.cellLayoutKey.push(this.chainMode ? 2 : showLfo ? 1 : 0, this.cellPage);
    if (this.chainMode) {
      this.layoutCells();
      return;
    }
    const m = this.module, proc2 = this.proc;
    if (showLfo) {
      const sync = proc2.lfoParam(m, lfoIdx.sync).getValue() > 0.5;
      this.cellLayoutKey.push(sync ? 1 : 0);
      this.cells.push(
        new ModLaneCell(proc2, m, 0),
        new ModLaneCell(proc2, m, 1),
        new ParamCell(proc2, m, -1, sync ? lfoIdx.div : lfoIdx.rate),
        new ParamCell(proc2, m, -1, lfoIdx.sync),
        new ShapeCell(proc2, m)
      );
      for (const k of [lfoIdx.warp, lfoIdx.asym, lfoIdx.slew, lfoIdx.polarity]) this.cells.push(new ParamCell(proc2, m, -1, k));
    } else {
      const params = this.visibleFxParams();
      this.cellLayoutKey.push(...params);
      const paged = params.length > 8;
      const perPage = paged ? 7 : 8;
      const pages = Math.ceil(params.length / perPage);
      this.cellPage = pages > 0 ? this.cellPage % pages : 0;
      for (let k = this.cellPage * perPage; k < Math.min(params.length, (this.cellPage + 1) * perPage); ++k)
        this.cells.push(new ParamCell(proc2, m, params[k], -1));
      if (paged) {
        this.moreButton.setVisible(true);
        this.moreButton.setText(`${this.cellPage + 1}/${pages}  \u203A`);
      }
    }
    for (const c of this.cells) this.drawer.addAndMakeVisible(c);
    this.layoutCells();
  }
  visualArea() {
    return { x: 6, y: 54, w: this.w - 12, h: this.h - 54 - 6 };
  }
  drawerArea() {
    return { x: 10, y: this.h - 10 - Drawer.height, w: this.w - 20, h: Drawer.height };
  }
  layoutCells() {
    const d = this.drawerArea();
    this.drawer.setBounds(d.x, d.y, d.w, d.h);
    const area = { x: Drawer.pad, y: Drawer.pad, w: d.w - 2 * Drawer.pad, h: d.h - 2 * Drawer.pad };
    const showLfo = this.lfoMode && !this.starDrag;
    const cols = showLfo ? 5 : 4;
    const gap = Drawer.gap;
    const w = Math.floor((area.w - gap * (cols - 1)) / cols), h = Drawer.cellHeight;
    this.cells.forEach((c, i) => c.setBounds(area.x + i % cols * (w + gap), area.y + Math.floor(i / cols) * (h + gap), w, h));
    if (this.moreButton.isVisible()) this.moreButton.setBounds(area.x + 7 % cols * (w + gap), area.y + Math.floor(7 / cols) * (h + gap), w, h);
    this.chain.setBounds(14, 10, d.w - 28, d.h - 20);
    this.mixCell?.setBounds(this.w - 141, 15, 130, 26);
  }
  resized() {
    const v = this.visualArea();
    for (const vis of this.visuals) vis.setBounds(v.x, v.y, v.w, v.h);
    this.xy.setBounds(v.x, v.y, v.w, v.h);
    this.layoutCells();
  }
  tick() {
    if (!this.chainMode && !(this.lfoMode && !this.starDrag)) {
      const key2 = [0, this.cellPage, ...this.visibleFxParams()];
      if (key2.length !== this.cellLayoutKey.length || key2.some((k, i) => k !== this.cellLayoutKey[i])) {
        this.rebuildCells();
        this.xy.setModule(this.module, this.pageDef());
      }
    } else if (this.lfoMode && !this.starDrag && !this.chainMode) {
      const sync = this.proc.lfoParam(this.module, lfoIdx.sync).getValue() > 0.5 ? 1 : 0;
      if (this.cellLayoutKey.length < 3 || this.cellLayoutKey[2] !== sync) this.rebuildCells();
    }
    this.visuals[this.module].tick();
    if (this.drawerOpen) for (const c of this.cells) c.refresh();
    this.mixCell?.refresh();
    if (this.chainMode) this.chain.refresh();
  }
  subPresetName() {
    const subs = this.presets.subPresets(this.module);
    const si = this.presets.currentSub(this.module);
    return si >= 0 && si < subs.length ? subs[si].name : "Presets";
  }
  header(ctx) {
    const titleFont = sans(17, "semibold"), subFont = sans(11.5);
    const h = {};
    h.title = { x: 22, y: 17, w: textWidth(ctx, titleCase(TITLES[this.module]), titleFont) + 4, h: 22 };
    let x = 22;
    const y = 41, lineH = 18;
    h.power = null;
    h.page = null;
    if (MODULE_DEFS[this.module].pages.length > 1) {
      h.power = { x, y, w: 12, h: lineH };
      x += 15;
      h.page = { x, y, w: textWidth(ctx, titleCase(this.pageDef().name), subFont) + 12, h: lineH };
      x = h.page.x + h.page.w + 18;
    }
    h.sub = { x, y, w: textWidth(ctx, this.subPresetName(), subFont) + 12, h: lineH };
    h.prev = { x: h.sub.x + h.sub.w + 6, y, w: 14, h: lineH };
    h.next = translated(h.prev, 14, 0);
    return h;
  }
  paint(ctx) {
    const h = this.header(ctx);
    drawTextIn(ctx, titleCase(TITLES[this.module]), h.title, sans(17, "semibold"), colours.text, "left");
    const subFont = sans(11.5);
    if (h.page) {
      const pd = this.pageDef();
      const on = pd.enableParam < 0 || this.proc.paramValue(this.module, pd.enableParam) > 0.5;
      const c = centre(h.power);
      if (on) {
        fillEllipse(ctx, c.x - 5.5, c.y - 5.5, 11, 11, withAlpha2(colours.text, 0.25));
        fillEllipse(ctx, c.x - 3, c.y - 3, 6, 6, colours.text);
      } else {
        ctx.beginPath();
        ctx.arc(c.x, c.y, 3, 0, Math.PI * 2);
        ctx.strokeStyle = colours.textFaint;
        ctx.lineWidth = 1.2;
        ctx.stroke();
      }
      drawTextIn(ctx, titleCase(pd.name), h.page, subFont, on ? colours.textDim : colours.textFaint, "left");
      smallChevron(ctx, { x: h.page.x + h.page.w - 4, y: h.page.y + h.page.h / 2 + 0.5 }, colours.textFaint);
      drawTextIn(ctx, "\xB7", { x: h.page.x + h.page.w, y: h.page.y, w: 18, h: h.page.h }, subFont, colours.textFaint, "centre");
    }
    drawTextIn(ctx, this.subPresetName(), h.sub, subFont, colours.textDim, "left");
    smallChevron(ctx, { x: h.sub.x + h.sub.w - 4, y: h.sub.y + h.sub.h / 2 + 0.5 }, colours.textFaint);
    drawTextIn(ctx, "\u2039", h.prev, sans(13), colours.textFaint, "centre");
    drawTextIn(ctx, "\u203A", h.next, sans(13), colours.textFaint, "centre");
  }
  paintOverChildren(ctx) {
    drawGlassSheen(ctx, 0, 0, this.w, this.h, displayRadius, 0.6);
  }
  anchor(r) {
    return screenRect(this.root(), localToDevice(this, r));
  }
  async showSubPresetMenu() {
    const subs = this.presets.subPresets(this.module);
    const items = [
      { header: `${titleCase(TITLES[this.module])} presets` },
      ...subs.map((s, i) => ({ id: i + 1, text: s.name, checked: this.presets.currentSub(this.module) === i }))
    ];
    const r = await showMenu(items, this.anchor(this.header(this.root().ctx).sub), this.root().scale);
    if (r > 0) this.presets.loadSub(this.module, r - 1);
  }
  async showPageMenu() {
    const pages = MODULE_DEFS[this.module].pages;
    if (pages.length < 2) return;
    const items = pages.map((p, i) => {
      const on = p.enableParam < 0 || this.proc.paramValue(this.module, p.enableParam) > 0.5;
      return { id: i + 1, text: titleCase(p.name) + (on ? "" : "  (off)"), checked: this.page === i };
    });
    const r = await showMenu(items, this.anchor(this.header(this.root().ctx).page), this.root().scale);
    if (r <= 0) return;
    this.page = r - 1;
    this.visuals[this.module].setPage(this.page);
    this.xy.setModule(this.module, this.pageDef());
    this.cellPage = 0;
    this.rebuildCells();
    this.resized();
  }
  mouseUp(e) {
    const h = this.header(this.root().ctx);
    const subs = this.presets.subPresets(this.module);
    const cur = this.presets.currentSub(this.module);
    const at = (r, grow = 0) => r && contains(expanded(r, grow), e.x, e.y);
    if (at(h.prev, 2)) this.presets.loadSub(this.module, cur < 0 ? subs.length - 1 : cur - 1);
    else if (at(h.next, 2)) this.presets.loadSub(this.module, cur + 1);
    else if (at(h.sub)) this.showSubPresetMenu();
    else if (h.power && at(h.power, 3) && this.pageDef().enableParam >= 0) toggleParam(this.proc.param(this.module, this.pageDef().enableParam));
    else if (h.page && (at(h.page) || at(h.title))) this.showPageMenu();
  }
  mouseMove(e) {
    const h = this.header(this.root().ctx);
    const at = (r, grow = 0) => r && contains(expanded(r, grow), e.x, e.y);
    let text = "";
    if (at(h.sub) || at(h.prev) || at(h.next)) text = "Module presets: click the name for the list, or step through them with the arrows.";
    else if (h.power && at(h.power, 3)) text = "Switch this effect on or off inside the module.";
    else if (h.page && (at(h.page) || at(h.title))) text = "This module holds two effects. Click to switch between them; both can run at once (light = on).";
    this.cursor = text ? "pointer" : null;
    this.showInfo(text);
  }
  mouseExit() {
    this.showInfo("");
  }
};

// xray-demo-stage/src/app/editor.js
var infoArea = { x: 24, y: 613, w: 240, h: 54 };
var Editor = class extends Root {
  constructor(canvas2, proc2) {
    super(canvas2, width, height);
    this.proc = proc2;
    this.presets = new PresetManager(proc2);
    const ctx = this.ctx;
    this.scope = new Scope(proc2);
    this.keys = new ModuleKeys(proc2);
    this.screen = new Screen(proc2, this.presets);
    this.presetBar = new PresetBar(proc2, this.presets);
    this.mixKnob = new GlobalKnob(proc2, "mix", "Mix", "Global mix: the whole plug-in against your dry signal, for parallel processing.", false, true);
    this.inputKnob = new GlobalKnob(proc2, "in_gain", "Input", "Input gain: the level going into every module.", true, false);
    this.filterKnob = new GlobalKnob(proc2, "filter", "Filter", "Global filter: turn left for low-pass, right for high-pass. The centre is off.", true, false);
    this.widthKnob = new GlobalKnob(proc2, "width", "Width", "Global stereo width: 0% is mono, 100% as is, 200% extra wide.", false, false);
    this.meter = new OutputMeter(proc2);
    this.pitchField = new ValueField(proc2, "pitch", "Pitch", "Global pitch: shifts everything from -12 to +12 semitones before the effects.");
    this.lockField = new ValueField(proc2, "pitch_lock", "Lock", "Pitch lock: loading presets keeps the current global pitch.");
    this.pitchMixField = new ValueField(proc2, "pitch_mix", "Mix", "Pitch mix: the blend of the pitch-shifted and the original signal.");
    this.gainField = new ValueField(proc2, "out_gain", "Gain", "Output gain (you can also drag the output meter).");
    this.glueField = new ValueField(proc2, "glue", "Glue", "Master glue: gentle bus compression to tighten the final sound.");
    this.pageSwitch = new Segmented(["FX", "LFO", "Chain"], "The drawer shows the module's effect parameters, its LFO, or the signal chain (the order of the effects).");
    this.motionButton = new PillButton("Motion", "Motion: play back the recorded XY movement in time with the song (or generate one if nothing is recorded).");
    this.speedButton = new PillButton("1\xD7", "Motion playback speed: half, normal or double.");
    this.recButton = new PillButton("Rec", "Record: arm it, then drag the XY dot. The movement loops in time with the song.");
    this.drawerButton = new PillButton("Parameters", "Show or hide this module's parameters.", "filled");
    this.demoButton = new PillButton("Demo", "Plays a built-in groove instead of your sample, so you can explore straight away.");
    for (const c of [
      this.scope,
      this.keys,
      this.screen,
      this.presetBar,
      this.mixKnob,
      this.inputKnob,
      this.filterKnob,
      this.widthKnob,
      this.meter,
      this.pitchField,
      this.lockField,
      this.pitchMixField,
      this.gainField,
      this.glueField,
      this.pageSwitch,
      this.motionButton,
      this.speedButton,
      this.recButton,
      this.drawerButton,
      this.demoButton
    ])
      this.addAndMakeVisible(c);
    const set = (c, r) => c.setBounds(Math.round(r.x), Math.round(r.y), Math.round(r.w), Math.round(r.h));
    set(this.scope, scopeGlass);
    set(this.keys, ModuleKeys.boundsOnDevice());
    set(this.screen, displayGlass);
    set(this.presetBar, PresetBar.boundsOnDevice());
    this.mixKnob.placeAt(dial);
    this.inputKnob.placeAt(smallKnobs[0]);
    this.filterKnob.placeAt(smallKnobs[1]);
    this.widthKnob.placeAt(smallKnobs[2]);
    set(this.meter, OutputMeter.boundsOnDevice());
    this.drawerButton.setIcon("chevronUp");
    set(this.drawerButton, drawerButton);
    this.demoButton.setIcon("play");
    set(this.demoButton, demoButton);
    const rowTop = Math.round(rowY) - 14;
    const displayX = Math.round(display.x);
    this.pageSwitch.setBounds(displayX, rowTop, 168, 28);
    let x = displayX + 188;
    for (const b of [this.motionButton, this.speedButton, this.recButton]) {
      const w = Math.round(b === this.speedButton ? 34 : b.preferredWidth(ctx));
      b.setBounds(x, rowTop, w, 28);
      x += w + 8;
    }
    let gx = Math.round(right);
    for (const [field, w] of [[this.glueField, 80], [this.gainField, 96], [this.pitchMixField, 76], [this.lockField, 42], [this.pitchField, 80]]) {
      gx -= w;
      field.setBounds(gx, rowTop, w, 28);
      gx -= 4;
    }
    this.keys.onSelect = (m) => this.selectModule(m);
    this.screen.onModuleChosen = (m) => this.selectModule(m);
    this.presetBar.currentModule = () => this.screen.getModule();
    this.presetBar.onPresetLoaded = () => this.selectModule(proc2.suggestedFocus());
    this.pageSwitch.onChange = (i) => {
      if (i === 2) return this.showChain(true);
      if (this.screen.isChainMode()) this.screen.setChainMode(false);
      this.showLfoPage(i === 1);
    };
    this.motionButton.onClick = () => {
      this.screen.toggleMotion();
      this.syncControls();
    };
    this.speedButton.onClick = () => {
      this.screen.cycleMotionSpeed();
      this.syncControls();
    };
    this.recButton.onClick = () => {
      this.screen.toggleRecord();
      this.syncControls();
    };
    this.drawerButton.onClick = () => this.showDrawer(!this.screen.isDrawerOpen());
    this.demoButton.onClick = () => {
      this.onDemoToggle ? this.onDemoToggle(!proc2.isDemoEnabled()) : proc2.setDemoEnabled(!proc2.isDemoEnabled());
      this.syncControls();
    };
    this.onDemoToggle = null;
    this.onDragStarted = () => this.screen.setStarDrag(true);
    this.onDragEnded = () => this.screen.setStarDrag(false);
    this.selectModule(proc2.suggestedFocus());
    this.syncControls();
  }
  selectModule(m) {
    this.proc.focusModule = m;
    this.screen.setModule(m);
    this.keys.setSelected(m);
    this.syncControls();
  }
  showLfoPage(on) {
    this.screen.setLfoMode(on);
    this.syncControls();
  }
  showChain(on) {
    this.screen.setChainMode(on);
    this.syncControls();
  }
  showDrawer(open2) {
    this.screen.setDrawerOpen(open2);
    this.syncControls();
  }
  syncControls() {
    const s = this.screen;
    const axes = s.hasMotion();
    for (const b of [this.motionButton, this.speedButton, this.recButton]) b.setDimmed(!axes);
    this.motionButton.setLit(axes && s.isMotionPlaying());
    const sp = s.motionSpeed();
    this.speedButton.setText(sp === 0 ? "\xBD\xD7" : sp === 2 ? "2\xD7" : "1\xD7");
    this.recButton.setAlarm(axes && s.isRecordArmed());
    this.pageSwitch.setSelected(s.isChainMode() ? 2 : s.isLfoMode() ? 1 : 0);
    this.drawerButton.setLit(s.isDrawerOpen());
    this.drawerButton.setIcon(s.isDrawerOpen() ? "chevronDown" : "chevronUp");
    this.demoButton.setLit(this.proc.isDemoEnabled());
  }
  // one frame: read the meters and the analysis, then draw
  tick() {
    this.scope.refresh();
    this.screen.tick();
    this.meter.refresh();
    this.syncControls();
    this.draw();
    this.proc.flush();
  }
  paint(ctx) {
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(plateImage(), 0, 0, width, height);
    const logo = logoImage();
    const lw = logo.naturalWidth * 0.5, lh = logo.naturalHeight * 0.5;
    const cy = barY;
    ctx.drawImage(logo, logoX, cy - lh * 0.5, lw, lh);
    const after = logoX + lw + 12;
    ctx.fillStyle = ink.hair;
    ctx.fillRect(after, cy - 7, 1, 14);
    drawTrackedIn(ctx, "XRAY", { x: after + 12, y: cy - 8, w: 80, h: 16 }, sans(12.5, "semibold"), ink.primary, 0.32, "left");
    ctx.fillStyle = ink.hair;
    ctx.fillRect(margin, dividerY - 0.5, right - margin, 1);
    const icx = infoArea.x + 10, icy = rowY;
    ctx.beginPath();
    ctx.arc(icx, icy, 5.5, 0, Math.PI * 2);
    ctx.strokeStyle = ink.tertiary;
    ctx.lineWidth = 1;
    ctx.stroke();
    drawTextIn(ctx, "i", { x: icx - 6, y: icy - 6, w: 12, h: 12 }, sans(8.5, "semibold"), ink.tertiary, "centre");
    const empty = !this.infoText;
    drawWrapped(
      ctx,
      empty ? "Hover a control to see what it does" : this.infoText,
      { x: infoArea.x + 24, y: infoArea.y, w: infoArea.w - 24, h: infoArea.h },
      sans(10.5),
      empty ? ink.tertiary : ink.secondary,
      3
    );
  }
};
function drawWrapped(ctx, s, r, font, colour2, maxLines) {
  ctx.font = font;
  const words = s.split(/\s+/);
  const lines = [];
  let line = "";
  for (const w of words) {
    const t = line ? `${line} ${w}` : w;
    if (ctx.measureText(t).width <= r.w || !line) line = t;
    else {
      lines.push(line);
      line = w;
    }
  }
  if (line) lines.push(line);
  if (lines.length > maxLines) {
    lines.length = maxLines;
    let last = lines[maxLines - 1];
    while (last.length > 1 && ctx.measureText(`${last}\u2026`).width > r.w) last = last.slice(0, -1);
    lines[maxLines - 1] = `${last.trimEnd()}\u2026`;
  }
  const lh = parseFloat(font.split(" ")[1]) * 1.22;
  const top = r.y + r.h / 2 - lines.length * lh / 2;
  ctx.fillStyle = colour2;
  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  lines.forEach((l, i) => ctx.fillText(l, r.x, top + lh * (i + 0.5)));
}

// xray-demo-stage/src/app/main.js
var $ = (s) => document.querySelector(s.replace(/^#/, "#xr-"));
var canvas = $("#device");
var proc = new Proc();
var actx = null;
var node = null;
var out = null;
var audioReady = null;
function initAudio() {
  if (audioReady) return audioReady;
  audioReady = (async () => {
    const AC = window.AudioContext || window.webkitAudioContext;
    actx = new AC({ latencyHint: "interactive" });
    const url = window.XRDEMO && window.XRDEMO.assets && window.XRDEMO.assets["worklet"] ? new URL(window.XRDEMO.assets["worklet"], location.href) : new URL("./worklet.bundle.js", import.meta.url);
    try {
      await actx.audioWorklet.addModule(url);
    } catch {
      const code = await (await fetch(url)).text();
      await actx.audioWorklet.addModule(URL.createObjectURL(new Blob([code], { type: "text/javascript" })));
    }
    node = new AudioWorkletNode(actx, "xray", {
      numberOfInputs: 1,
      numberOfOutputs: 1,
      outputChannelCount: [2],
      channelCount: 2,
      channelCountMode: "explicit",
      channelInterpretation: "speakers"
    });
    out = actx.createGain();
    node.connect(out).connect(actx.destination);
    proc.connect(node.port);
    proc.send({ type: "bypass", on: state.bypass });
  })();
  audioReady.catch((e) => showError(e));
  return audioReady;
}
async function resumeAudio() {
  await initAudio();
  if (actx.state !== "running") await actx.resume();
}
var unlocked = false;
var silentEl = null;
function unlockAudio() {
  try {
    if (navigator.audioSession) navigator.audioSession.type = "playback";
  } catch {
  }
  if (!actx) initAudio();
  if (!actx) return;
  if (actx.state !== "running") actx.resume().catch(() => {
  });
  if (!unlocked) {
    unlocked = true;
    try {
      const src = actx.createBufferSource();
      src.buffer = actx.createBuffer(1, 1, actx.sampleRate);
      src.connect(actx.destination);
      src.start(0);
    } catch {
    }
    if (!navigator.audioSession && /iP(hone|ad|od)|Macintosh.*Mobile/.test(navigator.userAgent) && !silentEl) {
      silentEl = new Audio(window.XRDEMO && window.XRDEMO.assets && window.XRDEMO.assets["silence"] || new URL("../assets/silence.wav", import.meta.url).href);
      silentEl.loop = true;
      silentEl.setAttribute("playsinline", "");
      silentEl.play().catch(() => {
      });
    }
  }
}
for (const type of ["touchend", "pointerdown", "pointerup", "click", "keydown"])
  window.addEventListener(type, unlockAudio, { capture: true, passive: true });
var state = { samples: [], current: -1, playing: false, bypass: false, source: null, startedAt: 0, offset: 0, pending: -1, played: false };
function addCard(info) {
  const s = { name: info.name, kind: info.kind || "", bpm: info.bpm || 0, key: info.key || "", buffer: null, peaks: null, failed: false, el: null };
  state.samples.push(s);
  buildCard(state.samples.length - 1);
  return state.samples.length - 1;
}
async function decodeInto(i, arrayBuffer) {
  const s = state.samples[i];
  try {
    await initAudio();
    s.buffer = await actx.decodeAudioData(arrayBuffer);
    s.peaks = peaksOf(s.buffer, 160);
  } catch {
    s.failed = true;
    toast(`Couldn't load \u201C${s.name}\u201D.`);
  }
  updateCards();
  drawCardWave(i);
  if (state.pending === i && s.buffer) playSample(i);
}
function peaksOf(buffer, n) {
  const chans = Array.from({ length: buffer.numberOfChannels }, (_, c) => buffer.getChannelData(c));
  const len = buffer.length, out2 = new Float32Array(n);
  let max = 1e-6;
  for (let k = 0; k < n; ++k) {
    const a = Math.floor(k * len / n), b = Math.max(a + 1, Math.floor((k + 1) * len / n));
    let p = 0;
    for (const ch of chans) for (let i = a; i < b; i += 4) p = Math.max(p, Math.abs(ch[i]));
    out2[k] = p;
    max = Math.max(max, p);
  }
  for (let k = 0; k < n; ++k) out2[k] /= max;
  return out2;
}
function stopSource() {
  if (!state.source) return;
  const src = state.source, g = src._gain;
  const t = actx.currentTime;
  g.gain.setTargetAtTime(0, t, 8e-3);
  src.stop(t + 0.06);
  state.source = null;
}
async function playSample(i, offset = 0) {
  const s = state.samples[i];
  if (!s || s.failed) return;
  state.current = i;
  if (!s.buffer) {
    state.pending = i;
    updateCards();
    return;
  }
  state.pending = -1;
  await resumeAudio();
  if (proc.isDemoEnabled()) proc.setDemoEnabled(false);
  stopSource();
  const src = actx.createBufferSource();
  src.buffer = s.buffer;
  src.loop = true;
  const g = actx.createGain();
  g.gain.value = 0;
  g.gain.setTargetAtTime(1, actx.currentTime, 6e-3);
  src.connect(g).connect(node);
  src._gain = g;
  src.start(actx.currentTime, offset % s.buffer.duration);
  state.source = src;
  state.playing = true;
  state.played = true;
  state.startedAt = actx.currentTime;
  state.offset = offset % s.buffer.duration;
  if (s.bpm) setTempo(s.bpm);
  updateCards();
}
function stopAll() {
  if (actx) stopSource();
  if (proc.isDemoEnabled()) proc.setDemoEnabled(false);
  state.playing = false;
  state.pending = -1;
  updateCards();
}
async function setDemo(on) {
  if (on) {
    await resumeAudio();
    stopSource();
    state.playing = false;
    state.pending = -1;
    state.played = true;
    proc.setDemoEnabled(true);
  } else proc.setDemoEnabled(false);
  updateCards();
}
function isSounding() {
  return state.playing || proc.isDemoEnabled();
}
async function togglePlay() {
  if (isSounding()) return stopAll();
  if (state.samples.length) return playSample(Math.max(0, state.current));
  return setDemo(true);
}
function playheadFraction(i) {
  const s = state.samples[i];
  if (!s || !s.buffer || !state.playing || state.current !== i || !actx) return -1;
  const t = state.offset + (actx.currentTime - state.startedAt);
  return t % s.buffer.duration / s.buffer.duration;
}
var PLAY_SVG = '<svg viewBox="0 0 16 16" aria-hidden="true"><path class="go" d="M5 2.6v10.8c0 .5.5.8.9.5l8.3-5.4c.4-.3.4-.8 0-1L5.9 2.1c-.4-.3-.9 0-.9.5z"/><rect class="stop" x="3.5" y="3.5" width="9" height="9" rx="1.6"/></svg>';
function metaOf(s) {
  return [s.kind, s.bpm ? `${s.bpm} BPM` : ""].filter(Boolean).join(" \xB7 ");
}
function buildCard(i) {
  const s = state.samples[i];
  const b = document.createElement("button");
  b.type = "button";
  b.className = "card";
  b.innerHTML = `<span class="card-play">${PLAY_SVG}</span><span class="card-text"><span class="card-name"></span><span class="card-meta"></span></span><canvas class="card-wave" aria-hidden="true"></canvas>`;
  b.querySelector(".card-name").textContent = s.name;
  b.addEventListener("click", (e) => {
    const wave = b.querySelector(".card-wave");
    if (e.target === wave && state.playing && state.current === i && s.buffer) {
      const r = wave.getBoundingClientRect();
      return playSample(i, (e.clientX - r.left) / r.width * s.buffer.duration);
    }
    if ((state.playing || state.pending === i) && state.current === i) stopAll();
    else playSample(i);
  });
  s.el = b;
  $("#cards").appendChild(b);
  updateCards();
  drawCardWave(i);
}
function updateCards() {
  state.samples.forEach((s, i) => {
    if (!s.el) return;
    const playing = state.playing && state.current === i;
    const waiting = state.pending === i;
    s.el.classList.toggle("on", playing || waiting);
    s.el.classList.toggle("loading", !s.buffer && !s.failed);
    s.el.classList.toggle("failed", s.failed);
    s.el.setAttribute("aria-pressed", String(playing));
    s.el.setAttribute("aria-label", `${playing ? "Stop" : "Play"} ${s.name} through Xray`);
    s.el.querySelector(".card-meta").textContent = playing ? "Playing through XRAY" : waiting ? "Loading\u2026" : s.failed ? "Couldn\u2019t load" : metaOf(s) || (s.buffer ? `${s.buffer.duration.toFixed(1)} s` : "Loading\u2026");
    s.el.title = [s.name, metaOf(s), s.key].filter(Boolean).join(" \xB7 ");
    if (!playing) drawCardWave(i);
  });
  $("#deck")?.classList.toggle("fresh", !state.played);
  $("#demo-note")?.classList.toggle("show", proc.isDemoEnabled());
  document.body.classList.toggle("sounding", isSounding());
}
function drawCardWave(i) {
  const s = state.samples[i];
  const cv = s?.el?.querySelector(".card-wave");
  if (!cv) return;
  const r = cv.getBoundingClientRect();
  const dpr = Math.min(2, window.devicePixelRatio || 1);
  const w = Math.max(1, Math.round(r.width * dpr)), h = Math.max(1, Math.round(r.height * dpr));
  if (cv.width !== w || cv.height !== h) {
    cv.width = w;
    cv.height = h;
  }
  const g = cv.getContext("2d");
  g.clearRect(0, 0, w, h);
  const css3 = getComputedStyle(s.el);
  const dim = css3.getPropertyValue("--wave-dim").trim() || "rgba(0,0,0,0.18)";
  if (!s.peaks) {
    g.fillStyle = dim;
    g.fillRect(0, Math.round(h / 2), w, Math.max(1, Math.round(dpr)));
    return;
  }
  const head = playheadFraction(i);
  const p = s.peaks, n = p.length, step = w / n, bw = Math.max(1, step * 0.55);
  const grad = g.createLinearGradient(0, 0, w, 0);
  ["#3789fd", "#9362f4", "#f061ba", "#f84b4b", "#ff8c1e", "#fbd530", "#3bca60", "#00d0e2"].forEach((c, k, a) => grad.addColorStop(k / (a.length - 1), c));
  for (let k = 0; k < n; ++k) {
    const v = Math.max(0.06, p[k]) * h * 0.48;
    g.fillStyle = head >= 0 && (k + 0.5) / n <= head ? grad : dim;
    g.fillRect(k * step, h / 2 - v, bw, v * 2);
  }
}
function setTempo(bpm) {
  proc.setTempo(bpm);
  const shown = $("#bpm-value");
  if (shown) shown.textContent = String(proc.bpm);
}
function toast(text) {
  const t = $("#toast");
  if (!t) return;
  t.textContent = text;
  t.classList.add("show");
  clearTimeout(toast.timer);
  toast.timer = setTimeout(() => t.classList.remove("show"), 3600);
}
function showError(e) {
  console.error(e);
  toast("Audio could not start in this browser. Try a recent Chrome, Safari or Firefox.");
}
async function boot() {
  await loadAssets();
  const editor = new Editor(canvas, proc);
  editor.presets.load(0);
  editor.selectModule(proc.suggestedFocus());
  editor.onDemoToggle = (on) => setDemo(on);
  window.xray = { proc, editor, state, togglePlay };
  document.body.classList.add("ready");
  const wake = () => {
    resumeAudio();
  };
  window.addEventListener("pointerdown", wake, { capture: true });
  window.addEventListener("keydown", wake, { capture: true });
  initAudio();
  let shown = "", lastTick = -1e9;
  const frame = (now) => {
    requestAnimationFrame(frame);
    if (now - lastTick < 12) return;
    lastTick = now;
    editor.tick();
    if (state.playing) drawCardWave(state.current);
    const key2 = `${proc.isDemoEnabled()}|${state.current}|${state.playing}|${state.pending}`;
    if (key2 !== shown) {
      shown = key2;
      updateCards();
    }
  };
  requestAnimationFrame(frame);
  window.addEventListener("resize", () => state.samples.forEach((_, i) => drawCardWave(i)));
  $("#bypass")?.addEventListener("click", () => {
    state.bypass = !state.bypass;
    $("#bypass").classList.toggle("on", state.bypass);
    $("#bypass").setAttribute("aria-pressed", String(state.bypass));
    proc.send({ type: "bypass", on: state.bypass });
  });
  const bpm = $("#bpm") || document.createElement("div");
  let dragFrom = null;
  bpm.addEventListener("pointerdown", (e) => {
    dragFrom = { y: e.clientY, v: proc.bpm };
    bpm.setPointerCapture(e.pointerId);
  });
  bpm.addEventListener("pointermove", (e) => {
    if (dragFrom) setTempo(dragFrom.v + Math.round((dragFrom.y - e.clientY) / 4));
  });
  bpm.addEventListener("pointerup", () => {
    dragFrom = null;
  });
  bpm.addEventListener("dblclick", () => setTempo(120));
  bpm.addEventListener("keydown", (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowRight") {
      setTempo(proc.bpm + (e.shiftKey ? 10 : 1));
      e.preventDefault();
    }
    if (e.key === "ArrowDown" || e.key === "ArrowLeft") {
      setTempo(proc.bpm - (e.shiftKey ? 10 : 1));
      e.preventDefault();
    }
  });
  bpm.addEventListener("wheel", (e) => {
    e.preventDefault();
    setTempo(proc.bpm + (e.deltaY < 0 ? 1 : -1));
  }, { passive: false });
  setTempo(120);
  window.addEventListener("keydown", (e) => {
    if (e.code === "Space" && !/input|textarea|button/i.test(document.activeElement?.tagName || "")) {
      e.preventDefault();
      togglePlay();
    }
  });
  for (const type of ["dragover", "drop"]) window.addEventListener(type, (e) => e.preventDefault());
  try {
    const list = window.XRDEMO && window.XRDEMO.samples || await (await fetch(new URL("../samples/index.json", import.meta.url))).json();
    if (list) {
      const cards = list.map((item) => [item, addCard(item)]);
      if (cards.length) {
        state.current = 0;
        if (state.samples[0].bpm) setTempo(state.samples[0].bpm);
      }
      updateCards();
      for (const [item, i] of cards) {
        try {
          const r = await fetch(item.url || new URL(`../samples/${item.file}`, import.meta.url));
          if (!r.ok) throw new Error(String(r.status));
          await decodeInto(i, await r.arrayBuffer());
        } catch {
          state.samples[i].failed = true;
          updateCards();
        }
      }
    }
  } catch {
  }
  updateCards();
}
boot().catch((e) => {
  console.error(e);
  document.body.classList.add("failed");
});

// ---------------------------------------------------------------- theme build: the light round the device follows the output level (from the dev's landing.js)
(() => {
  const stage = document.getElementById('xr-stage');
  if (!stage || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let level = 0, shown = -1;
  function glow() {
    const g = window.xray && window.xray.proc && window.xray.proc.analysis && window.xray.proc.analysis.global;
    const peak = g ? Math.max(g.outPeakL || 0, g.outPeakR || 0) : 0;
    const target = Math.min(1, Math.sqrt(peak) * 1.2);
    level += (target > level ? 0.18 : 0.035) * (target - level);
    if (Math.abs(level - shown) > 0.004) { shown = level; stage.style.setProperty('--level', level.toFixed(3)); }
    requestAnimationFrame(glow);
  }
  requestAnimationFrame(glow);
})();

// ---------------------------------------------------------------- theme build (user 2026-10-20): on desktop the device is sized so the top CTA, the device and
// the four sound cards all fit the first screen (port of the dev's landing.js fit()); phones keep the full width
(() => {
  const RATIO = 1140 / 680, MIN_W = 480;
  const root = document.getElementById('xrdemo');
  if (!root) return;
  function fit() {
    const vw = window.innerWidth, vh = window.innerHeight;
    if (vw <= 760) { root.style.removeProperty('--dev-w'); root.style.removeProperty('--deck-w'); return; }
    const band = document.getElementById('xr-band'), deck = document.getElementById('xr-deck');
    if (!band || !deck) return;
    const px = (el, prop) => parseFloat(getComputedStyle(el)[prop]) || 0;
    const bandTop = band.getBoundingClientRect().top + window.scrollY;   // where the device starts on the unscrolled page
    const below = deck.getBoundingClientRect().height + px(deck, 'marginTop') + 28;
    const availH = vh - bandTop - below;
    const maxW = root.getBoundingClientRect().width || vw;
    const w = Math.max(MIN_W, Math.min(maxW, 1040, availH * RATIO));
    root.style.setProperty('--dev-w', Math.floor(w) + 'px');
    root.style.setProperty('--deck-w', Math.floor(Math.max(w, Math.min(760, maxW))) + 'px');
  }
  let queued = false;
  const queue = () => { if (!queued) { queued = true; setTimeout(() => { queued = false; fit(); }, 0); } };
  window.addEventListener('resize', queue); window.addEventListener('load', queue);
  for (const ms of [300, 1000, 2500]) setTimeout(queue, ms);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);
  if (window.ResizeObserver) new ResizeObserver(queue).observe(document.getElementById('xr-deck'));
  fit();
})();
